"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AudRoamCtrl = void 0;
var angular_1 = __importDefault(require("angular"));
var actions2_1 = require("../js/data/actions2");
var assetInfo_1 = require("../js/data/assetInfo");
var bikeActions_1 = require("../js/data/bikeActions");
var defaultActions1_1 = require("../js/data/defaultActions1");
var reuseActions_1 = require("../js/data/reuseActions");
var iframeUtil = __importStar(require("../js/utils/iframe"));
var timelineUtils_1 = require("./timelineUtils");
var tallyState = __importStar(require("@services/tallyStateManager"));
var recentViewDigest_1 = require("@services/recentViewDigest");
var authInterceptor_1 = require("./services/authInterceptor");
var resultRowDraftService_1 = require("./services/resultRowDraftService");
var syncConflictUtils_1 = require("./services/syncConflictUtils");
var rowSplitScopeActions_1 = require("./services/rowSplitScopeActions");
var rowApplyScopeActions_1 = require("./services/rowApplyScopeActions");
var rowPromoteScopeActions_1 = require("./services/rowPromoteScopeActions");
var threadScopeActions_1 = require("./services/threadScopeActions");
var localRowPatch_1 = require("./services/localRowPatch");
var outlineMapPrefs_1 = require("./services/outlineMapPrefs");
var outlineDisplayCaption_1 = require("./services/outlineDisplayCaption");
var focusTimeHelpers_1 = require("./services/focusTimeHelpers");
var editBodyCryptoActions_1 = require("./services/editBodyCryptoActions");
var scheduleTopActions_1 = require("./services/scheduleTopActions");
function AudRoamCtrl($scope, $rootScope, $window, $http, $interval, $timeout, $q, personService, person16Service, listService, splitService, config, moment, searchService, scheduleService, tallyService, timeCalculationService, encryptionService, historyService, pushSubscriptionService, pwaService, resultRowDraftService, offlineDataService, pilotNotesSyncService, threadsApiService, appEventsService) {
    var _this = this;
    var _a, _b;
    // Capture controller instance for controllerAs syntax.
    // @ts-ignore - 'this' is set by AngularJS
    var vm = this;
    var clearLocationTimeoutID;
    var updateProgressTimeout1ID;
    var updateProgressTimeout2ID;
    /** Clear degraded-cache banner after a live Recent success. */
    function clearOfflineDataBanner() {
        $scope.viewMode.offlineDataActive = false;
        $scope.viewMode.offlineDataMessage = null;
        $scope.viewMode.serverUnreachable = false;
    }
    /** Recent list + local cache paint only when board Recent is enabled (not search/view/report). */
    function isRecentUiEnabled() {
        try {
            return !!($scope.viewMode &&
                $scope.viewMode.recentFetchEnabled !== false);
        }
        catch (_a) {
            return false;
        }
    }
    /**
     * Apply IndexedDB Recent snapshot to scope.
     * @param degraded when true, show the yellow banner (server failed).
     *   Boot paint must pass false — otherwise the banner sticks after a successful refresh.
     */
    function applyRecentLocalSnapshot(snapshot, opts) {
        var _a, _b, _c;
        if (!snapshot) {
            return false;
        }
        var boardRecent = isRecentUiEnabled();
        var hasRows = Array.isArray(snapshot.recent) && snapshot.recent.length > 0;
        // Person-only snapshot still unblocks authenticated shell
        if (!hasRows && !snapshot.person) {
            return false;
        }
        // Never spawn the Recent panel on search/view/report (recentFetchEnabled === false)
        if (boardRecent && Array.isArray(snapshot.recent)) {
            $scope.recentRows = snapshot.recent;
        }
        if (boardRecent && snapshot.teamRecent) {
            $scope.teamRecent = snapshot.teamRecent;
        }
        if (boardRecent) {
            $scope.openMeta = (_a = snapshot.openMeta) !== null && _a !== void 0 ? _a : null;
            $scope.sessionMeta = (_b = snapshot.sessionMeta) !== null && _b !== void 0 ? _b : null;
            $scope.idleMeta = (_c = snapshot.idleMeta) !== null && _c !== void 0 ? _c : null;
        }
        if (snapshot.person) {
            $scope.person = snapshot.person;
            // Ensure UI treats last session as authenticated for capture chrome
            if ($scope.person && $scope.person.authenticated == null) {
                $scope.person.authenticated = true;
            }
            $scope.setPerson();
        }
        if (boardRecent) {
            if (snapshot.generatedAtMs) {
                $scope.viewMode.recentGeneratedAtMs = snapshot.generatedAtMs;
            }
            $scope.viewMode.recentLastAt = snapshot.cachedAt
                ? new Date(snapshot.cachedAt).getTime()
                : Date.now();
        }
        $scope.viewMode.personReady = true;
        // Degraded "local cache" banner is for board Recent only — not search results
        if (opts && opts.degraded && boardRecent) {
            $scope.viewMode.offlineDataActive = true;
            var when = snapshot.cachedAt
                ? new Date(snapshot.cachedAt).toLocaleString()
                : 'last session';
            $scope.viewMode.offlineDataMessage =
                'Server hard to reach — showing data from ' + when + '.';
        }
        return true;
    }
    /**
     * Local-first boot: paint last Recent/person from IndexedDB before any network call.
     * Silent paint only — do not raise the degraded banner (that waits for a real failure).
     */
    function hydrateOfflineFirst() {
        var _a;
        var personId = (_a = $scope.person) === null || _a === void 0 ? void 0 : _a.dbPK;
        var load = personId != null
            ? offlineDataService.loadRecentSnapshot(personId).then(function (snap) {
                if (snap) {
                    return snap;
                }
                return offlineDataService.loadLastRecentSnapshot();
            })
            : offlineDataService.loadLastRecentSnapshot();
        return load
            .then(function (snapshot) {
            if (snapshot && applyRecentLocalSnapshot(snapshot, { degraded: false })) {
                try {
                    var pid = personPkOf($scope.person);
                    if (pid != null) {
                        hydrateScheduleFromCache(pid);
                    }
                }
                catch (_a) {
                    /* ignore */
                }
                return true;
            }
            $scope.viewMode.personReady = true;
            return false;
        })
            .catch(function () {
            $scope.viewMode.personReady = true;
            return false;
        });
    }
    function cacheRecentFromResponse(response) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        var personId = (_b = (_a = $scope.person) === null || _a === void 0 ? void 0 : _a.dbPK) !== null && _b !== void 0 ? _b : (_e = (_d = (_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.person) === null || _d === void 0 ? void 0 : _d.personObject) === null || _e === void 0 ? void 0 : _e.dbPK;
        // Live success always dismisses the banner — even if we cannot write IDB
        clearOfflineDataBanner();
        if (!personId || !((_f = response === null || response === void 0 ? void 0 : response.data) === null || _f === void 0 ? void 0 : _f.recent)) {
            return;
        }
        offlineDataService.cacheRecentSnapshot({
            personId: personId,
            cachedAt: new Date().toISOString(),
            recent: response.data.recent,
            teamRecent: response.data.teamRecent,
            openMeta: response.data.openMeta,
            sessionMeta: response.data.sessionMeta,
            idleMeta: response.data.idleMeta,
            person: (_g = response.data.person) === null || _g === void 0 ? void 0 : _g.personObject,
            generatedAtMs: (_j = (_h = $scope.viewMode) === null || _h === void 0 ? void 0 : _h.recentGeneratedAtMs) !== null && _j !== void 0 ? _j : null,
        });
    }
    function restoreRecentFromLocalCache() {
        var _a;
        var personId = (_a = $scope.person) === null || _a === void 0 ? void 0 : _a.dbPK;
        var load = personId != null
            ? offlineDataService.loadRecentSnapshot(personId).then(function (snap) {
                if (snap) {
                    return snap;
                }
                return offlineDataService.loadLastRecentSnapshot();
            })
            : offlineDataService.loadLastRecentSnapshot();
        return load.then(function (snapshot) {
            if (!snapshot) {
                return false;
            }
            // Server failed — show degraded banner
            return applyRecentLocalSnapshot(snapshot, { degraded: true });
        });
    }
    function refreshSyncConflicts() {
        return offlineDataService.listFailedSync().then(function (entries) {
            $scope.viewMode.syncConflicts = entries.map(function (entry) { return (0, syncConflictUtils_1.buildSyncConflictViewModel)(entry); });
            if (entries.length > 0) {
                $scope.viewMode.showSyncConflicts = true;
            }
            return undefined;
        });
    }
    function replayOfflineSyncQueue() {
        // pilot_notes bridge only: updateRow queue (do not expand — see offline-timewriting / next product)
        return offlineDataService
            .flushSyncQueue(function (entry) {
            if (entry.kind === 'updateRow') {
                return pilotNotesSyncService.syncQueueEntry(entry).then(function () { return undefined; });
            }
            return $q.reject(new Error("Unsupported sync kind: ".concat(entry.kind)));
        })
            .then(function (result) {
            return refreshSyncConflicts().then(function () {
                if (result.failed > 0) {
                    $scope.viewMode.showSyncConflicts = true;
                    $scope.toast("".concat(result.failed, " offline edit(s) need review"), 'warning', 9000);
                }
                else if (result.processed > 0) {
                    $scope.toast("Synced ".concat(result.processed, " offline edit(s)"), 'success', 5000);
                }
            });
        });
    }
    $scope.refreshSyncConflicts = refreshSyncConflicts;
    $scope.discardSyncConflict = function (conflict) {
        offlineDataService.deleteSyncEntry(conflict.id).then(function () { return refreshSyncConflicts(); });
    };
    $scope.forceApplySyncConflict = function (conflict) {
        offlineDataService
            .retrySyncEntry(conflict.id, { clearBaseRowUpdatedAt: true })
            .then(function (entry) {
            if (!entry) {
                return $q.reject(new Error('Queued edit not found'));
            }
            return pilotNotesSyncService.syncQueueEntry(entry).then(function () { return offlineDataService.deleteSyncEntry(conflict.id); });
        })
            .then(function () {
            refreshSyncConflicts();
            $scope.toast('Forced your offline edit onto the server', 'success', 6000);
            $timeout(function () { return $scope.fetchRecent(); }, 250);
        })
            .catch(function (error) {
            refreshSyncConflicts();
            $scope.toast("Force apply failed: ".concat((error === null || error === void 0 ? void 0 : error.message) || error), 'danger', 8000);
        });
    };
    // Recent fetch: on-demand (initial board load, mutations, manual refresh).
    // Open timers tick locally from startedUTC / pnCustomTimeUTC — no periodic recent poll by default.
    // Multi-device Focus: history SSE focus/realm sign-on → GET /api/v2/focus/state only.
    var recentFetchTimerID;
    var recentFetchInFlight = false;
    // Optional legacy poll (opt-in via ?pollR=1 or viewMode.recentPollEnabled)
    var recentBackoffMs = Math.max(45 * 1000, ((_a = $scope.viewMode) === null || _a === void 0 ? void 0 : _a.intervalRecentms) || 45 * 1000);
    var recentMinBackoffMs = 45 * 1000;
    var recentMaxBackoffMs = 120 * 1000;
    var recentHiddenMinMs = 90 * 1000;
    // Ticking clock for local open timers + UI age
    $scope.nowTs = Date.now();
    var nowTickInterval = $interval(function () {
        var now = Date.now();
        $scope.nowTs = now;
        // Recompute open recent-row Duration labels without hitting the server
        try {
            var rows = $scope.recentRows;
            if (Array.isArray(rows)) {
                for (var i = 0; i < rows.length; i++) {
                    var r = rows[i];
                    if (!r || !r.pnCustomTimeUTC)
                        continue;
                    if ($scope.isRowOpen && !$scope.isRowOpen(r))
                        continue;
                    (0, localRowPatch_1.recomputeDerivedTimeFields)(r, now);
                }
            }
        }
        catch (_a) { }
    }, 1000);
    function isRecentPollEnabled() {
        try {
            return !!($scope.viewMode &&
                $scope.viewMode.recentFetchEnabled !== false &&
                $scope.viewMode.recentPollEnabled === true);
        }
        catch (_a) {
            return false;
        }
    }
    function scheduleNextRecent(success, extraDelayMs) {
        var _a;
        // Default: no periodic recent poll (local timers + mutation-driven refresh)
        if (!isRecentPollEnabled()) {
            if (recentFetchTimerID) {
                $timeout.cancel(recentFetchTimerID);
                recentFetchTimerID = undefined;
            }
            return;
        }
        if (success === true) {
            recentBackoffMs = Math.max(recentMinBackoffMs, ((_a = $scope.viewMode) === null || _a === void 0 ? void 0 : _a.intervalRecentms) || recentMinBackoffMs);
        }
        else if (success === false) {
            recentBackoffMs = Math.min(recentMaxBackoffMs, Math.round(recentBackoffMs * 1.5));
        }
        var base = document.hidden
            ? Math.max(recentBackoffMs, recentHiddenMinMs)
            : recentBackoffMs;
        var jitter = Math.round(base * 0.2 * Math.random());
        var extra = Math.max(0, extraDelayMs || 0);
        var delayMs = base + jitter + extra;
        if (recentFetchTimerID) {
            $timeout.cancel(recentFetchTimerID);
            recentFetchTimerID = undefined;
        }
        try {
            $scope.viewMode.nextRecentDelayMs = undefined;
            $scope.viewMode.nextRecentAt = undefined;
        }
        catch (_b) { }
        recentFetchTimerID = $timeout(function () { return $scope.fetchRecent(); }, delayMs);
    }
    /**
     * After a local mutation: one recent/focus reconcile soon (not a multi-poll window).
     * No-op when Recent UI is disabled (search/view/report) or the tab is hidden.
     */
    function refreshRecentAfterMutation(delayMs) {
        if (delayMs === void 0) { delayMs = 250; }
        if (document.hidden) {
            return;
        }
        if (!isRecentUiEnabled()) {
            return;
        }
        try {
            if (recentFetchTimerID) {
                $timeout.cancel(recentFetchTimerID);
                recentFetchTimerID = undefined;
            }
            if (recentFetchInFlight) {
                return;
            }
            $timeout(function () { return $scope.fetchRecent(); }, Math.max(0, delayMs));
        }
        catch (_a) { }
    }
    // Alias for older call sites
    function triggerRecentBurst() {
        refreshRecentAfterMutation();
    }
    /**
     * Multi-device wake: Focus card only (Python GET /focus/state) — never PHP Recent.
     * Realm sign-ons arrive via history SSE → history:remoteFocus (same path).
     * Full Recent rows: mutation, manual refresh, or optional ?pollR=1.
     * Debounced so focus + visibilitychange do not double-fetch.
     */
    var lastStreamReconcileAt = 0;
    function refreshFocusFromStream(delayMs, reason) {
        if (delayMs === void 0) { delayMs = 50; }
        if (document.hidden) {
            return;
        }
        var now = Date.now();
        if (now - lastStreamReconcileAt < 1500) {
            return;
        }
        lastStreamReconcileAt = now;
        try {
            if (typeof $scope.refreshFocusState === 'function') {
                $timeout(function () {
                    try {
                        $scope.refreshFocusState();
                    }
                    catch (_a) {
                        /* ignore */
                    }
                }, Math.max(0, delayMs));
            }
        }
        catch (_a) {
            /* ignore */
        }
        // Optional legacy Recent poll only when explicitly enabled
        if (isRecentPollEnabled()) {
            scheduleNextRecent(true, Math.max(500, delayMs));
        }
    }
    function reconcileStreamFromOtherDevices(delayMs) {
        if (delayMs === void 0) { delayMs = 50; }
        refreshFocusFromStream(delayMs, 'visibility');
    }
    function onVisibilityOrFocusForStream() {
        if (document.hidden) {
            return;
        }
        reconcileStreamFromOtherDevices(50);
    }
    try {
        if (typeof document !== 'undefined' && document.addEventListener) {
            document.addEventListener('visibilitychange', onVisibilityOrFocusForStream);
        }
        if (typeof window !== 'undefined' && window.addEventListener) {
            window.addEventListener('focus', onVisibilityOrFocusForStream);
            window.addEventListener('pageshow', onVisibilityOrFocusForStream);
        }
    }
    catch (_c) {
        /* ignore */
    }
    $scope.$on('$destroy', function () {
        try {
            if (typeof document !== 'undefined' && document.removeEventListener) {
                document.removeEventListener('visibilitychange', onVisibilityOrFocusForStream);
            }
            if (typeof window !== 'undefined' && window.removeEventListener) {
                window.removeEventListener('focus', onVisibilityOrFocusForStream);
                window.removeEventListener('pageshow', onVisibilityOrFocusForStream);
            }
        }
        catch (_a) {
            /* ignore */
        }
    });
    $scope.viewMode = Object.assign({
        ver: config.ver,
        style: {
            'font-family': 'sans-serif',
            /*'font-size': '0.80em'*/
        },
        teamRecentRows: 0,
        Message: 'OK',
        hitMessage: 'OK',
        hideBlocks: false,
        hideAssetLinks: true,
        hideTaskActions: true,
        viewEditAction: true,
        viewEditExtActions: false,
        hideWardrobe: true,
        showCurrentPanel: false,
        showFocusPanel1: false,
        showEntityHistory: true,
        showEntityHistoryRows: 2,
        showTimewritingStyle: 1,
        showUserFeedback: false,
        addScheduleTag: false,
        recentRows: 4,
        filterRecentActive: true,
        imageLimitDefault: 8,
        imageLimit: 8,
        fetchPersonEnabled: true,
        recentFetchEnabled: true,
        // board = main pilot (Focus/schedule/time-flow). view|search|zen|report hide that chrome.
        pageMode: 'board',
        timeTrackingActive: true,
        // ##top pins: full set stays in schedule cache; strip shows a folded subset by default
        scheduleTopActionCountDefault: 6,
        scheduleTopActionCount: 6,
        filterScheduleActive: true,
        scheduleRows: 500,
        fetchEnabled: true,
        // Schedule full payload is heavy; never auto-polled (refresh / filter / mutation only)
        intervalFetchms: 300 * 1000,
        // Legacy opt-in Recent poll only (recentPollEnabled must be true)
        intervalRecentms: 45 * 1000,
        // Recent poll OFF by default. Multi-device Focus uses history stream → /focus/state.
        // Opt in: ?pollR=1  · interval: ?intR=45000. Open timers tick locally.
        recentPollEnabled: false,
        // Legacy "end from next stamp" (old flag) — off by default; enable if repairing old data
        showLegacyCloseAtNext: false,
        // Focus card: warn when open T/S has been running this long (seconds)
        focusStaleTSec: 4 * 3600,
        focusStaleSSec: 12 * 3600,
        searchRows: 10,
        searchRowsOrder: true,
        searchRowsOrderTag: false,
        retryCount: 5,
        retrySem: 5,
        bodyClass: '',
        // Loading flags
        recentLoading: false,
        actionLoading: false,
        sessionActionLoading: false,
        // Daily tally panel controls
        tallyDate: undefined,
        tallyLoading: false,
        tallyMode: 'day',
        // Clean display mode management (added dynamically to avoid type issues)
        showDetails: false,
        showTimeline: false,
        syncConflicts: [],
        showSyncConflicts: false,
        // Not driven by navigator.onLine — only cleared/set from real request outcomes
        networkOnline: true,
        pwaInstallable: false,
        pwaInstalled: false,
    }, $scope.viewMode || {});
    // Add displayMode property dynamically to avoid TypeScript issues
    $scope.viewMode.displayMode = 'none'; // 'none' | 'timeline' | 'details' | 'both'
    offlineDataService.bindConnectivity($window, $rootScope);
    refreshSyncConflicts();
    // Browser "online" is a retry hint only. Never mark degraded from "offline" event.
    // Do not clear the banner here optimistically — only clearOfflineDataBanner() after live Recent OK.
    $scope.$on('offline:connectivity', function (_event, state) {
        if (state && (state.reason === 'online' || state.online === true)) {
            replayOfflineSyncQueue();
            if ($scope.viewMode.recentFetchEnabled) {
                $timeout(function () { return $scope.fetchRecent(); }, 250);
            }
        }
    });
    // --- Identity / focus context via appEventsService (factory-registered) ---
    function focusHost() {
        return {
            person: $scope.person,
            openMeta: $scope.openMeta,
            sessionMeta: $scope.sessionMeta,
            idleMeta: $scope.idleMeta,
        };
    }
    function personPkOf(p) {
        return appEventsService.personPkOf(p);
    }
    function emitFocusContextChanged(reason) {
        appEventsService.emitFocusContext(reason, focusHost());
    }
    function emitUserChanged(reason, previousPersonId) {
        appEventsService.emitUserChanged(reason, $scope.person, previousPersonId);
    }
    /**
     * After login / user switch: load Focus + Recent + lists (cold start without token
     * used to skip these because isLoggingIn blocked auth:tokenRefreshed).
     */
    function afterUserSessionReady(reason) {
        $timeout(function () {
            try {
                if (isRecentUiEnabled()) {
                    $scope.fetchRecent();
                }
                else if ($scope.viewMode.timeTrackingActive &&
                    typeof $scope.refreshFocusState === 'function') {
                    $scope.refreshFocusState();
                }
            }
            catch (_a) {
                /* ignore */
            }
            try {
                if ($scope.viewMode.initListFetchEnabled || $scope.viewMode.fetchEnabled) {
                    $scope.fetchLists();
                }
            }
            catch (_b) {
                /* ignore */
            }
            try {
                var pid = personPkOf($scope.person);
                if (pid != null) {
                    hydrateScheduleFromCache(pid);
                }
            }
            catch (_c) {
                /* ignore */
            }
            try {
                if (typeof $scope.syncThreadsFromServer === 'function') {
                    $scope.syncThreadsFromServer({ quiet: true });
                }
            }
            catch (_d) {
                /* ignore */
            }
            emitFocusContextChanged(reason);
        }, 50);
    }
    // Auth transport / session (interceptor already $broadcasts these)
    appEventsService.onServerUnreachable(function () {
        $scope.viewMode.serverUnreachable = true;
        $scope.viewMode.offlineDataMessage =
            $scope.viewMode.offlineDataMessage ||
                'Server unreachable — keeping your session; local drafts and cached rows still work.';
        try {
            $scope.toast('Server hard to reach — session kept. Working offline until it recovers.', 'warning', 6000);
        }
        catch (_a) {
            /* ignore */
        }
    });
    appEventsService.onSessionEnded(function () {
        $scope.viewMode.serverUnreachable = false;
        var prev = personPkOf($scope.person);
        $scope.person = null;
        $scope.openMeta = null;
        $scope.sessionMeta = null;
        $scope.idleMeta = null;
        emitUserChanged('session_ended', prev);
        emitFocusContextChanged('session_ended');
    });
    appEventsService.onTokenRefreshed(function () {
        // Token refresh alone is not a full Recent refresh; still clear hard-unreachable
        // so a successful reauth is not stuck under a stale banner forever.
        $scope.viewMode.serverUnreachable = false;
    });
    // Identity changes (person switch / token refresh). Login is handled in doLogin.
    appEventsService.onUserChanged(function (payload) {
        if (!payload || !payload.authenticated) {
            return;
        }
        if (payload.reason === 'login') {
            return;
        }
        if (payload.reason === 'person_loaded' ||
            payload.reason === 'person_switched' ||
            payload.reason === 'token_refreshed') {
            afterUserSessionReady(payload.reason);
        }
    });
    // Timeline API reference (set by directive on-ready callback)
    $scope.timelineApi = null;
    // Expose view manager methods to scope for template access
    $scope.showTimelineOnly = function (dateStr) {
        if (dateStr) {
            $scope.fetchTimelineOnly(dateStr);
        }
        else {
            tallyState.setTimelineOnlyMode($scope.viewMode);
        }
    };
    $scope.showDetailsOnly = function (dateStr) {
        tallyState.setDetailsOnlyMode($scope.viewMode);
        if (dateStr && $scope.fetchDailyDetails) {
            $scope.fetchDailyDetails(dateStr);
        }
    };
    $scope.toggleTimelineView = function () {
        tallyState.toggleTimeline($scope.viewMode);
    };
    $scope.toggleDetailsView = function () {
        tallyState.toggleDetails($scope.viewMode);
    };
    // Initialize AI system for intelligent timestream analysis (temporarily disabled for debugging)
    // const audRoamAI = initializeAudRoamAI($scope);
    // console.log('🤖 AI system initialized for temporal analysis and data healing');
    // Ensure defaults for tally date and mine-only flag (moved out of template ng-init to avoid Angular parse issues)
    try {
        if ($scope.viewMode.tallyDate === undefined || $scope.viewMode.tallyDate === null) {
            $scope.viewMode.tallyDate = new Date();
        }
        if (typeof $scope.viewMode.tallyMineOnly === 'undefined') {
            $scope.viewMode.tallyMineOnly = true;
        }
    }
    catch (_d) { }
    // Initialize viewMode from PHP-injected global config
    var viewModeConfig = window.audroamViewModeConfig || {};
    $scope.viewMode.recentFetchEnabled = viewModeConfig.recentFetchEnabled;
    $scope.viewMode.scheduleRows = viewModeConfig.scheduleRows;
    $scope.viewMode.initFetchEnabled = viewModeConfig.initFetchEnabled;
    $scope.viewMode.initScheduleFetchEnabled = viewModeConfig.initScheduleFetchEnabled;
    $scope.viewMode.initListFetchEnabled = viewModeConfig.initListFetchEnabled;
    $scope.viewMode.fetchEnabled = viewModeConfig.fetchEnabled;
    if (viewModeConfig.pageMode) {
        $scope.viewMode.pageMode = viewModeConfig.pageMode;
    }
    if (typeof viewModeConfig.timeTrackingActive === 'boolean') {
        $scope.viewMode.timeTrackingActive = viewModeConfig.timeTrackingActive;
    }
    $scope.viewMode.intervalFetchms = viewModeConfig.intervalFetchms;
    $scope.viewMode.intervalRecentms = viewModeConfig.intervalRecentms;
    if (typeof viewModeConfig.recentPollEnabled === 'boolean') {
        $scope.viewMode.recentPollEnabled = viewModeConfig.recentPollEnabled;
    }
    // Align optional poll backoff with injected interval
    try {
        if (typeof $scope.viewMode.intervalRecentms === 'number' && $scope.viewMode.intervalRecentms > 0) {
            recentBackoffMs = Math.max(recentMinBackoffMs, $scope.viewMode.intervalRecentms);
        }
    }
    catch (_e) { }
    $scope.viewMode.initialSearch = viewModeConfig.initialSearch;
    $scope.viewMode.initialSearchOnly = viewModeConfig.initialSearchOnly;
    $scope.viewMode.initialSearchText = viewModeConfig.initialSearchText;
    $scope.viewMode.initialSearchPNID = viewModeConfig.initialSearchPNID;
    $scope.viewMode.initialSearchOnlyPNID = viewModeConfig.initialSearchOnlyPNID;
    $scope.viewMode.zenMode = !!viewModeConfig.zenMode;
    $scope.viewMode.zenPnid = viewModeConfig.zenPnid || viewModeConfig.initialSearchOnlyPNID || null;
    $scope.viewMode.zenRow = null;
    $scope.viewMode.zenLoading = !!viewModeConfig.zenMode;
    $scope.viewMode.zenError = null;
    $scope.viewMode.presentMode = !!viewModeConfig.presentMode;
    if (viewModeConfig.initialThreadsPath) {
        $scope.viewMode.initialThreadsPath = viewModeConfig.initialThreadsPath;
    }
    if (viewModeConfig.pageMode === 'threads') {
        $scope.viewMode.pageMode = 'threads';
        $scope.viewMode.timeTrackingActive = false;
        $scope.viewMode.recentFetchEnabled = false;
        $scope.viewMode.fetchEnabled = false;
        $scope.viewMode.initScheduleFetchEnabled = false;
    }
    if ($scope.viewMode.zenMode) {
        $scope.viewMode.recentFetchEnabled = false;
        $scope.viewMode.fetchEnabled = false;
        $scope.viewMode.pageMode = 'zen';
        $scope.viewMode.timeTrackingActive = false;
        $scope.viewMode.initScheduleFetchEnabled = false;
        $scope.viewMode.hideBlocks = true;
    }
    $scope.openZenForRow = function (row) {
        if (!row || !row.ID)
            return;
        $window.location.href = '/zen/pnid/' + row.ID;
    };
    /** Open note with map presentation (?present=1). */
    $scope.openPresentForRow = function (row) {
        if (!row || !row.ID)
            return;
        $window.location.href = '/view/pnid/' + row.ID + '?present=1';
    };
    // Initialize personLoginURI if not set
    if (!$scope.personLoginURI) {
        $scope.personLoginURI = { loginName: '', inviteToken: '' };
    }
    // TODO: tree view experiment
    // $scope.treeData = [
    //     {
    //         label: 'Root',
    //         expanded: true,
    //         children: [
    //             { label: 'Branch 1', children: [ { label: 'Leaf 1.1' }, { label: 'Leaf 1.2' } ] },
    //             { label: 'Branch 2', children: [ { label: 'Leaf 2.1' } ] },
    //             { label: 'Branch 3' }
    //         ]
    //     }
    // ];
    $scope.config = config;
    $scope.personLoginURI = $scope.personLoginURI || { loginName: '', inviteToken: '' };
    $scope.login = {
        loginName: $scope.personLoginURI.loginName,
        inviteToken: $scope.personLoginURI.inviteToken,
        personLoginURI: $scope.personLoginURI,
    };
    $scope.ui = {};
    $scope.personPrev = '(initial load)';
    $scope.assetForm = { uiMessage: 'OK' };
    $scope.Feedback = { uiMessage: '' };
    $scope.tagStatus = {};
    $scope.shareLevels = ['Private', 'Team', 'Client', 'Technical', 'Public'];
    // Initialize history data
    $scope.history = {
        searches: historyService.getSearchHistory(),
        views: historyService.getViewHistory(),
        scans: historyService.getScanHistory(),
        focus: historyService.getFocusHistory(),
    };
    console.log('History initialized:', $scope.history);
    console.log('Search history length:', $scope.history.searches.length);
    console.log('View history length:', $scope.history.views.length);
    console.log('Scan history length:', $scope.history.scans.length);
    console.log('Focus history length:', $scope.history.focus.length);
    // Push: opt-in only (My Account). No auto-subscribe toast on load.
    var pushFallback = function (title, body) {
        console.warn('[push]', body ? "".concat(title, ": ").concat(body) : title);
    };
    $scope.pushStatus = {
        supported: false,
        permission: 'unsupported',
        optIn: false,
        hasBrowserSubscription: false,
        busy: false,
        message: null,
    };
    $scope.pushPrefs = {
        timezone: 'Australia/Melbourne',
        start_of_day_time: '08:00',
        start_of_day_enabled: true,
        due_schedule_enabled: true,
        long_open_enabled: true,
        long_open_hours: 2,
        quiet_start: '',
        quiet_end: '',
    };
    /** Pending digest stack (My Account inbox) — what one push may summarize. */
    $scope.pushInbox = {
        loading: false,
        error: null,
        summary: null,
        showRecent: false,
    };
    $scope.refreshPushStatus = function () {
        return pushSubscriptionService.getStatus().then(function (status) {
            Object.assign($scope.pushStatus, status, { busy: false });
            // Surface probe so My Account is not a useless “unsupported” label
            $scope.pushDiagnostics = status.diagnostics || null;
            return status;
        });
    };
    $scope.loadPushPrefs = function () {
        return pushSubscriptionService
            .getPrefs()
            .then(function (prefs) {
            var p = $scope.pushPrefs;
            Object.assign(p, prefs || {});
            if (p.quiet_start == null)
                p.quiet_start = '';
            if (p.quiet_end == null)
                p.quiet_end = '';
        })
            .catch(function (err) {
            console.warn('[push] load prefs failed', err);
            $scope.pushStatus.message =
                'Could not load server digest prefs (API/migration?)';
        });
    };
    $scope.loadPushInbox = function () {
        var box = $scope.pushInbox;
        box.loading = true;
        box.error = null;
        return pushSubscriptionService
            .getPendingSummary()
            .then(function (summary) {
            box.summary = summary || null;
            box.loading = false;
        })
            .catch(function (err) {
            box.loading = false;
            box.error =
                (err && err.data && err.data.error) ||
                    (err && err.message) ||
                    'Could not load pending notifications';
            box.summary = null;
        });
    };
    $scope.openPushInboxItem = function (item, newTab) {
        if (!item)
            return;
        var id = item.id;
        var path = item.url || (id != null ? '/view/pnid/' + id : null);
        if (!path)
            return;
        if (newTab) {
            $window.open(path, '_blank');
            return;
        }
        if (id != null && typeof $scope.personSearch === 'function') {
            try {
                $scope.personSearch({ pnid: id });
                return;
            }
            catch (_a) {
                /* fall through */
            }
        }
        $window.location.href = path;
    };
    $scope.savePushPrefs = function () {
        var st = $scope.pushStatus;
        var p = $scope.pushPrefs;
        st.busy = true;
        st.message = null;
        var body = {
            timezone: p.timezone,
            start_of_day_time: p.start_of_day_time,
            start_of_day_enabled: !!p.start_of_day_enabled,
            due_schedule_enabled: !!p.due_schedule_enabled,
            long_open_enabled: !!p.long_open_enabled,
            long_open_hours: p.long_open_hours,
            quiet_start: p.quiet_start || null,
            quiet_end: p.quiet_end || null,
        };
        return pushSubscriptionService
            .savePrefs(body)
            .then(function (saved) {
            Object.assign(p, saved);
            st.busy = false;
            st.message = 'Digest preferences saved on server.';
            try {
                $scope.toast('Push digest prefs saved', 'success', 3500);
            }
            catch (_a) { }
        })
            .catch(function (err) {
            st.busy = false;
            st.message =
                (err && err.data && err.data.error) ||
                    (err && err.message) ||
                    'Save prefs failed';
            try {
                $scope.toast(st.message, 'danger', 5000);
            }
            catch (_a) { }
        });
    };
    var runPushDogfood = function (label, fn) {
        var st = $scope.pushStatus;
        st.busy = true;
        st.message = null;
        return fn()
            .then(function (data) {
            st.busy = false;
            st.message = label + ' OK — check notification tray. ' + (data && data.status ? '' : '');
            try {
                $scope.toast(label + ' triggered', 'success', 4000);
            }
            catch (_a) { }
            console.log('[push]', label, data);
        })
            .catch(function (err) {
            st.busy = false;
            st.message =
                (err && err.data && err.data.error) ||
                    (err && err.message) ||
                    label + ' failed';
            try {
                $scope.toast(st.message, 'danger', 6000);
            }
            catch (_a) { }
        });
    };
    $scope.pushSendStartOfDay = function () {
        return runPushDogfood('Start of day', function () { return pushSubscriptionService.sendStartOfDayNow(); });
    };
    $scope.pushSendDueSchedule = function () {
        return runPushDogfood('Due schedule', function () { return pushSubscriptionService.sendDueScheduleNow(); });
    };
    $scope.pushSendLongOpen = function () {
        return runPushDogfood('Long open', function () { return pushSubscriptionService.sendLongOpenNow(); });
    };
    $scope.pushRunTick = function () {
        return runPushDogfood('Digest tick', function () {
            return pushSubscriptionService.runTick({ force: false });
        });
    };
    $scope.pushRunTickForce = function () {
        return runPushDogfood('Digest tick (force)', function () {
            return pushSubscriptionService.runTick({ force: true });
        });
    };
    $scope.enablePushNotifications = function () {
        var st = $scope.pushStatus;
        st.busy = true;
        st.message = null;
        // User gesture: request permission even if a weak probe said no
        return pushSubscriptionService
            .initialize({
            onFallback: pushFallback,
            requestPermission: true,
        })
            .then(function (result) {
            $scope.pushDiagnostics = result.diagnostics || $scope.pushDiagnostics;
            $scope.refreshPushStatus();
            if (result.subscribed) {
                st.message = 'Subscribed on this device. Use Send test to verify.';
                try {
                    $scope.toast('Push enabled on this device', 'success', 4000);
                }
                catch (_a) { }
            }
            else {
                var diag = result.diagnostics;
                var extra = diag && diag.blockers && diag.blockers.length
                    ? ' — ' + diag.blockers.join('; ')
                    : '';
                st.message = result.reason
                    ? "Not subscribed (".concat(result.reason, ")").concat(extra)
                    : 'Not subscribed' + extra;
                try {
                    $scope.toast(st.message, 'warning', 8000);
                }
                catch (_b) { }
            }
        })
            .catch(function (err) {
            st.busy = false;
            st.message = (err && err.message) || 'Enable failed';
            console.warn('[push] enable failed', err);
        });
    };
    $scope.resubscribePushNotifications = function () {
        var st = $scope.pushStatus;
        st.busy = true;
        st.message = null;
        return pushSubscriptionService
            .initialize({
            onFallback: pushFallback,
            requestPermission: true,
            forceResubscribe: true,
        })
            .then(function (result) {
            $scope.refreshPushStatus();
            st.message = result.subscribed
                ? 'Re-subscribed and saved to server.'
                : "Re-subscribe failed (".concat(result.reason || 'unknown', ")");
            try {
                $scope.toast(st.message, result.subscribed ? 'success' : 'warning', 5000);
            }
            catch (_a) { }
        })
            .catch(function (err) {
            st.busy = false;
            st.message = (err && err.message) || 'Re-subscribe failed';
        });
    };
    $scope.disablePushOptIn = function () {
        pushSubscriptionService.setOptIn(false);
        $scope.refreshPushStatus();
        $scope.pushStatus.message =
            'Opt-in cleared for this browser. Browser permission may still be granted until you change site settings.';
    };
    $scope.sendPushTest = function () {
        var st = $scope.pushStatus;
        st.busy = true;
        st.message = null;
        return pushSubscriptionService
            .sendTest()
            .then(function () {
            st.busy = false;
            st.message = 'Test sent — check system notification tray (and allow if blocked).';
            try {
                $scope.toast('Push test sent', 'success', 4000);
            }
            catch (_a) { }
        })
            .catch(function (err) {
            st.busy = false;
            st.message = (err && err.message) || 'Test send failed (VAPID/API/subscription?)';
            try {
                $scope.toast(st.message, 'danger', 6000);
            }
            catch (_a) { }
        });
    };
    $timeout(function () {
        pwaService
            .initialize($rootScope)
            .then(function (result) {
            $scope.viewMode.pwaInstallable = result.installable;
        })
            .catch(function (error) { return console.warn('PWA init failed:', error); });
        // Silent refresh only if user previously opted in (no permission prompt, no toast).
        if (pushSubscriptionService.getOptIn()) {
            pushSubscriptionService
                .initialize({ onFallback: pushFallback, requestPermission: false })
                .then(function () { return $scope.refreshPushStatus(); })
                .catch(function (error) { return console.warn('Push silent refresh failed:', error); });
        }
        else {
            $scope.refreshPushStatus();
        }
    }, 0);
    $scope.$on('pwa:installable', function (_event, state) {
        $scope.viewMode.pwaInstallable = !!(state === null || state === void 0 ? void 0 : state.installable);
    });
    $scope.$on('pwa:installed', function () {
        $scope.viewMode.pwaInstallable = false;
        $scope.viewMode.pwaInstalled = true;
    });
    $scope.installPwa = function () {
        return pwaService.promptInstall().then(function (accepted) {
            if (accepted) {
                $scope.toast('Audroam installed — open from your home screen or app list.', 'success', 6000);
            }
            else if (!$scope.viewMode.pwaInstallable) {
                $scope.toast('Install from the browser menu: Add to Home Screen / Install app.', 'info', 8000);
            }
            return accepted;
        });
    };
    // Subscribe to history changes for real-time updates (realm switcher highlights, etc.)
    historyService.onChange(function () {
        // Use safeApply to avoid digest-in-progress errors
        var applyFn = function () {
            $scope.history = {
                searches: historyService.getSearchHistory(),
                views: historyService.getViewHistory(),
                scans: historyService.getScanHistory(),
                focus: historyService.getFocusHistory(),
            };
            // Update realmList with fresh focus history if person is set
            if ($scope.person) {
                $scope.setPerson();
            }
        };
        // If already in digest, just update; otherwise trigger digest
        if ($scope.$root.$$phase) {
            applyFn();
        }
        else {
            $scope.$apply(applyFn);
        }
    });
    /**
     * After this tab loaded a valid Recent + Focus snapshot, fan out a compact digest
     * on the history focus message so peers merge by note ID (no PHP recent).
     *
     * Prefer live scope rows/meta when present so optimistic set-time/backdate patches
     * win over a stale PHP recent payload (Python mutates DB; PHP recent can lag).
     */
    function publishRecentViewDigestFromPayload(data) {
        try {
            if (!isRecentUiEnabled())
                return;
            var liveRows = $scope.recentRows;
            var rows = Array.isArray(liveRows) && liveRows.length > 0
                ? liveRows
                : data && Array.isArray(data.recent)
                    ? data.recent
                    : null;
            if (!rows || rows.length === 0)
                return;
            var fromPayload = (0, focusTimeHelpers_1.extractFocusAccountRealmFromPayload)(data || {});
            var account = fromPayload.account ||
                ($scope.person && $scope.person.CurrentAccount) ||
                null;
            var realm = fromPayload.realm ||
                ($scope.person && $scope.person.CurrentRealm) ||
                null;
            if (!account || !realm)
                return;
            var dig = (0, recentViewDigest_1.buildRecentViewDigest)(rows, {
                limit: Math.max(4, Number($scope.viewMode.recentRows) || 4) + 4,
                at: Date.now(),
                // Live Focus meta after local patches; fall back to payload
                openMeta: $scope.openMeta !== undefined
                    ? $scope.openMeta
                    : data === null || data === void 0 ? void 0 : data.openMeta,
                sessionMeta: $scope.sessionMeta !== undefined
                    ? $scope.sessionMeta
                    : data === null || data === void 0 ? void 0 : data.sessionMeta,
                idleMeta: $scope.idleMeta !== undefined
                    ? $scope.idleMeta
                    : data === null || data === void 0 ? void 0 : data.idleMeta,
            });
            if (!dig)
                return;
            historyService.addFocusEntry(String(realm), String(account), {
                recentDigest: dig,
                force: true,
            });
        }
        catch (_a) {
            /* ignore */
        }
    }
    /**
     * Publish focus stream digest from the current board Recent + open/session meta.
     * Used right after set-time / backdate so peers see updated times without waiting
     * for PHP recent (and even when Recent fetch is deferred or stale).
     */
    function publishFocusRecentDigestFromLocal(_reason) {
        try {
            if (!isRecentUiEnabled())
                return;
            var rows = $scope.recentRows;
            if (!Array.isArray(rows) || rows.length === 0)
                return;
            var account = ($scope.person && $scope.person.CurrentAccount) || null;
            var realm = ($scope.person && $scope.person.CurrentRealm) || null;
            if (!account || !realm)
                return;
            var now = Date.now();
            try {
                $scope.viewMode.recentLastAt = now;
                $scope.viewMode.recentGeneratedAtMs = now;
            }
            catch (_a) { }
            var dig = (0, recentViewDigest_1.buildRecentViewDigest)(rows, {
                limit: Math.max(4, Number($scope.viewMode.recentRows) || 4) + 4,
                at: now,
                openMeta: $scope.openMeta,
                sessionMeta: $scope.sessionMeta,
                idleMeta: $scope.idleMeta,
            });
            if (!dig)
                return;
            historyService.addFocusEntry(String(realm), String(account), {
                recentDigest: dig,
                force: true,
            });
        }
        catch (_b) {
            /* ignore */
        }
    }
    $scope.publishFocusRecentDigestFromLocal = publishFocusRecentDigestFromLocal;
    /**
     * Apply peer focus+recentDigest from history SSE. Prefer merge over PHP recent / focus GET
     * when digest is present and fresh enough.
     */
    function applyRemoteFocusWithOptionalDigest(entry) {
        var _a;
        var data = entry && entry.data ? entry.data : entry;
        // Live thread checklist status/role (independent of Recent digest)
        try {
            if (typeof $scope.applyThreadMemberDigestFromFocus === 'function') {
                $scope.applyThreadMemberDigestFromFocus(entry);
            }
        }
        catch (_b) {
            /* ignore */
        }
        var dig = (0, recentViewDigest_1.extractRecentDigestFromFocusData)(data);
        if (dig && isRecentUiEnabled()) {
            var localAt = (_a = $scope.viewMode) === null || _a === void 0 ? void 0 : _a.recentLastAt;
            if ((0, recentViewDigest_1.isRecentDigestFresher)(dig.at, localAt)) {
                try {
                    var merged = (0, recentViewDigest_1.mergeRecentDigestById)($scope.recentRows, dig.rows);
                    $scope.recentRows = merged;
                    var now = Date.now();
                    for (var i = 0; i < merged.length; i++) {
                        var r = merged[i];
                        if (r && r.pnCustomTimeUTC) {
                            (0, localRowPatch_1.recomputeDerivedTimeFields)(r, now);
                        }
                    }
                    applyFocusStatePayload({
                        openMeta: dig.openMeta,
                        sessionMeta: dig.sessionMeta,
                        idleMeta: dig.idleMeta,
                        account: data.account || data.Account,
                        realm: data.realm || data.Realm,
                    }, { recordHistory: false });
                    if (dig.at) {
                        $scope.viewMode.recentLastAt = dig.at;
                        $scope.viewMode.recentGeneratedAtMs = dig.at;
                    }
                    try {
                        if (typeof $scope.refreshThreadPills === 'function') {
                            $scope.refreshThreadPills();
                        }
                    }
                    catch (_c) {
                        /* ignore */
                    }
                    // Digest carried Focus meta — skip GET /focus/state and PHP recent
                    if (dig.openMeta !== undefined || dig.sessionMeta !== undefined) {
                        return;
                    }
                }
                catch (_d) {
                    /* fall through to focus GET */
                }
            }
        }
        // Thread-only focus message (no Recent rows / Focus meta): skip Focus GET thrash
        if (data &&
            data.threadMemberDigest &&
            Array.isArray(data.threadMemberDigest.patches) &&
            data.threadMemberDigest.patches.length > 0 &&
            !dig) {
            return;
        }
        // No usable digest: Focus only (Python), never PHP recent
        refreshFocusFromStream(80, 'history-remote-focus');
    }
    // Remote focus / realm sign-on via history SSE → digest merge or Focus GET only
    var stopRemoteFocus = $rootScope.$on('history:remoteFocus', function (_event, entry) {
        applyRemoteFocusWithOptionalDigest(entry);
    });
    $scope.$on('$destroy', function () {
        try {
            stopRemoteFocus();
        }
        catch (_a) {
            /* ignore */
        }
    });
    // Initialize navHit for search inputs
    $scope.navHit = {};
    // History selection functions - now use full search parameters stored in history
    $scope.selectSearchHistory = function (entry) {
        if (entry && entry.data) {
            // Use full params if available (contains realm, account, filters, etc)
            // Otherwise fall back to just the text field
            var searchArgs = entry.data.params || { s: entry.data.text };
            console.log('selectSearchHistory - entry.data:', entry.data);
            console.log('selectSearchHistory - using searchArgs:', searchArgs);
            $scope.personSearch(searchArgs);
        }
    };
    $scope.selectScanHistory = function (entry) {
        if (entry && entry.data) {
            // Use full params if available, which includes realm/account filters
            // Otherwise fall back to just the tag
            var searchArgs = entry.data.params || { tag: entry.data.tag };
            $scope.personSearch(searchArgs);
        }
    };
    $scope.selectViewHistory = function (entry) {
        // Thread views open the local thread panel (caption lives in view history)
        if (entry && typeof $scope.tryOpenThreadFromViewHistory === 'function') {
            if ($scope.tryOpenThreadFromViewHistory(entry)) {
                return;
            }
        }
        if (entry && entry.data && entry.data.pnid) {
            $scope.personSearch({ pnid: entry.data.pnid });
            return;
        }
        if (entry && entry.data && entry.data.url) {
            // For view history, we can either open in new tab or navigate
            // For now, let's open in new tab
            window.open(entry.data.url, '_blank');
        }
    };
    $scope.clearHistory = function (type) {
        historyService.clearHistory(type);
        $scope.history = historyService.getAllHistory();
    };
    /**
     * Clear all client history and force fresh sync from server
     * Useful for mobile to reset state and pull all data fresh
     */
    $scope.clearAllAndSync = function () {
        if (!$window.confirm('Clear all local history and force fresh sync from server? This will reload all data.')) {
            return;
        }
        console.log('[AudRoamCtrl] Clearing all history and syncing...');
        historyService.clearAllAndSync()
            .then(function () {
            $scope.history = historyService.getAllHistory();
            console.log('[AudRoamCtrl] Fresh sync complete, history reloaded');
        })
            .catch(function (error) {
            console.error('[AudRoamCtrl] Clear and sync failed:', error);
            $scope.history = historyService.getAllHistory();
        });
    };
    $scope.assetOwners = assetInfo_1.assetOwners;
    $scope.assetCategories = assetInfo_1.assetCategories;
    $scope.defaultActions1 = defaultActions1_1.defaultActions1;
    $scope.defaultActions2 = actions2_1.actions2;
    $scope.taskActions = defaultActions1_1.defaultActions1.concat(actions2_1.actions2);
    $scope.bikeActions = bikeActions_1.bikeActions;
    $scope.reuseActions = reuseActions_1.reuse;
    // Expose a confirm dialog for use in templates
    // AngularJS expressions cannot call global window.confirm directly
    $scope.confirm = function (message) {
        try {
            return $window.confirm(message);
        }
        catch (_a) {
            return true;
        }
    };
    // Determine whether a row is still open (not completed)
    $scope.isRowOpen = function (row) { return (0, focusTimeHelpers_1.isRowOpen)(row); };
    /** Current Focus T/S pointer ids — single place for openMeta/sessionMeta shape. */
    $scope.focusPointerIds = function () {
        var _a, _b, _c, _d;
        try {
            return {
                focusTId: (_b = (_a = $scope.openMeta) === null || _a === void 0 ? void 0 : _a.openId) !== null && _b !== void 0 ? _b : null,
                focusSId: (_d = (_c = $scope.sessionMeta) === null || _c === void 0 ? void 0 : _c.openId) !== null && _d !== void 0 ? _d : null,
            };
        }
        catch (_e) {
            return { focusTId: null, focusSId: null };
        }
    };
    /**
     * How this row is active vs Focus pointers (focus_t | focus_s | open_orphan).
     * Prefer this over ad-hoc openMeta checks when UI logic evolves.
     */
    $scope.rowActiveRoles = function (row) {
        try {
            return (0, focusTimeHelpers_1.activeRolesForRow)(row, $scope.focusPointerIds());
        }
        catch (_a) {
            return [];
        }
    };
    /** Chips for search/recent: Focus T / Focus S (orphan optional via opts). */
    $scope.rowActiveChips = function (row, includeOrphan) {
        try {
            return (0, focusTimeHelpers_1.activeChipsForRow)(row, $scope.focusPointerIds(), {
                includeOrphan: !!includeOrphan,
            });
        }
        catch (_a) {
            return [];
        }
    };
    /** Show adopt / resume menu when row is not already Focus T. */
    $scope.canAdoptAsFocusT = function (row) {
        try {
            return (0, focusTimeHelpers_1.canAdoptAsFocusT)(row, $scope.focusPointerIds());
        }
        catch (_a) {
            return false;
        }
    };
    $scope.adoptFocusTLabel = function (row) {
        return (0, focusTimeHelpers_1.adoptFocusTLabel)(row);
    };
    /** Active Focus T pointer (person_focus_state) — this row is the current activity timer. */
    $scope.isFocusT = function (row) {
        try {
            return (0, focusTimeHelpers_1.activeRolesForRow)(row, $scope.focusPointerIds()).indexOf('focus_t') >= 0;
        }
        catch (_a) {
            return false;
        }
    };
    /** Active Focus S pointer — current Session envelope. */
    $scope.isFocusS = function (row) {
        try {
            return (0, focusTimeHelpers_1.activeRolesForRow)(row, $scope.focusPointerIds()).indexOf('focus_s') >= 0;
        }
        catch (_a) {
            return false;
        }
    };
    /**
     * Open flowKind S|T that is not the current Focus pointer (stale open interval).
     */
    $scope.isOpenTimerOrphan = function (row) {
        try {
            return (0, focusTimeHelpers_1.activeRolesForRow)(row, $scope.focusPointerIds()).indexOf('open_orphan') >= 0;
        }
        catch (_a) {
            return false;
        }
    };
    /** @deprecated use isTimeTracking — same rule (flowKind S|T only) */
    $scope.isDurationOpenCandidate = function (row) {
        return !!row && (0, focusTimeHelpers_1.isRowOpen)(row) && (0, focusTimeHelpers_1.isTimeTrackingRow)(row);
    };
    $scope.countOpenTimerOrphans = function () {
        try {
            var rows = $scope.recentRows;
            if (!Array.isArray(rows))
                return 0;
            var n = 0;
            for (var _i = 0, rows_1 = rows; _i < rows_1.length; _i++) {
                var r = rows_1[_i];
                if ($scope.isOpenTimerOrphan(r))
                    n++;
            }
            return n;
        }
        catch (_a) {
            return 0;
        }
    };
    /** Preview start → end for seal confirm dialogs (local clock). */
    $scope.describeStopDuration = function (row, durationMinutes) {
        return (0, focusTimeHelpers_1.describeStopDurationPreview)((row === null || row === void 0 ? void 0 : row.pnCustomTimeUTC) || (row === null || row === void 0 ? void 0 : row.startedUTC), durationMinutes, row === null || row === void 0 ? void 0 : row.LocalTime);
    };
    function afterTimerStop(row, data, toastMsg, callback) {
        var _a, _b, _c, _d, _e, _f;
        try {
            if ((data === null || data === void 0 ? void 0 : data.openMeta) !== undefined || (data === null || data === void 0 ? void 0 : data.sessionMeta) !== undefined) {
                applyFocusStatePayload(data);
            }
            else {
                (_b = (_a = $scope).refreshFocusState) === null || _b === void 0 ? void 0 : _b.call(_a);
            }
        }
        catch (_g) {
            try {
                (_d = (_c = $scope).refreshFocusState) === null || _d === void 0 ? void 0 : _d.call(_c);
            }
            catch (_h) { }
        }
        try {
            if ((data === null || data === void 0 ? void 0 : data.pnCompletedUTC) != null || (data === null || data === void 0 ? void 0 : data.CompletedUTC) != null) {
                row.pnCompletedUTC = data.pnCompletedUTC || data.CompletedUTC;
            }
            if ((data === null || data === void 0 ? void 0 : data.pnCustomTimeUTC) != null) {
                row.pnCustomTimeUTC = data.pnCustomTimeUTC;
            }
            if ((data === null || data === void 0 ? void 0 : data.mode) === 'unlink') {
                row.pnCompletedUTC = null;
                row.pnFlowKind = null;
            }
            (0, localRowPatch_1.recomputeDerivedTimeFields)(row, Date.now());
            if ($scope.patchLocalRowsById && row.ID) {
                var patch = {
                    pnCompletedUTC: row.pnCompletedUTC,
                    pnCustomTimeUTC: row.pnCustomTimeUTC,
                };
                if ((data === null || data === void 0 ? void 0 : data.mode) === 'unlink') {
                    patch.pnFlowKind = null;
                }
                $scope.patchLocalRowsById(row.ID, patch, row);
            }
        }
        catch (_j) { }
        try {
            (_f = (_e = $scope).toast) === null || _f === void 0 ? void 0 : _f.call(_e, toastMsg, 'success', 5000);
        }
        catch (_k) { }
        if (typeof callback === 'function') {
            callback();
        }
        else if ($scope.fetchRecentOnly) {
            try {
                $scope.fetchRecentOnly();
            }
            catch (_l) { }
        }
    }
    /**
     * Stop / repair open timer.
     * mode:
     *  - 'unlink' (default) — clear Focus + flowKind, no end/duration invented
     *  - 'short' — end = start + durationMinutes (must confirm in UI)
     *  - 'next' — end from next newer stamp
     *  - 'unreliable' — unlink + mark unreliable
     */
    $scope.stopOpenTimer = function (row, mode, durationMinutes, callback) {
        var _a, _b;
        if (mode === void 0) { mode = 'unlink'; }
        if (!row || !row.ID)
            return $q.reject(new Error('missing row'));
        var id = Number(row.ID);
        // Seal/stop/next only for explicit flowKind S|T — never invent timers from taxonomy
        if (!(0, focusTimeHelpers_1.isTimeTrackingRow)(row)) {
            try {
                (_b = (_a = $scope).toast) === null || _b === void 0 ? void 0 : _b.call(_a, "Not a time-tracking row (need flowKind S|T) #".concat(id), 'warning', 5000);
            }
            catch (_c) { }
            return $q.reject(new Error('Not a time-tracking row (need flowKind S|T)'));
        }
        if (mode === 'short') {
            var mins = Number(durationMinutes) || 5;
            var preview_1 = $scope.describeStopDuration(row, mins);
            if (!$scope.confirm("Seal as ".concat(mins < 60 ? mins + ' minutes' : mins / 60 + ' hour(s)', "?\n").concat(preview_1))) {
                return $q.resolve(null);
            }
            return pilotNotesSyncService
                .sealFocusShort(id, mins)
                .then(function (data) {
                afterTimerStop(row, data, "Sealed #".concat(id, ": ").concat(preview_1), callback);
                return data;
            })
                .catch(function (err) {
                var _a, _b;
                try {
                    (_b = (_a = $scope).toast) === null || _b === void 0 ? void 0 : _b.call(_a, "Seal failed: ".concat((err === null || err === void 0 ? void 0 : err.message) || err), 'danger', 6000);
                }
                catch (_c) { }
                return $q.reject(err);
            });
        }
        if (mode === 'next') {
            if (!$scope.confirm("Set end from next newer stamp for #".concat(id, "?\nStart: ").concat(row.LocalTime || row.pnCustomTimeUTC || '?', "\nKeeps flowKind (sealed T/S interval)."))) {
                return $q.resolve(null);
            }
            // Seal only: set end from next stamp. set_time clears Focus pointer when
            // this row was active T/S. Do NOT unlink — that wiped pnFlowKind (bug:
            // manual T stamps lost after "close at next stamp").
            return pilotNotesSyncService
                .setTime(id, { endFromNext: true })
                .then(function (data) {
                afterTimerStop(row, __assign(__assign({}, data), { pnCompletedUTC: data.pnCompletedUTC || data.CompletedUTC, mode: 'next' }), "Ended #".concat(id, " at next stamp (flowKind kept)"), callback);
                return data;
            })
                .catch(function (err) {
                var _a, _b;
                try {
                    (_b = (_a = $scope).toast) === null || _b === void 0 ? void 0 : _b.call(_a, "End from next failed: ".concat((err === null || err === void 0 ? void 0 : err.message) || err), 'danger', 6000);
                }
                catch (_c) { }
                return $q.reject(err);
            });
        }
        // unlink (default) or unreliable
        var mark = mode === 'unreliable';
        if (!$scope.confirm(mark
            ? "Unlink #".concat(id, " from time tracking and mark unreliable?\nNo duration will be stored.")
            : "Unlink #".concat(id, " from Focus / time tracking?\nNo end time or duration will be invented.\n(Start was ").concat(row.LocalTime || row.pnCustomTimeUTC || '?', ")"))) {
            return $q.resolve(null);
        }
        return pilotNotesSyncService
            .unlinkFocusTimer(id, { clearEnd: true, markUnreliable: mark })
            .then(function (data) {
            afterTimerStop(row, data, mark
                ? "Unlinked #".concat(id, " (unreliable, no duration)")
                : "Unlinked #".concat(id, " from time tracking (no duration)"), callback);
            return data;
        })
            .catch(function (err) {
            var _a, _b;
            try {
                (_b = (_a = $scope).toast) === null || _b === void 0 ? void 0 : _b.call(_a, "Unlink failed: ".concat((err === null || err === void 0 ? void 0 : err.message) || err), 'danger', 6000);
            }
            catch (_c) { }
            return $q.reject(err);
        });
    };
    /** @deprecated use stopOpenTimer — kept as alias for templates */
    $scope.closeOpenTimerRow = function (row, callback) {
        return $scope.stopOpenTimer(row, 'unlink', undefined, callback);
    };
    // Daily Tally state and fetcher
    $scope.dailyTally = {
        loading: false,
        range: null,
        totals: null,
        rows: [],
        weekDays: [],
        weekTotals: null,
    };
    // Wrapper chooses day vs week
    $scope.fetchTally = function (dateStr) {
        tallyState.clearTallyData($scope.dailyTally);
        tallyState.resetDisplayState($scope.viewMode);
        var mode = $scope.viewMode.tallyMode || 'day';
        try {
            window.localStorage && window.localStorage.setItem('audroam.tally.mode', mode);
        }
        catch (_a) { }
        if (mode === 'week')
            return $scope.fetchWeekTally(dateStr);
        return $scope.fetchDailyTally(dateStr);
    };
    function localDateStr(d) {
        var pad = function (n) { return ('0' + n).slice(-2); };
        return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate());
    }
    $scope.fetchDailyTally = function (dateStr) {
        var _a;
        var date = dateStr || localDateStr(new Date());
        var mineOnlyFlag = !!((_a = $scope.viewMode.tallyMineOnly) !== null && _a !== void 0 ? _a : true);
        var openHrs = parseInt(($scope.viewMode.tallyOpenHrs || 24), 10);
        return tallyService.fetchDailyTally(date, mineOnlyFlag, openHrs, $scope.dailyTally);
    };
    // Helper: convert UTC timestamp string (YYYY-MM-DD HH:mm:ss) to local time string
    $scope.toLocal = function (ts, withSeconds) {
        try {
            if (!ts)
                return '';
            var s = ('' + ts).trim();
            if (!s)
                return '';
            // Treat as UTC by adding Z
            var iso = s.replace(' ', 'T') + 'Z';
            var d = new Date(iso);
            if (isNaN(d.getTime()))
                return s;
            var pad = function (n) { return ('0' + n).slice(-2); };
            var yyyy = d.getFullYear();
            var mm = pad(d.getMonth() + 1);
            var dd = pad(d.getDate());
            var HH = pad(d.getHours());
            var MM = pad(d.getMinutes());
            var SS = pad(d.getSeconds());
            return yyyy + '-' + mm + '-' + dd + ' ' + HH + ':' + MM + (withSeconds ? ':' + SS : '');
        }
        catch (_a) {
            return '' + (ts !== null && ts !== void 0 ? ts : '');
        }
    };
    $scope.fetchDailyDetails = function (dateStr) {
        var _a;
        var date = dateStr || localDateStr(new Date());
        var mineOnlyFlag = !!((_a = $scope.viewMode.tallyMineOnly) !== null && _a !== void 0 ? _a : true);
        var openHrs = parseInt(($scope.viewMode.tallyOpenHrs || 24), 10);
        var showTimeline = !!$scope.viewMode.showTimeline;
        return tallyService.fetchDailyDetails(date, mineOnlyFlag, openHrs, $scope.dailyTally, showTimeline);
    };
    // Load timeline only (without showing details table)
    $scope.fetchTimelineOnly = function (dateStr) {
        var _a;
        var date = dateStr || localDateStr(new Date());
        var mineOnlyFlag = !!((_a = $scope.viewMode.tallyMineOnly) !== null && _a !== void 0 ? _a : true);
        var openHrs = parseInt(($scope.viewMode.tallyOpenHrs || 24), 10);
        // Set timeline-only mode
        tallyState.setTimelineOnlyMode($scope.viewMode);
        return tallyService.fetchTimelineOnly(date, mineOnlyFlag, openHrs, $scope.dailyTally);
    };
    function buildDayTimeline(details, startUTC, endUTC) {
        // lazy load prefs once per window
        if (!window._audTlPrefs) {
            try {
                window._audTlPrefs = (0, timelineUtils_1.loadTimelinePrefs)(window.localStorage || { getItem: function () { return null; }, setItem: function () { } });
            }
            catch (_a) {
                window._audTlPrefs = { collapse: {} };
            }
        }
        var _prefs = window._audTlPrefs;
        try {
            $scope.dailyTally.timeline = null;
        }
        catch (_b) { }
        var parseTs = function (s) {
            if (!s)
                return NaN;
            var d = new Date(s.replace(' ', 'T') + 'Z');
            return d.getTime();
        };
        var normalizePlane = function (p) {
            if (!p)
                return '';
            // trim to protect against leading/trailing spaces causing plane mismatch
            try {
                p = p.trim ? p.trim() : p;
            }
            catch (_a) { }
            var x = p.toLowerCase();
            if (x.indexOf('sess') === 0)
                return 'Session';
            if (x.indexOf('activ') === 0)
                return 'Activity';
            if (x.indexOf('trav') === 0)
                return 'Travel';
            if (x.indexOf('break') === 0)
                return 'Break';
            return p; // fallback original
        };
        var dayStartMs = parseTs(startUTC);
        var dayEndMs = parseTs(endUTC);
        if (!isFinite(dayStartMs) || !isFinite(dayEndMs) || dayEndMs <= dayStartMs)
            return;
        var nowMs = Date.now();
        var clamp = function (t) { return Math.max(dayStartMs, Math.min(dayEndMs, t)); };
        var mkSpan = function (d) {
            // Accept a broader set of possible field names for start/end to handle
            // variations in API payloads (e.g. clipStart/clipEnd or clipStartUTC/clipEndUTC)
            var startStr = d.startUTC || d.StartUTC || d.clipStartUTC || d.clipStart || d.pnCustomTimeUTC;
            var endStr = d.completedUTC || d.CompletedUTC || d.clipEndUTC || d.clipEnd || d.pnCompletedUTC;
            var s = clamp(parseTs(startStr));
            var eRaw = parseTs(endStr);
            var e = clamp(isFinite(eRaw) ? eRaw : nowMs);
            if (!(e > s))
                return null;
            var plane = normalizePlane((d.plane || d.taskGroup || '').toString());
            return {
                id: d.ID || d.id,
                plane: plane,
                start: s,
                end: e,
                realm: d.realm || d.pnAssetRealm || '',
                account: d.account || d.pnAssetAccount || '',
                topic: (d.topicGroup || d.pnTopicGroup || '') + (d.topicDetail ? '/' + d.topicDetail : ''),
            };
        };
        var spansAll = [];
        (details || []).forEach(function (d) {
            var sp = mkSpan(d);
            if (sp)
                spansAll.push(sp);
        });
        var byPlane = { Session: [], Activity: [], Travel: [], Break: [] };
        spansAll.forEach(function (sp) {
            if (sp.plane === 'Session')
                byPlane['Session'].push(sp);
            else if (sp.plane === 'Activity')
                byPlane['Activity'].push(sp);
            else if (sp.plane === 'Travel')
                byPlane['Travel'].push(sp);
            else if (sp.plane === 'Break')
                byPlane['Break'].push(sp);
        });
        var layoutLanes = function (items) {
            var sorted = items.slice().sort(function (a, b) { return a.start - b.start || a.end - b.end; });
            var lanes = [];
            sorted.forEach(function (sp) {
                var placed = false;
                for (var li = 0; li < lanes.length; li++) {
                    var lane = lanes[li];
                    var last = lane[lane.length - 1];
                    if (!last || last.end <= sp.start) {
                        lane.push(sp);
                        placed = true;
                        break;
                    }
                }
                if (!placed)
                    lanes.push([sp]);
            });
            return lanes;
        };
        var bands = [];
        var order = ['Session', 'Activity', 'Travel', 'Break'];
        order.forEach(function (name) {
            var items = byPlane[name] || [];
            var lanes = layoutLanes(items);
            // decorate with layout percentages
            lanes.forEach(function (lane) {
                return lane.forEach(function (sp) {
                    var leftPct = ((sp.start - dayStartMs) / (dayEndMs - dayStartMs)) * 100;
                    var widthPct = Math.max(0.2, ((sp.end - sp.start) / (dayEndMs - dayStartMs)) * 100);
                    sp.leftPct = Math.max(0, Math.min(100, leftPct));
                    sp.widthPct = Math.max(0.2, Math.min(100, widthPct));
                    sp.cls =
                        name === 'Session'
                            ? 'span-session'
                            : name === 'Activity'
                                ? 'span-activity'
                                : name === 'Travel'
                                    ? 'span-travel'
                                    : 'span-break';
                    var fmt = function (ms) {
                        var d = new Date(ms);
                        var pad = function (n) { return ('0' + n).slice(-2); };
                        return (d.getFullYear() +
                            '-' +
                            pad(d.getMonth() + 1) +
                            '-' +
                            pad(d.getDate()) +
                            ' ' +
                            pad(d.getHours()) +
                            ':' +
                            pad(d.getMinutes()));
                    };
                    sp.title =
                        '#' +
                            (sp.id || '') +
                            ' ' +
                            (sp.topic || name) +
                            ' [' +
                            fmt(sp.start) +
                            ' → ' +
                            fmt(sp.end) +
                            ']';
                });
            });
            var maxPreviewLanes = 3;
            var collapsed = lanes.length > maxPreviewLanes;
            var overflowCount = Math.max(0, lanes.length - maxPreviewLanes);
            bands.push({ name: name, lanes: lanes, _collapsed: collapsed, maxPreviewLanes: maxPreviewLanes, overflowCount: overflowCount });
        });
        // hour ticks (local browser time)
        var ticks = [];
        var totalMs = Math.max(1, dayEndMs - dayStartMs);
        var hourMs = 60 * 60 * 1000;
        // Calculate ticks based on local time hour boundaries
        var localStart = new Date(dayStartMs);
        var localEnd = new Date(dayEndMs);
        // Find the first local hour boundary
        var firstTickLocal = new Date(localStart);
        firstTickLocal.setMinutes(0, 0, 0); // Round down to hour
        if (firstTickLocal.getTime() < localStart.getTime()) {
            firstTickLocal.setHours(firstTickLocal.getHours() + 1);
        }
        // Generate ticks at each local hour
        for (var tickTime = new Date(firstTickLocal); tickTime <= localEnd; tickTime.setHours(tickTime.getHours() + 1)) {
            var tickMs = tickTime.getTime();
            var pct = ((tickMs - dayStartMs) / totalMs) * 100;
            if (pct >= 0 && pct <= 100) {
                var lab = ('0' + tickTime.getHours()).slice(-2) + ':00';
                ticks.push({ pct: pct, label: lab });
            }
        }
        // Add current time indicator
        var nowPct = ((nowMs - dayStartMs) / totalMs) * 100;
        var nowIndicator = nowPct >= 0 && nowPct <= 100 ? { pct: nowPct, isNow: true } : null;
        try {
            (0, timelineUtils_1.applyCollapsePrefs)(bands, _prefs);
        }
        catch (_c) { }
        $scope.dailyTally.timeline = { startUTC: startUTC, endUTC: endUTC, bands: bands, ticks: ticks, nowIndicator: nowIndicator };
        try {
            $scope.dailyTally.timeline._debugCounts = {
                session: byPlane['Session'].length,
                activity: byPlane['Activity'].length,
                travel: byPlane['Travel'].length,
                break: byPlane['Break'].length,
            };
        }
        catch (_d) { }
    }
    // Timeline helpers: expand/collapse all bands
    $scope.expandAllTimelineBands = function (expand) {
        try {
            var tl = $scope.dailyTally && $scope.dailyTally.timeline;
            if (!tl || !tl.bands)
                return;
            tl.bands.forEach(function (b) {
                b._collapsed = !expand;
            });
            try {
                var prefs = (0, timelineUtils_1.captureCollapsePrefs)(tl.bands);
                window._audTlPrefs = prefs;
                (0, timelineUtils_1.saveTimelinePrefs)(window.localStorage || { getItem: function () { return null; }, setItem: function () { } }, prefs);
            }
            catch (_a) { }
        }
        catch (_b) { }
    };
    $scope.toggleTimelineBand = function (band) {
        try {
            if (!band)
                return;
            band._collapsed = !band._collapsed;
            var tl = $scope.dailyTally && $scope.dailyTally.timeline;
            if (tl && tl.bands) {
                try {
                    var prefs = (0, timelineUtils_1.captureCollapsePrefs)(tl.bands);
                    window._audTlPrefs = prefs;
                    (0, timelineUtils_1.saveTimelinePrefs)(window.localStorage || { getItem: function () { return null; }, setItem: function () { } }, prefs);
                }
                catch (_a) { }
            }
        }
        catch (_b) { }
    };
    // Timeline popup helpers
    function fmtLocal(ms, withSeconds) {
        var d = new Date(ms);
        var pad = function (n) { return ('0' + n).slice(-2); };
        return (d.getFullYear() +
            '-' +
            pad(d.getMonth() + 1) +
            '-' +
            pad(d.getDate()) +
            ' ' +
            pad(d.getHours()) +
            ':' +
            pad(d.getMinutes()) +
            (withSeconds ? ':' + pad(d.getSeconds()) : ''));
    }
    $scope.showTimelinePopup = function (sp, $event) {
        try {
            var tl_1 = $scope.dailyTally && $scope.dailyTally.timeline;
            if (!tl_1)
                return;
            var durSec = Math.max(0, Math.round((sp.end - sp.start) / 1000));
            var w = window;
            var vpW = w && w.innerWidth ? w.innerWidth : 1024;
            var vpH = w && w.innerHeight ? w.innerHeight : 768;
            var px = {
                left: ($event && ($event.clientX || $event.pageX)) || Math.round(vpW * 0.5),
                top: ($event && ($event.clientY || $event.pageY)) || Math.round(vpH * 0.3),
            };
            var panelW = 340, panelH = 200;
            var left = Math.max(8, Math.min(vpW - panelW - 8, px.left + 12));
            var top_1 = Math.max(8, Math.min(vpH - panelH - 8, px.top + 12));
            tl_1.popup = {
                show: true,
                left: left,
                top: top_1,
                span: sp,
                info: {
                    id: sp.id,
                    plane: sp.plane,
                    topic: sp.topic,
                    realm: sp.realm,
                    account: sp.account,
                    startLocal: fmtLocal(sp.start, true),
                    endLocal: fmtLocal(sp.end, true),
                    duration: $scope.formatDuration ? $scope.formatDuration(durSec) : durSec + 's',
                },
                loading: true,
            };
            // Close on ESC
            try {
                var handler = function (ev) {
                    if (ev.key === 'Escape') {
                        try {
                            $scope.$applyAsync(function () {
                                $scope.closeTimelinePopup();
                            });
                        }
                        catch (_a) { }
                    }
                };
                window.addEventListener('keydown', handler);
                tl_1._popupKeyHandler = handler;
            }
            catch (_a) { }
            // Fetch row details for preview
            try {
                if (personService.getRowById && sp.id) {
                    personService.getRowById(sp.id).then(function (response) {
                        try {
                            var ok = response && response.data && response.data.Result === 'OK' && response.data.Row;
                            var row = ok ? response.data.Row : null;
                            var body = row ? row.pnBody || '' : '';
                            var tag = row ? row.pnTopicGroup || '' : '';
                            tl_1.popup.info.preview = { tag: tag, body: '' + body };
                        }
                        finally {
                            tl_1.popup.loading = false;
                        }
                    }, function () {
                        tl_1.popup.loading = false;
                    });
                }
                else {
                    tl_1.popup.loading = false;
                }
            }
            catch (_b) {
                tl_1.popup.loading = false;
            }
        }
        catch (_c) { }
    };
    $scope.closeTimelinePopup = function () {
        try {
            var tl = $scope.dailyTally && $scope.dailyTally.timeline;
            if (tl && tl._popupKeyHandler) {
                try {
                    window.removeEventListener('keydown', tl._popupKeyHandler);
                }
                catch (_a) { }
                tl._popupKeyHandler = null;
            }
            if (tl) {
                tl.popup = null;
            }
        }
        catch (_b) { }
    };
    $scope.gotoTimelineSpan = function (openInNew) {
        try {
            var tl = $scope.dailyTally && $scope.dailyTally.timeline;
            if (!tl || !tl.popup || !tl.popup.span || !tl.popup.span.id)
                return;
            var id = tl.popup.span.id;
            if (openInNew) {
                try {
                    // Record view history before opening new tab (caption enriched after load if same session)
                    var span = tl.popup.span || {};
                    historyService.addViewEntry(id, '/view/pnid/' + id, {
                        taskGroup: span.taskGroup || span.task_group,
                        topicGroup: span.topic || span.topicGroup || span.topic_group,
                        bodyPreview: span.title || span.body,
                    });
                    $scope.history = historyService.getAllHistory();
                    window.open('/view/pnid/' + id, '_blank');
                }
                catch (_a) { }
            }
            else {
                historyService.addViewEntry(id, '/view/pnid/' + id, {
                    topicGroup: tl.popup.span && (tl.popup.span.topic || tl.popup.span.topicGroup),
                    bodyPreview: tl.popup.span && tl.popup.span.title,
                });
                $scope.history = historyService.getAllHistory();
                $scope.personSearch({ pnid: id });
            }
            $scope.closeTimelinePopup();
        }
        catch (_b) { }
    };
    // Build a scrollable 3-day timeline (prev day, core day, next day) in pixels
    function buildDayTimelineExtended(details, coreStartUTC, coreEndUTC) {
        if (!window._audTlPrefs) {
            try {
                window._audTlPrefs = (0, timelineUtils_1.loadTimelinePrefs)(window.localStorage || { getItem: function () { return null; }, setItem: function () { } });
            }
            catch (_a) {
                window._audTlPrefs = { collapse: {} };
            }
        }
        var _prefs = window._audTlPrefs;
        try {
            $scope.dailyTally.timeline = null;
        }
        catch (_b) { }
        var parseMs = function (s) {
            var d = new Date(s.replace(' ', 'T') + 'Z');
            return d.getTime();
        };
        var normalizePlane = function (p) {
            if (!p)
                return '';
            try {
                p = p.trim ? p.trim() : p;
            }
            catch (_a) { }
            var x = p.toLowerCase();
            if (x.indexOf('sess') === 0)
                return 'Session';
            if (x.indexOf('activ') === 0)
                return 'Activity';
            if (x.indexOf('trav') === 0)
                return 'Travel';
            if (x.indexOf('break') === 0)
                return 'Break';
            return p;
        };
        var coreStartMs = parseMs(coreStartUTC);
        var coreEndMs = parseMs(coreEndUTC);
        var dayMs = 24 * 60 * 60 * 1000;
        var extStartMs = coreStartMs - dayMs;
        var extEndMs = coreEndMs + dayMs;
        var clamp = function (t) { return Math.max(extStartMs, Math.min(extEndMs, t)); };
        var nowMs = Date.now();
        // map spans
        var spansAll = [];
        // Helper to detect if an activity should be a milestone vs a bar
        var isMilestone = function (topic, durationMs) {
            var topicLower = (topic || '').toLowerCase();
            var isVeryShort = durationMs < 5 * 60 * 1000; // < 5 minutes (more selective)
            // More specific milestone keywords - things that are truly point-in-time events
            var pointInTimeKeywords = [
                'pack up',
                'arrive',
                'departure',
                'check in',
                'check out',
                'pickup',
                'drop off',
                'complete',
                'done',
                'finish',
                'submit',
                'send',
                'receive',
                'message',
                'call',
                'email',
                'update',
                'review',
            ];
            // Keywords that should be bars, not milestones, even if short
            var shouldBeBarKeywords = ['start', 'begin', 'activity', 'session', 'break', 'lunch', 'meeting', 'work'];
            var hasPointInTimeKeyword = pointInTimeKeywords.some(function (keyword) { return topicLower.includes(keyword); });
            var hasShouldBeBarKeyword = shouldBeBarKeywords.some(function (keyword) { return topicLower.includes(keyword); });
            // Debug logging for milestone detection
            if (topicLower.includes('start') || topicLower.includes('38785')) {
                console.log('Milestone Debug - Topic Analysis:', {
                    topic: topic,
                    topicLower: topicLower,
                    durationMs: durationMs,
                    durationMinutes: Math.round(durationMs / (60 * 1000)),
                    isVeryShort: isVeryShort,
                    hasPointInTimeKeyword: hasPointInTimeKeyword,
                    hasShouldBeBarKeyword: hasShouldBeBarKeyword,
                    finalDecision: hasShouldBeBarKeyword
                        ? 'BAR (forced)'
                        : (isVeryShort && hasPointInTimeKeyword) || hasPointInTimeKeyword
                            ? 'MILESTONE'
                            : 'BAR (default)',
                });
            }
            // Only mark as milestone if it's very short AND has point-in-time keywords,
            // or if it has point-in-time keywords regardless of duration (but not if it should be a bar)
            if (hasShouldBeBarKeyword)
                return false; // Force these to be bars
            return hasPointInTimeKeyword; // Only point-in-time keywords become milestones
        };
        var mk = function (d) {
            // Wider field support (start/end) matching logic in single-day builder
            var startStr = d.startUTC || d.StartUTC || d.clipStartUTC || d.clipStart || d.pnCustomTimeUTC;
            var endStr = d.completedUTC || d.CompletedUTC || d.clipEndUTC || d.clipEnd || d.pnCompletedUTC;
            var s = clamp(parseMs(startStr));
            var rawE = parseMs(endStr);
            // For open activities, use a reasonable default duration instead of extending to now
            var e;
            if (isFinite(rawE)) {
                e = clamp(rawE);
            }
            else {
                // Open activity - default to 1 hour duration or extend to core day end, whichever is sooner
                var oneHourLater = s + 60 * 60 * 1000;
                var coreDayEnd = coreEndMs || s + 8 * 60 * 60 * 1000; // 8 hours max
                e = Math.min(oneHourLater, coreDayEnd, nowMs);
            }
            if (!(e > s))
                return null;
            var plane = normalizePlane((d.plane || d.taskGroup || '').toString());
            var topic = (d.topicGroup || d.pnTopicGroup || '') + (d.topicDetail ? '/' + d.topicDetail : '');
            var durationMs = e - s;
            return {
                id: d.ID || d.id,
                plane: plane,
                start: s,
                end: e,
                realm: d.realm || d.pnAssetRealm || '',
                account: d.account || d.pnAssetAccount || '',
                topic: topic,
                isMilestone: isMilestone(topic, durationMs),
                durationMs: durationMs,
            };
        };
        (details || []).forEach(function (d) {
            var sp = mk(d);
            if (sp)
                spansAll.push(sp);
        });
        // Debug logging for data processing
        console.log('Timeline Debug - Processing details:', {
            inputRecords: (details || []).length,
            validSpans: spansAll.length,
            sampleRecord: details && details[0]
                ? {
                    id: details[0].ID || details[0].id,
                    startUTC: details[0].startUTC || details[0].StartUTC || details[0].clipStartUTC,
                    endUTC: details[0].completedUTC || details[0].CompletedUTC || details[0].clipEndUTC,
                    topic: details[0].topicGroup || details[0].pnTopicGroup,
                    plane: details[0].plane || details[0].taskGroup,
                    isOpen: !(details[0].completedUTC || details[0].CompletedUTC || details[0].clipEndUTC),
                }
                : null,
            spansSample: spansAll.slice(0, 3).map(function (sp) { return ({
                id: sp.id,
                topic: sp.topic,
                plane: sp.plane,
                durationHours: (sp.durationMs / (60 * 60 * 1000)).toFixed(1),
                isMilestone: sp.isMilestone,
            }); }),
        });
        // Group travel activities into streams and separate milestones
        var byPlane = { Session: [], Activity: [], Travel: [], Break: [] };
        var milestones = [];
        var travelStreams = new Map();
        spansAll.forEach(function (sp) {
            if (sp.isMilestone) {
                milestones.push(sp);
            }
            else if (sp.plane === 'Travel') {
                // Group travel by realm+account to create streams
                var streamKey = "".concat(sp.realm, "/").concat(sp.account);
                if (!travelStreams.has(streamKey))
                    travelStreams.set(streamKey, []);
                travelStreams.get(streamKey).push(sp);
            }
            else {
                byPlane[sp.plane].push(sp);
            }
        });
        // Convert travel streams back to byPlane format
        travelStreams.forEach(function (spans, streamKey) {
            var _a;
            (_a = byPlane['Travel']).push.apply(_a, spans);
        });
        var layoutLanes = function (items) {
            var sorted = items.slice().sort(function (a, b) { return a.start - b.start || a.end - b.end; });
            var lanes = [];
            sorted.forEach(function (sp) {
                var placed = false;
                for (var i = 0; i < lanes.length; i++) {
                    var last = lanes[i][lanes[i].length - 1];
                    if (!last || last.end <= sp.start) {
                        lanes[i].push(sp);
                        placed = true;
                        break;
                    }
                }
                if (!placed)
                    lanes.push([sp]);
            });
            return lanes;
        };
        var pxPerHour = 80;
        var totalMs = Math.max(1, extEndMs - extStartMs);
        var toPx = function (ms) { return (ms / (60 * 60 * 1000)) * pxPerHour; };
        var bands = [];
        ['Session', 'Activity', 'Travel', 'Break'].forEach(function (name) {
            var lanes = layoutLanes(byPlane[name] || []);
            console.log("Timeline Debug - Band \"".concat(name, "\":"), {
                itemCount: (byPlane[name] || []).length,
                laneCount: lanes.length,
                items: (byPlane[name] || []).slice(0, 3).map(function (item) { return ({
                    id: item.id,
                    topic: item.topic,
                    durationMs: item.durationMs,
                }); }),
            });
            lanes.forEach(function (lane) {
                return lane.forEach(function (sp) {
                    sp.leftPx = toPx(sp.start - extStartMs);
                    sp.widthPx = Math.max(1, toPx(sp.end - sp.start));
                    sp.cls =
                        name === 'Session'
                            ? 'span-session'
                            : name === 'Activity'
                                ? 'span-activity'
                                : name === 'Travel'
                                    ? 'span-travel'
                                    : 'span-break';
                    var fmt = function (ms) {
                        var d = new Date(ms);
                        var pad = function (n) { return ('0' + n).slice(-2); };
                        return (d.getFullYear() +
                            '-' +
                            pad(d.getMonth() + 1) +
                            '-' +
                            pad(d.getDate()) +
                            ' ' +
                            pad(d.getHours()) +
                            ':' +
                            pad(d.getMinutes()));
                    };
                    sp.title =
                        '#' +
                            (sp.id || '') +
                            ' ' +
                            (sp.topic || name) +
                            ' [' +
                            fmt(sp.start) +
                            ' → ' +
                            fmt(sp.end) +
                            ']';
                });
            });
            var maxPreviewLanes = 8;
            bands.push({
                name: name,
                lanes: lanes,
                _collapsed: lanes.length > maxPreviewLanes,
                maxPreviewLanes: maxPreviewLanes,
                overflowCount: Math.max(0, lanes.length - maxPreviewLanes),
            });
        });
        // Create milestone band if we have milestones
        if (milestones.length > 0) {
            var milestoneLanes = layoutLanes(milestones);
            milestoneLanes.forEach(function (lane) {
                return lane.forEach(function (sp) {
                    sp.leftPx = toPx(sp.start - extStartMs);
                    sp.widthPx = Math.max(8, toPx(sp.end - sp.start)); // Minimum 8px for visibility
                    sp.cls = 'span-milestone';
                    var fmt = function (ms) {
                        var d = new Date(ms);
                        var pad = function (n) { return ('0' + n).slice(-2); };
                        return (d.getFullYear() +
                            '-' +
                            pad(d.getMonth() + 1) +
                            '-' +
                            pad(d.getDate()) +
                            ' ' +
                            pad(d.getHours()) +
                            ':' +
                            pad(d.getMinutes()));
                    };
                    sp.title = '📍 ' + (sp.topic || 'Milestone') + ' [' + fmt(sp.start) + ' → ' + fmt(sp.end) + ']';
                });
            });
            // Insert milestone band at the beginning
            bands.unshift({
                name: 'Milestones',
                lanes: milestoneLanes,
                _collapsed: false,
                maxPreviewLanes: 8,
                overflowCount: 0,
            });
        }
        // ticks per hour across extended window (local time)
        var ticks = [];
        var hours = Math.ceil(totalMs / (60 * 60 * 1000));
        var firstTickLocal = new Date(extStartMs);
        firstTickLocal.setMinutes(0, 0, 0); // Align to hour boundary
        for (var h = 0; h <= hours; h++) {
            var tickLocal = new Date(firstTickLocal.getTime() + h * 60 * 60 * 1000);
            var tMs = tickLocal.getTime();
            var label = ('0' + tickLocal.getHours()).slice(-2) + ':00';
            ticks.push({ px: toPx(tMs - extStartMs), label: label });
        }
        var highlightLeftPx = toPx(coreStartMs - extStartMs);
        var highlightWidthPx = toPx(coreEndMs - coreStartMs);
        var widthPx = Math.ceil(toPx(totalMs));
        try {
            (0, timelineUtils_1.applyCollapsePrefs)(bands, _prefs);
        }
        catch (_c) { }
        var nowIndicator = { px: toPx(nowMs - extStartMs), label: 'NOW' };
        $scope.dailyTally.timeline = {
            mode: 'extended',
            pxPerHour: pxPerHour,
            startMs: extStartMs,
            endMs: extEndMs,
            widthPx: widthPx,
            bands: bands,
            ticks: ticks,
            highlightLeftPx: highlightLeftPx,
            highlightWidthPx: highlightWidthPx,
            nowIndicator: nowIndicator,
        };
        // Debug timeline visibility conditions
        console.log('Timeline Debug - Timeline object created:', {
            mode: 'extended',
            showTimeline: $scope.viewMode.showTimeline,
            showDetails: $scope.viewMode.showDetails,
            bandsCount: bands.length,
            widthPx: widthPx,
            timelineExists: !!$scope.dailyTally.timeline,
        });
        // Final verification of timeline state
        setTimeout(function () {
            var _a, _b, _c;
            console.log('Timeline Debug - Final state check:', {
                showTimeline: $scope.viewMode.showTimeline,
                timelineExists: !!$scope.dailyTally.timeline,
                timelineMode: (_a = $scope.dailyTally.timeline) === null || _a === void 0 ? void 0 : _a.mode,
                bandsCount: (_c = (_b = $scope.dailyTally.timeline) === null || _b === void 0 ? void 0 : _b.bands) === null || _c === void 0 ? void 0 : _c.length,
                domElement: document.querySelector('aud-timeline') ? 'FOUND' : 'NOT FOUND',
                wrapperDiv: document.querySelector('[ng-if*="showTimeline"]') ? 'FOUND' : 'NOT FOUND',
            });
            // Set timeline visibility when timeline is built
            try {
                $scope.viewMode.showTimeline = true;
            }
            catch (_d) { }
            // Try to center core day highlight in view on next digest
            try {
                $scope.$$postDigest(function () {
                    try {
                        var wrap = document.getElementById('daily-timeline-scroll');
                        if (!wrap)
                            return;
                        var targetCenter = highlightLeftPx + highlightWidthPx / 2;
                        var desired = Math.max(0, targetCenter - wrap.clientWidth / 2);
                        wrap.scrollLeft = desired;
                    }
                    catch (_a) { }
                });
            }
            catch (_e) { }
        });
    }
    // Find stale open rows for cleanup
    $scope.loadStaleOpen = function () {
        var _a;
        try {
            $scope.stale = { loading: true, rows: [] };
        }
        catch (_b) { }
        var mineOnlyFlag = !!((_a = $scope.viewMode.tallyMineOnly) !== null && _a !== void 0 ? _a : true);
        var olderThanHours = parseInt(($scope.viewMode.tallyOpenHrs || 24), 10); // reuse selection as a starting point
        if (personService.getStaleOpen) {
            return personService
                .getStaleOpen({ olderThanHours: olderThanHours, mineOnly: mineOnlyFlag ? 1 : 0 })
                .then(function (resp) {
                if (resp && resp.data && resp.data.Result === 'OK') {
                    $scope.stale = {
                        loading: false,
                        rows: resp.data.rows || [],
                        olderThanHours: resp.data.olderThanHours,
                    };
                }
            })
                .finally(function () {
                try {
                    $scope.stale.loading = false;
                }
                catch (_a) { }
            });
        }
    };
    // Mark a row to close at the next timestamp and refresh
    $scope.markCloseAtNext = function (r) {
        if (!r || !r.ID)
            return;
        var ok = $scope.confirm('Close this row at next timestamp?');
        if (!ok)
            return;
        return pilotNotesSyncService
            .setTime(r.ID, { endFromNext: true })
            .then(function () {
            try {
                $scope.loadStaleOpen();
            }
            catch (_a) { }
            try {
                var d = $scope.viewMode.tallyDate;
                $scope.fetchTally(d instanceof Date ? d.toISOString().slice(0, 10) : undefined);
            }
            catch (_b) { }
        })
            .catch(function (err) {
            try {
                $scope.toast((err && err.message) || 'Could not set end', 'danger', 5000);
            }
            catch (_a) { }
        });
    };
    // Apply suggested auto end to actual pnCompletedUTC
    $scope.applyAutoEnd = function (r) {
        if (!r || !r.ID)
            return;
        return $scope
            .postURI(config.basePath + 'api1.php?json=post', { action: 'updateRow', rowArray: { ID: r.ID, __applyAutoEnd: 1 } }, null)
            .then(function () {
            try {
                var d = $scope.viewMode.tallyDate;
                $scope.fetchTally(d instanceof Date ? d.toISOString().slice(0, 10) : undefined);
            }
            catch (_a) { }
        });
    };
    // Clear suggested auto end values
    $scope.clearAutoEnd = function (r) {
        if (!r || !r.ID)
            return;
        return $scope
            .postURI(config.basePath + 'api1.php?json=post', { action: 'updateRow', rowArray: { ID: r.ID, __clearAutoEnd: 1 } }, null)
            .then(function () {
            try {
                var d = $scope.viewMode.tallyDate;
                $scope.fetchTally(d instanceof Date ? d.toISOString().slice(0, 10) : undefined);
            }
            catch (_a) { }
        });
    };
    // Clear manual completed fields
    $scope.clearCompleted = function (r) {
        if (!r || !r.ID)
            return;
        var ok = $scope.confirm('Clear manual end time so it can be re-applied?');
        if (!ok)
            return;
        return $scope
            .postURI(config.basePath + 'api1.php?json=post', { action: 'updateRow', rowArray: { ID: r.ID, __clearCompleted: 1 } }, null)
            .then(function () {
            try {
                var d = $scope.viewMode.tallyDate;
                $scope.fetchTally(d instanceof Date ? d.toISOString().slice(0, 10) : undefined);
            }
            catch (_a) { }
        });
    };
    // Quick helper to open edit pane for a given ID via search
    // (do not force hide-done — completed root notes must still open)
    $scope.editById = function (id) {
        if (!id)
            return;
        $scope.personSearch({ pnid: id });
    };
    function startOfWeek(d) {
        var x = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
        // Convert to local midnight while keeping date parts
        var dow = x.getUTCDay(); // 0=Sun .. 6=Sat
        // Use Monday as start; compute diff to Monday (1)
        var diff = dow === 0 ? -6 : 1 - dow;
        x.setUTCDate(x.getUTCDate() + diff);
        return new Date(Date.UTC(x.getUTCFullYear(), x.getUTCMonth(), x.getUTCDate()));
    }
    $scope.fetchWeekTally = function (dateStr) {
        var _a;
        return tallyService.fetchWeekTally(dateStr ? new Date(dateStr + 'T00:00:00') : $scope.viewMode.tallyDate || new Date(), !!((_a = $scope.viewMode.tallyMineOnly) !== null && _a !== void 0 ? _a : true), parseInt(($scope.viewMode.tallyOpenHrs || 24), 10), $scope.dailyTally);
    };
    // Build a synthetic week timeline (aggregate all day details fetched individually)
    $scope.buildWeekTimeline = function () {
        return tallyService.buildWeekTimeline($scope.dailyTally);
    };
    // Minimal timeline mode watcher
    try {
        $scope.$watch('viewMode.minimalTimeline', function (v) {
            if (v) {
                try {
                    $scope.viewMode.showDetails = false;
                }
                catch (_a) { }
            }
        });
    }
    catch (_f) { }
    // Step tally date by +/-1 day or week depending on mode; 0 = today
    $scope.stepTally = function (delta) {
        try {
            var vm_1 = $scope.viewMode || {};
            var d = void 0;
            if (delta === 0) {
                d = new Date();
            }
            else {
                var base = vm_1.tallyDate instanceof Date ? new Date(vm_1.tallyDate.getTime()) : new Date();
                var isWeek = (vm_1.tallyMode || 'day') === 'week';
                var stepDays = isWeek ? 7 : 1;
                base.setDate(base.getDate() + stepDays * (delta || 0));
                d = base;
            }
            vm_1.tallyDate = d;
            $scope.fetchTally(localDateStr(d));
        }
        catch (e) {
            try {
                $scope.fetchTally(localDateStr(new Date()));
            }
            catch (_a) { }
        }
    };
    // From week view: jump to a specific day and search its detail records
    $scope.goToDayAndSearch = function (dateStr) {
        try {
            // Switch to day mode and persist
            $scope.viewMode.tallyMode = 'day';
            try {
                window.localStorage && window.localStorage.setItem('audroam.tally.mode', 'day');
            }
            catch (_a) { }
            // Set date and fetch day tally
            if (dateStr && /^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
                var d = new Date(dateStr + 'T00:00:00');
                $scope.viewMode.tallyDate = d;
                $scope.fetchTally(dateStr);
                // Run a search for that day, honoring mine-only
                var args = {
                    d1: dateStr + ' 00:00:00',
                    d2: dateStr + ' 23:59:59',
                    done: 0,
                };
                try {
                    if ($scope.viewMode.tallyMineOnly) {
                        args.my = 1;
                    }
                }
                catch (_b) { }
                $scope.personSearch(args);
            }
            else {
                // Fallback to today
                $scope.stepTally(0);
            }
        }
        catch (_c) { }
    };
    // provide access to these hacked-together functions
    $scope.debugIFrame = iframeUtil.debugIFrame;
    $scope.submitFormToIFrame = function (xForm, xFrame, xMsg, xType, row) {
        $scope.viewMode.progress_1 = {
            done: false,
            show: false,
            max: 100,
            value: 0,
        };
        // disable the 2nd progress timeout
        console.log('cancelling updateProgressTimeout2ID', updateProgressTimeout2ID);
        updateProgressTimeout2ID && $interval.cancel(updateProgressTimeout2ID);
        updateProgressTimeout2ID = undefined;
        // start monitoring progress
        $scope.viewMode.updateProgressEnabled = true;
        $timeout.cancel(updateProgressTimeout1ID);
        $scope.updateProgress();
        row.uploading = true;
        // submit the form
        iframeUtil.submitFormToIFrame(xForm, xFrame, xMsg);
    };
    $scope.fetchRecentOnly = function () {
        // Report/search/view: never fetch or spawn Recent after Start / seal
        if (!isRecentUiEnabled()) {
            return false;
        }
        $scope.viewMode.Message = '...';
        // Mutations (set-time / backdate / end-from-next) go through Python while PHP
        // still serves cached recent. Force-invalidate so the next bind is not stale.
        var prevForce = $scope.viewMode.recentForce;
        $scope.viewMode.recentForce = true;
        return personService
            .fetchRecent($scope.viewMode)
            .then(function (response) {
            var _a, _b;
            if (response.data.Result == 'OK') {
                $scope.viewMode.Message = 'OK';
                $scope.recentRows = response.data.recent;
                try {
                    var now = Date.now();
                    if (Array.isArray(response.data.recent)) {
                        for (var _i = 0, _c = response.data.recent; _i < _c.length; _i++) {
                            var r = _c[_i];
                            if (r && r.pnCustomTimeUTC) {
                                (0, localRowPatch_1.recomputeDerivedTimeFields)(r, now);
                            }
                        }
                    }
                }
                catch (_d) { }
                try {
                    if (typeof $scope.refreshThreadPills === 'function') {
                        $scope.refreshThreadPills();
                    }
                }
                catch (_e) { }
                // Focus T/S + account/realm from person_focus_state (via recent payload)
                // also stamps missing pnFlowKind on recent rows for time menus
                try {
                    applyFocusStatePayload(response.data);
                }
                catch (_f) { }
                // If cache still returned old row, re-stamp our short-lived local patch
                try {
                    (_b = (_a = $scope).reapplyRememberedLocalPatches) === null || _b === void 0 ? void 0 : _b.call(_a);
                }
                catch (_g) { }
                cacheRecentFromResponse(response);
                // Fan-out compact Recent view on focus stream for peer tabs/devices
                publishRecentViewDigestFromPayload(response.data);
            }
            else if (response.data.Result == 'AUTH ERROR') {
                $scope.person = null;
                $scope.setPerson();
            }
            else if (offlineDataService.shouldUseLocalFallback(response)) {
                $scope.viewMode.serverUnreachable = true;
                restoreRecentFromLocalCache();
            }
        })
            .finally(function () {
            $scope.viewMode.recentForce = prevForce;
        });
    };
    // fetch recent dropdown
    $scope.fetchRecentDropdown = function () {
        personService.getParentList().then(function (result) {
            $scope.recentDropdown = result;
        });
    };
    // Lightweight toast notifications
    var toastSeq = 1;
    try {
        $scope.viewMode.toasts = $scope.viewMode.toasts || [];
    }
    catch (_g) { }
    $scope.toast = function (text, type, timeoutMs) {
        var id = toastSeq++;
        var t = { id: id, text: text, type: type || 'info' };
        try {
            $scope.viewMode.toasts.push(t);
        }
        catch (_a) { }
        var ms = timeoutMs === undefined || timeoutMs === null ? 4000 : timeoutMs;
        if (ms > 0) {
            $timeout(function () {
                $scope.closeToast(id);
            }, ms);
        }
        return id;
    };
    $scope.closeToast = function (id) {
        try {
            var arr = $scope.viewMode.toasts || [];
            for (var i = 0; i < arr.length; i++) {
                if (arr[i] && arr[i].id === id) {
                    arr.splice(i, 1);
                    break;
                }
            }
        }
        catch (_a) { }
    };
    var stopHistoryReconnectToast = $rootScope.$on('history:sseReconnected', function (event, data) {
        var reason = data && data.reason ? " (".concat(data.reason, ")") : '';
        $scope.toast("History stream reconnected".concat(reason), 'info', 2500);
    });
    // Services (e.g. personService allowlist) broadcast toasts without $scope access
    var stopUiToast = $rootScope.$on('ui:toast', function (_event, data) {
        if (data && data.text) {
            $scope.toast(data.text, data.type || 'info', data.timeoutMs);
        }
    });
    $scope.$on('$destroy', function () {
        stopHistoryReconnectToast();
        stopUiToast();
    });
    (0, rowSplitScopeActions_1.registerRowSplitScopeActions)($scope, splitService);
    (0, rowApplyScopeActions_1.registerRowApplyScopeActions)($scope, personService, pilotNotesSyncService, $timeout);
    (0, rowPromoteScopeActions_1.registerRowPromoteScopeActions)($scope, pilotNotesSyncService);
    (0, threadScopeActions_1.registerThreadScopeActions)($scope, {
        historyService: historyService,
        threadsApi: threadsApiService,
        $q: $q,
        $timeout: function (fn, delay) { return $timeout(fn, delay); },
    });
    // Manual user-triggered refresh: force server to regenerate cache
    // Only when Recent UI is enabled and (when possible) the panel is on-screen.
    $scope.refreshRecent = function () {
        if (!isRecentUiEnabled()) {
            return false;
        }
        try {
            var el = document.getElementById('recent-container');
            if (el) {
                var style = $window.getComputedStyle
                    ? $window.getComputedStyle(el)
                    : null;
                if (style && (style.display === 'none' || style.visibility === 'hidden')) {
                    return false;
                }
            }
        }
        catch (_a) {
            /* visibility check best-effort */
        }
        try {
            $scope.viewMode.recentForce = true;
        }
        catch (_b) { }
        var p = $scope.fetchRecent();
        if (p && typeof p.then === 'function') {
            p.finally(function () {
                try {
                    $scope.viewMode.recentForce = undefined;
                }
                catch (_a) { }
            });
        }
        else {
            try {
                $scope.viewMode.recentForce = undefined;
            }
            catch (_c) { }
        }
        return p;
    };
    // Session envelope (Focus S) via Python /api/v2/focus/*
    // No "Shift" topic stamps — flexible work/study/make; commercial T&A later if needed.
    // startShift kept as thin alias for older tests only (prefer startSession).
    $scope.startSession = function () {
        try {
            $scope.viewMode.sessionActionLoading = true;
        }
        catch (_a) { }
        return pilotNotesSyncService
            .startFocusS({
            taskGroup: 'Session',
            topicGroup: '',
            topicDetail: 'Start',
        })
            .then(function (data) {
            var _a, _b;
            applyFocusStatePayload(data);
            try {
                (_b = (_a = $scope).toast) === null || _b === void 0 ? void 0 : _b.call(_a, data.reused
                    ? "Session (S) already open #".concat(data.ID)
                    : "Started session (S) #".concat(data.ID), 'success', 3000);
            }
            catch (_c) { }
            return $scope.fetchRecentOnly ? $scope.fetchRecentOnly() : $scope.fetchRecent();
        })
            .then(function () {
            try {
                $scope.viewMode.sessionActionLoading = false;
            }
            catch (_a) { }
        }, function (err) {
            var _a, _b;
            try {
                $scope.viewMode.sessionActionLoading = false;
                (_b = (_a = $scope).toast) === null || _b === void 0 ? void 0 : _b.call(_a, (err && err.message) || 'Start session failed', 'danger', 5000);
            }
            catch (_c) { }
        });
    };
    $scope.startShift = $scope.startSession;
    /**
     * Live elapsed for openMeta / sessionMeta — pure client clock.
     * Prefer startedUTC (absolute); fall back to openForSec + snapshot age.
     */
    $scope.liveMetaOpenSec = function (meta) {
        var _a, _b;
        if (!meta || !meta.openId)
            return 0;
        var now = $scope.nowTs || Date.now();
        var startMs = meta.startedUTC ? (0, localRowPatch_1.parseUtcMs)(meta.startedUTC) : null;
        if (startMs != null) {
            return Math.max(0, (now - startMs) / 1000);
        }
        var base = meta.openForSec || 0;
        var gen = ((_a = $scope.viewMode) === null || _a === void 0 ? void 0 : _a.recentGeneratedAtMs) ||
            ((_b = $scope.viewMode) === null || _b === void 0 ? void 0 : _b.recentLastAt) ||
            now;
        var extra = now > gen ? (now - gen) / 1000 : 0;
        return base + extra;
    };
    $scope.liveMetaDuration = function (meta) {
        if (!meta || !meta.openId)
            return '—';
        return $scope.formatDuration($scope.liveMetaOpenSec(meta));
    };
    /**
     * Focus T/S open longer than threshold — treat as stale stamp risk, not trusted duration.
     * Defaults: T 4h, S 12h (overridable via viewMode.focusStaleTSec / focusStaleSSec).
     */
    $scope.isFocusStale = function (meta, kind) {
        var _a, _b;
        if (kind === void 0) { kind = 'T'; }
        if (!meta || !meta.openId)
            return false;
        var sec = $scope.liveMetaOpenSec(meta);
        var tLimit = Number((_a = $scope.viewMode) === null || _a === void 0 ? void 0 : _a.focusStaleTSec) || 4 * 3600;
        var sLimit = Number((_b = $scope.viewMode) === null || _b === void 0 ? void 0 : _b.focusStaleSSec) || 12 * 3600;
        return (0, focusTimeHelpers_1.isFocusMetaStale)(sec, kind, tLimit, sLimit);
    };
    $scope.liveIdleDuration = function () {
        var _a, _b;
        var idle = $scope.idleMeta;
        var now = $scope.nowTs || Date.now();
        if (idle && idle.idleSinceUTC) {
            var startMs = (0, localRowPatch_1.parseUtcMs)(idle.idleSinceUTC);
            if (startMs != null) {
                return $scope.formatDuration(Math.max(0, (now - startMs) / 1000));
            }
        }
        if (idle && typeof idle.idleForSec === 'number') {
            var gen = ((_a = $scope.viewMode) === null || _a === void 0 ? void 0 : _a.recentGeneratedAtMs) ||
                ((_b = $scope.viewMode) === null || _b === void 0 ? void 0 : _b.recentLastAt) ||
                now;
            var extra = now > gen ? (now - gen) / 1000 : 0;
            return $scope.formatDuration((idle.idleForSec || 0) + extra);
        }
        return $scope.formatDuration(0);
    };
    /** Display duration for a recent row: live tick if open, else server/static Duration. */
    $scope.liveRowDuration = function (row) {
        if (!row)
            return '';
        if ($scope.isRowOpen && $scope.isRowOpen(row) && row.pnCustomTimeUTC) {
            var startMs = (0, localRowPatch_1.parseUtcMs)(row.pnCustomTimeUTC);
            if (startMs != null) {
                var now = $scope.nowTs || Date.now();
                return $scope.formatDuration(Math.max(0, (now - startMs) / 1000));
            }
        }
        return row.Duration != null ? String(row.Duration) : '';
    };
    /** Synthetic row handle for focus-card actions (applyAction only needs ID for set-time). */
    $scope.focusRowRef = function (meta) {
        if (!meta || !meta.openId)
            return null;
        return { ID: meta.openId };
    };
    /**
     * Row-like for Focus-card stop/seal (5m / 1h / next / unlink).
     * Prefer the live recent row when present (real pnFlowKind).
     * Otherwise synthesize from openMeta/sessionMeta — must include flowKind S|T
     * or stopOpenTimer rejects with "Not a time-tracking row".
     */
    $scope.focusTimerRow = function (meta) {
        if (!meta || !meta.openId)
            return null;
        var id = Number(meta.openId);
        try {
            var rows = $scope.recentRows;
            if (Array.isArray(rows)) {
                for (var i = 0; i < rows.length; i++) {
                    var r = rows[i];
                    if (r && Number(r.ID) === id) {
                        // Ensure S|T stamp for menus even if recent payload omitted it
                        if (!(0, focusTimeHelpers_1.isTimeTrackingRow)(r)) {
                            var fromMeta = meta.flowKind != null && String(meta.flowKind).trim() !== ''
                                ? String(meta.flowKind).trim().toUpperCase()
                                : null;
                            if (fromMeta === 'T' || fromMeta === 'S') {
                                r.pnFlowKind = fromMeta;
                            }
                        }
                        return r;
                    }
                }
            }
        }
        catch (_a) {
            /* fall through to synthetic */
        }
        var fkRaw = meta.flowKind;
        var fk = fkRaw != null && String(fkRaw).trim() !== ''
            ? String(fkRaw).trim().toUpperCase()
            : 'T'; // Focus activity tile = T; sessionMeta should pass flowKind S
        return {
            ID: meta.openId,
            pnFlowKind: fk,
            flowKind: fk,
            pnCustomTimeUTC: meta.startedUTC || null,
            LocalTime: meta.startedUTC
                ? new Date((0, localRowPatch_1.parseUtcMs)(meta.startedUTC) || 0).toLocaleTimeString(undefined, {
                    hour: '2-digit',
                    minute: '2-digit',
                })
                : null,
        };
    };
    $scope.editFocusRow = function (meta) {
        if (!meta || !meta.openId)
            return;
        $scope.activeSearch({ pnid: meta.openId }, meta.openId, null);
    };
    $scope.focusBackdateTimes = [
        { caption: '1', mins: 1 },
        { caption: '2', mins: 2 },
        { caption: '5', mins: 5 },
        { caption: '15', mins: 15 },
    ];
    /**
     * Stamp pnFlowKind on recent rows when the server omitted it but Focus meta
     * (or an alternate key) tells us the row is S|T. Time-tracking menus/actions
     * require explicit row.pnFlowKind — not openMeta alone.
     */
    function enrichRecentRowsFlowKind(rows, openMeta, sessionMeta) {
        if (!Array.isArray(rows) || !rows.length)
            return;
        var tId = openMeta && openMeta.openId != null && openMeta.openId !== ''
            ? Number(openMeta.openId)
            : null;
        var sId = sessionMeta && sessionMeta.openId != null && sessionMeta.openId !== ''
            ? Number(sessionMeta.openId)
            : null;
        for (var i = 0; i < rows.length; i++) {
            var r = rows[i];
            if (!r || r.ID == null)
                continue;
            // Prefer canonical field; accept aliases if present on the payload
            if (r.pnFlowKind == null || r.pnFlowKind === '') {
                var alt = r.flowKind != null ? r.flowKind : r.flow_kind;
                if (alt != null && String(alt).trim() !== '') {
                    r.pnFlowKind = String(alt).trim().toUpperCase();
                }
            }
            if (r.pnFlowKind != null && String(r.pnFlowKind).trim() !== '') {
                r.pnFlowKind = String(r.pnFlowKind).trim().toUpperCase();
                continue;
            }
            var id = Number(r.ID);
            if (tId != null && !isNaN(tId) && id === tId) {
                r.pnFlowKind = 'T';
            }
            else if (sId != null && !isNaN(sId) && id === sId) {
                r.pnFlowKind = 'S';
            }
        }
    }
    /**
     * Apply server focus payload onto scope.
     * Source of truth for Focus T/S meta and focus account/realm is person_focus_state
     * (via /api/v2/focus/* or PHP recent openMeta/sessionMeta) — not a separate client
     * setCurrentRealm write. When account/realm change, also record local focus history
     * (unless recordHistory: false — peer digest apply must not re-publish empty digests).
     */
    function applyFocusStatePayload(data, opts) {
        if (!data)
            return;
        var recordHistory = (opts === null || opts === void 0 ? void 0 : opts.recordHistory) !== false;
        try {
            if (data.openMeta !== undefined) {
                $scope.openMeta = data.openMeta;
            }
            if (data.sessionMeta !== undefined) {
                $scope.sessionMeta = data.sessionMeta;
            }
            if (data.idleMeta !== undefined) {
                $scope.idleMeta = data.idleMeta;
            }
            // Keep recent/search rows aligned with Focus so menus show T/S actions
            try {
                enrichRecentRowsFlowKind($scope.recentRows, $scope.openMeta, $scope.sessionMeta);
                if (Array.isArray(data.recent)) {
                    enrichRecentRowsFlowKind(data.recent, $scope.openMeta, $scope.sessionMeta);
                }
                if (Array.isArray($scope.reportResult)) {
                    enrichRecentRowsFlowKind($scope.reportResult, $scope.openMeta, $scope.sessionMeta);
                }
            }
            catch (_a) {
                /* ignore */
            }
            // Server signal: focus context account/realm (top-level or nested meta)
            var prevCtx = appEventsService.buildFocusContext('before_focus_payload', focusHost());
            var _b = (0, focusTimeHelpers_1.extractFocusAccountRealmFromPayload)(data), account = _b.account, realm = _b.realm;
            if (account && $scope.person) {
                var prevAcct = $scope.person.CurrentAccount;
                var prevRealm = $scope.person.CurrentRealm;
                $scope.person.CurrentAccount = account;
                if (realm) {
                    $scope.person.CurrentRealm = realm;
                }
                // Local realm-history stream when focus context moves (not peer digest apply)
                if (recordHistory &&
                    (account !== prevAcct || (realm && realm !== prevRealm))) {
                    try {
                        if (account && realm) {
                            historyService.addFocusEntry(realm, account);
                        }
                    }
                    catch (_c) {
                        /* ignore */
                    }
                }
            }
            // Reset live duration baseline so openForSec + tick stay coherent
            $scope.viewMode.recentGeneratedAtMs = Date.now();
            $scope.viewMode.recentLastAt = Date.now();
            $scope.$applyAsync();
            appEventsService.emitFocusContextIfChanged('focus_payload', focusHost(), prevCtx);
        }
        catch (_d) { }
    }
    /**
     * Point Focus T at this existing row (orphan open timer, or resume completed work).
     * Python POST /api/v2/focus/adopt-t — does not insert a new note.
     */
    $scope.adoptFocusTFromRow = function (row, callback) {
        var _a, _b, _c, _d, _e, _f;
        if (!row || !row.ID) {
            try {
                (_b = (_a = $scope).toast) === null || _b === void 0 ? void 0 : _b.call(_a, 'Cannot adopt: missing row', 'danger', 4000);
            }
            catch (_g) { }
            return $q.reject(new Error('missing row'));
        }
        // Only flowKind T may become current Focus task (use Time tracking → Mark as Task first)
        if (!(0, focusTimeHelpers_1.canAdoptAsFocusT)(row, ((_d = (_c = $scope).focusPointerIds) === null || _d === void 0 ? void 0 : _d.call(_c)) || null)) {
            try {
                (_f = (_e = $scope).toast) === null || _f === void 0 ? void 0 : _f.call(_e, 'Mark as current task only applies to Task (T) rows — stamp flowKind T first', 'warning', 5000);
            }
            catch (_h) { }
            return $q.reject(new Error('not flowKind T'));
        }
        var reopen = (0, focusTimeHelpers_1.adoptNeedsReopen)(row);
        if (reopen) {
            var ok = $window.confirm('Clear finish time and mark this row as your current Focus T?\n\n' +
                'Done-by and end time will be cleared so you can resume.');
            if (!ok) {
                return $q.reject(new Error('cancelled'));
            }
        }
        try {
            $scope.viewMode.sessionActionLoading = true;
        }
        catch (_j) { }
        return pilotNotesSyncService
            .adoptFocusT(Number(row.ID), { reopen: reopen, closePrevious: true })
            .then(function (data) {
            var _a, _b;
            applyFocusStatePayload(data);
            // Reflect reopened fields on the local row immediately
            if (reopen) {
                try {
                    row.pnCompletedUTC = null;
                    row.pnCompletedPersonPK = null;
                    row.CompletedUTC = null;
                }
                catch (_c) { }
            }
            try {
                (_b = (_a = $scope).toast) === null || _b === void 0 ? void 0 : _b.call(_a, data.closedTId
                    ? "Current task #".concat(data.ID, " (closed prior T #").concat(data.closedTId, ")")
                    : data.reopened
                        ? "Resumed as Focus T #".concat(data.ID)
                        : "Marked as current task #".concat(data.ID), 'success', 4000);
            }
            catch (_d) { }
            if (typeof callback === 'function') {
                callback();
            }
            else if ($scope.fetchRecentOnly) {
                try {
                    $scope.fetchRecentOnly();
                }
                catch (_e) { }
            }
            else {
                refreshRecentAfterMutation(100);
            }
            return data;
        })
            .catch(function (err) {
            var _a, _b;
            if (String((err === null || err === void 0 ? void 0 : err.message) || err) === 'cancelled') {
                return $q.reject(err);
            }
            try {
                (_b = (_a = $scope).toast) === null || _b === void 0 ? void 0 : _b.call(_a, "Adopt failed: ".concat((err === null || err === void 0 ? void 0 : err.message) || err), 'danger', 6000);
            }
            catch (_c) { }
            return $q.reject(err);
        })
            .finally(function () {
            try {
                $scope.viewMode.sessionActionLoading = false;
            }
            catch (_a) { }
        });
    };
    /**
     * Start Focus T via Python /api/v2/focus/start-t (person_focus_state ownership).
     * Used by recent/result-row Start buttons — does not go through PHP auditRow.
     */
    $scope.startFocusTFromRow = function (row, callback) {
        var _a, _b;
        if (!row || !row.ID) {
            try {
                (_b = (_a = $scope).toast) === null || _b === void 0 ? void 0 : _b.call(_a, 'Cannot start: missing row', 'danger', 4000);
            }
            catch (_c) { }
            return $q.reject(new Error('missing row'));
        }
        try {
            $scope.viewMode.sessionActionLoading = true;
        }
        catch (_d) { }
        var _e = (0, focusTimeHelpers_1.resolveFocusAccountRealm)(row), focusAccount = _e.account, focusRealm = _e.realm;
        return pilotNotesSyncService
            .startFocusT({
            parentId: row.ID,
            taskGroup: 'Activity',
            topicGroup: 'Start',
            assetTag: row.pnAssetTag,
            assetTagAux: row.pnAssetTagAux,
            assetAccount: focusAccount,
            assetRealm: focusRealm,
            account: focusAccount,
            realm: focusRealm,
            itemCode: row.pnItemCode,
        })
            .then(function (data) {
            var _a, _b;
            // Server openMeta/sessionMeta (+ account/realm) drive Focus card + Current*
            applyFocusStatePayload(data);
            try {
                var ctx = (0, focusTimeHelpers_1.extractFocusAccountRealmFromPayload)(data);
                var msg = data.closedTId
                    ? "Started T #".concat(data.ID, " (closed prior #").concat(data.closedTId, ")")
                    : "Started Focus T #".concat(data.ID);
                if (data.rolledUp) {
                    var p = data.parentId;
                    msg += p
                        ? " \u00B7 peer under #".concat(p, " (not nested under T)")
                        : ' · peer (rolled up from prior T)';
                }
                if (ctx.account) {
                    msg += " \u00B7 ".concat(ctx.account).concat(ctx.realm ? ' / ' + ctx.realm : '');
                }
                (_b = (_a = $scope).toast) === null || _b === void 0 ? void 0 : _b.call(_a, msg, 'success', 5000);
            }
            catch (_c) { }
            // Reconcile recent list (new T + closed prior) without waiting for poll
            if (typeof callback === 'function') {
                callback();
            }
            else if ($scope.fetchRecentOnly) {
                try {
                    $scope.fetchRecentOnly();
                }
                catch (_d) { }
            }
            else {
                refreshRecentAfterMutation(100);
            }
            return data;
        })
            .catch(function (err) {
            var _a, _b;
            try {
                (_b = (_a = $scope).toast) === null || _b === void 0 ? void 0 : _b.call(_a, "Start focus failed: ".concat((err === null || err === void 0 ? void 0 : err.message) || err), 'danger', 6000);
            }
            catch (_c) { }
            return $q.reject(err);
        })
            .finally(function () {
            try {
                $scope.viewMode.sessionActionLoading = false;
            }
            catch (_a) { }
        });
    };
    /**
     * Soft refresh Focus card meta from Python (does not replace recent rows).
     * Single-flight + short cooldown so View here / stream / visibility cannot stack
     * two GET /api/v2/focus/state in the same tick.
     */
    var focusStateInFlight = null;
    var lastFocusStateFetchAt = 0;
    var FOCUS_STATE_COOLDOWN_MS = 1500;
    $scope.refreshFocusState = function (opts) {
        var force = !!(opts && opts.force);
        if (focusStateInFlight) {
            return focusStateInFlight;
        }
        var now = Date.now();
        if (!force && lastFocusStateFetchAt && now - lastFocusStateFetchAt < FOCUS_STATE_COOLDOWN_MS) {
            return $q.when({
                Result: 'OK',
                openMeta: $scope.openMeta,
                sessionMeta: $scope.sessionMeta,
                idleMeta: $scope.idleMeta,
                skipped: true,
            });
        }
        lastFocusStateFetchAt = now;
        // Align stream debounce so history:remoteFocus / tab focus do not re-hit state immediately
        lastStreamReconcileAt = now;
        focusStateInFlight = pilotNotesSyncService
            .getFocusState()
            .then(function (data) {
            applyFocusStatePayload(data);
            return data;
        })
            .finally(function () {
            focusStateInFlight = null;
        });
        return focusStateInFlight;
    };
    /**
     * Pack up = open duration T (like Travel Start): closes prior Focus T, starts
     * Session/Travel/Pack up as the new open activity until seal/unlink/short stop.
     * Does not finish Session (S stays open). Python /focus/start-t.
     */
    $scope.packUpCloseT = function () {
        try {
            $scope.viewMode.sessionActionLoading = true;
        }
        catch (_a) { }
        return pilotNotesSyncService
            .startFocusT({
            taskGroup: 'Session',
            topicGroup: 'Travel',
            topicDetail: 'Pack up',
        })
            .then(function (data) {
            var _a, _b;
            applyFocusStatePayload(data);
            try {
                (_b = (_a = $scope).toast) === null || _b === void 0 ? void 0 : _b.call(_a, data.closedTId
                    ? "Pack up T #".concat(data.ID, " (closed prior #").concat(data.closedTId, ")")
                    : "Pack up Focus T #".concat(data.ID), 'success', 4000);
            }
            catch (_c) { }
            return $scope.fetchRecentOnly ? $scope.fetchRecentOnly() : $scope.fetchRecent();
        })
            .finally(function () {
            try {
                $scope.viewMode.sessionActionLoading = false;
            }
            catch (_a) { }
        });
    };
    /**
     * Peel outermost Focus timer (Python /focus/sign-off).
     * Open T → complete that T only (S stays). No T, open S → complete S. No Finish stamp.
     */
    $scope.signOff = function () {
        try {
            $scope.viewMode.sessionActionLoading = true;
        }
        catch (_a) { }
        return pilotNotesSyncService
            .signOffFocus()
            .then(function (data) {
            var _a, _b;
            applyFocusStatePayload(data);
            try {
                var msg = (data && data.Message) ||
                    (data && data.closedTId
                        ? "Signed off activity T #".concat(data.closedTId)
                        : data && data.closedSId
                            ? "Signed off session S #".concat(data.closedSId)
                            : 'Signed off');
                (_b = (_a = $scope).toast) === null || _b === void 0 ? void 0 : _b.call(_a, msg, 'success', 4000);
            }
            catch (_c) { }
            return $scope.fetchRecentOnly ? $scope.fetchRecentOnly() : $scope.fetchRecent();
        })
            .finally(function () {
            try {
                $scope.viewMode.sessionActionLoading = false;
            }
            catch (_a) { }
        });
    };
    // Utility: format seconds into s, m:ss, h:mm:ss, or d h:mm
    $scope.formatDuration = function (totalSec) {
        if (!totalSec || totalSec < 0)
            return '0s';
        var sec = Math.floor(totalSec);
        if (sec < 60)
            return sec + 's';
        var minutes = Math.floor(sec / 60);
        var s = ('0' + (sec % 60)).slice(-2);
        if (minutes < 60)
            return minutes + ':' + s;
        var hours = Math.floor(minutes / 60);
        var m = ('0' + (minutes % 60)).slice(-2);
        if (hours < 24)
            return hours + ':' + m + ':' + s;
        var days = Math.floor(hours / 24);
        var h = (hours % 24).toString();
        return days + 'd ' + h + ':' + m;
    };
    function showUml(body) {
        // Generate the diagram
        // const yuml = new yuml_diagram();
        // const svg = yuml.processYumlDocument(body, false);
        // return svg;
    }
    // fetch recent rows
    $scope.fetchRecent = function () {
        if ($scope.viewMode.recentFetchEnabled === false)
            return false;
        if (recentFetchInFlight)
            return false;
        recentFetchInFlight = true;
        try {
            $scope.viewMode.recentLoading = true;
        }
        catch (_a) { }
        return personService
            .fetchRecent($scope.viewMode)
            .then(function (response) {
            var _a, _b, _c;
            if (response.data.Result == 'OK') {
                if (response.data.recent) {
                    $scope.recentRows = response.data.recent;
                    // Seed live Duration for open rows from raw UTC stamps
                    try {
                        var now = Date.now();
                        for (var _i = 0, _d = response.data.recent; _i < _d.length; _i++) {
                            var r = _d[_i];
                            if (r && r.pnCustomTimeUTC) {
                                (0, localRowPatch_1.recomputeDerivedTimeFields)(r, now);
                            }
                        }
                    }
                    catch (_e) { }
                    try {
                        if (typeof $scope.refreshThreadPills === 'function') {
                            $scope.refreshThreadPills();
                        }
                    }
                    catch (_f) { }
                }
                if (($scope.viewMode.teamRecentRows || 0) > 0 && response.data.teamRecent) {
                    $scope.teamRecent = response.data.teamRecent;
                }
                // Protect optimistic set-time/backdate against a stale recent HIT
                try {
                    (_b = (_a = $scope).reapplyRememberedLocalPatches) === null || _b === void 0 ? void 0 : _b.call(_a);
                }
                catch (_g) { }
                if (response.data.person.personObject) {
                    $scope.person = response.data.person.personObject;
                    $scope.setPerson();
                }
                // Focus meta + account/realm after person bind so focus signal
                // wins over pilot_people Current* when they diverge.
                // Also fills missing pnFlowKind on recent rows (time menus).
                try {
                    applyFocusStatePayload(response.data);
                }
                catch (_h) { }
                $scope.appMode = (_c = $scope.person) === null || _c === void 0 ? void 0 : _c.appMode;
                // Mark last successful recent update time for age indicator
                try {
                    $scope.viewMode.recentLastAt = Date.now();
                }
                catch (_j) { }
                cacheRecentFromResponse(response);
                // Fan-out compact Recent view on focus stream for peer tabs/devices
                publishRecentViewDigestFromPayload(response.data);
            }
            else if (response.data.Result == 'AUTH ERROR') {
                $scope.person = null;
                $scope.setPerson();
            }
            else if (offlineDataService.shouldUseLocalFallback(response)) {
                // e.g. HTTP 200 + DB_CONNECTION_FAILED — keep session, use last recent cache
                $scope.viewMode.serverUnreachable = true;
                restoreRecentFromLocalCache();
            }
            // schedule next fetch after success; honor server-suggested jitter/backoff
            var extraDelay = 0;
            try {
                var headers_1 = response.headers ? response.headers : undefined;
                var get = function (name) { return (headers_1 ? headers_1(name) : null); };
                var suggest = get('X-Audroam-Recent-Suggest-Jitter');
                // Prefer header for generation time; fallback to payload field
                try {
                    var ttl = get('X-Audroam-Recent-TTL');
                    if (ttl) {
                        $scope.viewMode.recentTtl = ttl;
                    }
                    var gen = get('X-Audroam-Recent-Generated');
                    if (gen && /^\d{9,}$/.test(gen)) {
                        $scope.viewMode.recentGeneratedAtMs = parseInt(gen, 10) * 1000;
                    }
                    else if (response.data &&
                        typeof response.data.generatedAt === 'number') {
                        $scope.viewMode.recentGeneratedAtMs =
                            (response.data.generatedAt | 0) * 1000;
                    }
                }
                catch (_k) { }
                var follower = get('X-Audroam-Recent-Lock');
                var backoff = get('X-Audroam-Recent-Backoff');
                if (suggest) {
                    // formats like: "200-600ms" or "150-300 ms"
                    var m = /([0-9]+)\s*-\s*([0-9]+)\s*ms/i.exec(suggest);
                    if (m) {
                        var lo = parseInt(m[1], 10) || 0;
                        var hi = parseInt(m[2], 10) || 0;
                        if (hi > lo) {
                            extraDelay += lo + Math.floor(Math.random() * (hi - lo + 1));
                        }
                    }
                }
                if (follower && typeof follower === 'string' && follower.toLowerCase() === 'follower') {
                    var m2 = backoff ? /([0-9]+)/.exec(backoff) : null;
                    if (m2) {
                        var waited = parseInt(m2[1], 10) || 0;
                        // add up to 1/2 of what we already waited to stagger next poll, cap 3s
                        extraDelay += Math.min(3000, Math.round(waited / 2));
                    }
                    else {
                        extraDelay += 200 + Math.floor(Math.random() * 400);
                    }
                }
            }
            catch (e) {
                /* ignore header parsing errors */
            }
            scheduleNextRecent(true, extraDelay);
        }, function (response) {
            var _a;
            if (((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.Result) == 'AUTH ERROR') {
                $scope.person = null;
                $scope.setPerson();
            }
            else if (offlineDataService.shouldUseLocalFallback(response)) {
                $scope.viewMode.serverUnreachable = true;
                restoreRecentFromLocalCache();
            }
            // back off on errors
            scheduleNextRecent(false);
        })
            .then(function () {
            recentFetchInFlight = false;
            try {
                $scope.viewMode.recentLoading = false;
            }
            catch (_a) { }
        }, function () {
            recentFetchInFlight = false;
            try {
                $scope.viewMode.recentLoading = false;
            }
            catch (_a) { }
        });
        // Cleanup tickers on controller destroy
        $scope.$on('$destroy', function () {
            try {
                nowTickInterval && $interval.cancel(nowTickInterval);
            }
            catch (_a) { }
        });
    };
    $scope.watchPosition = function () {
        $scope.viewMode.geoPositionWatching = true;
        $scope.viewMode.currentGeolocationMsg = 'Requesting location...';
        personService.startWatchPosition($scope.showLocationUpdate);
    };
    $scope.watchPositionClear = function () {
        personService.stopWatchPosition();
        $scope.viewMode.geoPositionWatching = false;
        $scope.viewMode.geoPositionObj = null;
        $scope.viewMode.currentGeolocation = null;
        $scope.viewMode.currentGeolocationMsg = null;
        $scope.viewMode.currentGeolocationAcc = null;
    };
    $scope.getLocation = function () {
        console.log('calling personService.getLocation()');
        $scope.viewMode.currentGeolocationMsg = 'Requesting location...';
        return personService.getLocation().then(function (position) {
            if (position.coords) {
                $scope.viewMode.geoLocation = position.coords.latitude + ', ' + position.coords.longitude;
                $scope.viewMode.geoPosition = position;
                // [TODO] transition to using this function only
                $scope.showLocationUpdate(position);
                console.log('got location:', position);
            }
            return position;
        });
    };
    $scope.showLocationStale = function () {
        $scope.viewMode.currentGeolocationMsg = '?? ' + $scope.viewMode.currentGeolocationMsg;
        $scope.viewMode.currentGeolocationAcc = '?? ' + $scope.viewMode.currentGeolocationAcc;
    };
    $scope.showLocationUpdate = function (position) {
        $timeout.cancel(clearLocationTimeoutID);
        console.log(position);
        $scope.viewMode.geoPositionObj = {
            timestamp: position.timestamp,
            accuracy: position.coords.accuracy,
            speed: position.coords.speed,
            heading: position.coords.heading,
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
        };
        $scope.viewMode.currentGeolocationMsg = "(".concat(Math.round(position.coords.accuracy), "m) ");
        Math.round(position.coords.latitude * 10000) / 10000 +
            ', ' +
            Math.round(position.coords.longitude * 10000) / 10000 +
            ' - ' +
            Math.round(position.coords.speed * 36) / 10 +
            ' km/h' +
            (position.coords.heading ? ' - heading: ' + position.coords.heading : '');
        $scope.viewMode.currentGeolocationAcc =
            Math.round(position.coords.accuracy) + 'm - ' + Math.round(position.coords.speed * 36) / 10 + ' km/h';
        $scope.viewMode.currentGeolocation = position.coords.latitude + ', ' + position.coords.longitude;
        // clear location at timeout
        clearLocationTimeoutID = $timeout($scope.showLocationStale, 30 * 1000);
    };
    $scope.useLocation = function (row) {
        // check if a recent position is available
        // [TODO] check timestamp
        if ($scope.viewMode.geoPositionObj) {
            row.pnUserRoamGeoLat = $scope.viewMode.geoPositionObj.latitude;
            row.pnUserRoamGeoLon = $scope.viewMode.geoPositionObj.longitude;
            $scope.saveLocation(row);
        }
        else {
            $scope
                .getLocation()
                .then(function (position) {
                row.pnUserRoamGeoLat = position.coords.latitude;
                row.pnUserRoamGeoLon = position.coords.longitude;
                $scope.saveLocation(row);
            })
                .catch(function (err) {
                var msg = (err && (err.message || err)) ||
                    'Location failed — allow location for this site in the browser';
                row.uiMessage = String(msg);
                $scope.viewMode.currentGeolocationMsg = String(msg);
            });
        }
    };
    // updateRowArray + applyAction registered via registerRowApplyScopeActions
    /**
     * Persist GPS (and optional hint/point later) via Python place-focus API.
     * Not updateResultRow / rowArray — those strip geo via UPDATE_ROW_ARRAY_ALLOWED_KEYS.
     */
    $scope.saveLocation = function (row) {
        if (!row || !row.ID) {
            return;
        }
        var lat = row.pnUserRoamGeoLat;
        var lon = row.pnUserRoamGeoLon;
        if (lat == null || lon == null || lat === '' || lon === '') {
            row.uiMessage = 'No coordinates to save';
            return;
        }
        row.uiMessage = 'saving location...';
        var geo = ($scope.viewMode.geoPositionObj || {});
        var body = {
            row_id: row.ID,
            lat: lat,
            lon: lon,
            record_trail: true,
        };
        if (geo.accuracy != null) {
            body.accuracy = geo.accuracy;
        }
        if (geo.speed != null) {
            body.speed = geo.speed;
        }
        if (geo.heading != null) {
            body.heading = geo.heading;
        }
        if (geo.timestamp != null) {
            body.timestamp = geo.timestamp;
        }
        if (row.pnUserRoamHint) {
            body.hint = row.pnUserRoamHint;
        }
        if (row.pnUserRoamPoint) {
            body.point = row.pnUserRoamPoint;
        }
        $http
            .post('/api/v2/roaming/place-focus', body)
            .then(function (response) {
            var data = response && response.data;
            if (data && data.Result === 'OK') {
                if (data.pnUserRoamGeoLat != null) {
                    row.pnUserRoamGeoLat = data.pnUserRoamGeoLat;
                }
                if (data.pnUserRoamGeoLon != null) {
                    row.pnUserRoamGeoLon = data.pnUserRoamGeoLon;
                }
                row.uiMessage = data.Message || 'OK';
            }
            else {
                row.uiMessage =
                    (data && (data.Message || data.error || data.Result)) || 'Location save failed';
            }
        })
            .catch(function (error) {
            var data = error && error.data;
            row.uiMessage =
                (data && (data.Message || data.error)) ||
                    (error && error.status === 401
                        ? 'Not authenticated for location save'
                        : 'Location save failed');
        });
    };
    $scope.setPerson = function (value) {
        var _a, _b, _c, _d, _e;
        var prevPk = personPkOf($scope.person);
        if (value)
            $scope.person = value;
        $scope.viewMode.personReady = true;
        $scope.personCurr = "".concat((_a = $scope.person) === null || _a === void 0 ? void 0 : _a.CurrentRealm, " / ").concat((_b = $scope.person) === null || _b === void 0 ? void 0 : _b.ScanRealm);
        if (value &&
            $scope.viewMode.pageMode === 'threads' &&
            typeof $scope.applyThreadsPath === 'function' &&
            !((_c = $scope.threadUi) === null || _c === void 0 ? void 0 : _c.showPanel)) {
            try {
                $scope.applyThreadsPath($scope.viewMode.initialThreadsPath || $window.location.pathname);
            }
            catch (_f) {
                /* ignore */
            }
        }
        var nextPk = personPkOf($scope.person);
        if (value && nextPk != null && String(nextPk) !== String(prevPk !== null && prevPk !== void 0 ? prevPk : '')) {
            // During login, doLogin emits auth:userChanged('login') + afterUserSessionReady
            if (!$scope.isLoggingIn) {
                emitUserChanged(prevPk == null ? 'person_loaded' : 'person_switched', prevPk);
            }
            emitFocusContextChanged(prevPk == null ? 'person_loaded' : 'person_switched');
        }
        $scope.realmList = personService.getRealmList();
        $scope.recentRealmList = [];
        if ($scope.history && $scope.history.focus && $scope.history.focus.length > 0) {
            var focusEntries = $scope.history.focus.slice(0, 20).map(function (entry) { return ({
                realm: entry.data.realm,
                account: entry.data.account,
                isRecent: true,
                timestamp: entry.timestamp,
                caption: entry.caption
            }); });
            var recentMap_1 = new Map();
            focusEntries.forEach(function (entry) {
                var key = "".concat(entry.realm, "/").concat(entry.account);
                if (!recentMap_1.has(key)) {
                    recentMap_1.set(key, entry);
                }
            });
            $scope.recentRealmList = Array.from(recentMap_1.values());
            if ($scope.realmList && Array.isArray($scope.realmList)) {
                var realmSet_1 = new Set($scope.realmList.map(function (r) { return "".concat(r.realm, "/").concat(r.account); }));
                $scope.recentRealmList.forEach(function (f) {
                    var key = "".concat(f.realm, "/").concat(f.account);
                    if (realmSet_1.has(key)) {
                        var existing = $scope.realmList.find(function (r) {
                            return r.realm === f.realm && r.account === f.account;
                        });
                        if (existing) {
                            existing.isRecent = true;
                            if (existing.caption)
                                f.caption = existing.caption;
                        }
                    }
                    else {
                        $scope.realmList.push({
                            realm: f.realm,
                            account: f.account,
                            isRecent: true,
                            caption: f.caption,
                        });
                        realmSet_1.add(key);
                    }
                });
            }
            else if ($scope.recentRealmList.length > 0) {
                $scope.realmList = __spreadArray([], $scope.recentRealmList, true);
            }
        }
        // Check if the person focus has changed
        if ($scope.personPrev == $scope.personCurr) {
            return;
        }
        // Add defaults - top
        // [todo] create a new list of defaults to render above realm actions
        $scope.taskActions = angular_1.default.copy($scope.defaultActions1);
        if (((_d = $scope.person) === null || _d === void 0 ? void 0 : _d.CurrentRealm) === 'bikeshare' || ((_e = $scope.person) === null || _e === void 0 ? void 0 : _e.ScanRealm) === 'bikeshare') {
            Array.prototype.push.apply($scope.taskActions, $scope.bikeActions);
            //$scope.viewMode.showTimewritingStyle = 2;
        }
        var alwaysShowReuseActions = true;
        if (alwaysShowReuseActions) {
            Array.prototype.push.apply($scope.taskActions, $scope.reuseActions);
        }
        else if ($scope.person &&
            ($scope.person.CurrentRealm === 'reuse' ||
                $scope.person.ScanRealm === 'reuse' ||
                $scope.person.CurrentRealm === 'a' ||
                $scope.person.ScanRealm === 'a' ||
                $scope.person.CurrentRealm === 'my' ||
                $scope.person.ScanRealm === 'my' ||
                ($scope.person.CurrentRealm && $scope.person.CurrentRealm.substring(0, 2) === 'a-') ||
                ($scope.person.ScanRealm && $scope.person.ScanRealm.substring(0, 2) === 'a-') ||
                ($scope.person.CurrentRealm && $scope.person.CurrentRealm.substring(0, 3) === 'my-') ||
                ($scope.person.ScanRealm && $scope.person.ScanRealm.substring(0, 3) === 'my-'))) {
            // todo: make this more of a "current UI mode is related to tracking assets" flag
            // it's currently attempting to work that out from expect realm patterns
            // this could also be detected with AI having set the "these realms are asset-related" flag
            Array.prototype.push.apply($scope.taskActions, $scope.reuseActions);
        }
        // Add defaults
        Array.prototype.push.apply($scope.taskActions, $scope.defaultActions2);
    };
    /**
     * Realm switcher: Python POST /api/v2/focus/set-context (person_focus_state +
     * pilot_people Current*). Does not touch active T/S. No PHP focusSave.
     */
    $scope.setCurrentRealm = function (realm) {
        if (!realm) {
            return $q.reject(new Error('Missing realm'));
        }
        var account = realm.account != null ? String(realm.account) : '';
        var realmName = realm.realm != null ? String(realm.realm) : '';
        return pilotNotesSyncService
            .setFocusContext({ account: account, realm: realmName })
            .then(function (data) {
            applyFocusStatePayload(data);
            // Optimistic bind if payload omitted keys
            if ($scope.person) {
                if (account)
                    $scope.person.CurrentAccount = account;
                if (realmName)
                    $scope.person.CurrentRealm = realmName;
            }
            emitFocusContextChanged('set_current_realm');
            return data;
        })
            .catch(function (err) {
            var _a, _b;
            try {
                (_b = (_a = $scope).toast) === null || _b === void 0 ? void 0 : _b.call(_a, (err && err.message) || 'Could not switch realm', 'danger', 4000);
            }
            catch (_c) { }
            return $q.reject(err);
        });
    };
    var initProgress = function () {
        $scope.viewMode.progress_1 = {
            done: false,
            show: false,
            max: 100,
            value: 0,
        };
    };
    $scope.updateProgress = function () {
        // check if we're beginning
        if ($scope.viewMode.progress_1 === undefined || !$scope.viewMode.progress_1.show) {
            $scope.viewMode.updateProgressEnabled = true;
            initProgress();
        }
        person16Service
            .fetchProgress()
            .then(function (response) {
            console.debug('updateProgress success');
            if (response.data.Result === 'OK' && $scope.viewMode.progress_1) {
                $scope.viewMode.progress_1.show = true;
                $scope.viewMode.progress_1.progress = response.data.progress;
                $scope.viewMode.progress_1.done = response.data.progress.done;
                $scope.viewMode.progress_1.value = response.data.progress.bytes_processed;
                $scope.viewMode.progress_1.max = response.data.progress.content_length;
            }
            if ($scope.viewMode.updateProgressEnabled) {
                if (updateProgressTimeout1ID) {
                    // already set
                }
                else {
                    updateProgressTimeout1ID = $timeout($scope.updateProgress, 800);
                }
                // disable progress after some time
                // we need to allow the upload to start, before checking if it's finished
                if (updateProgressTimeout2ID) {
                    //console.log('interval already set ', updateProgressTimeout2ID);
                }
                else {
                    updateProgressTimeout2ID = $interval(function () {
                        var _a;
                        console.log('> Checking progress interval');
                        // check if progress done = true
                        if ((_a = $scope.viewMode.progress_1) === null || _a === void 0 ? void 0 : _a.done) {
                            $scope.viewMode.updateProgressEnabled = false;
                            $scope.viewMode.progress_1 = {
                                done: true,
                                show: false,
                                max: 1,
                                value: 1,
                            };
                            updateProgressTimeout2ID && $interval.cancel(updateProgressTimeout2ID);
                            updateProgressTimeout2ID = undefined;
                            $timeout.cancel(updateProgressTimeout1ID);
                            updateProgressTimeout1ID = undefined;
                            console.log('progress interval - done OK, disabled progress.');
                        }
                        else {
                            $scope.viewMode.updateProgressEnabled = true;
                            $scope.updateProgress();
                            console.log('progress interval - still in progress...');
                        }
                    }, 30 * 1000);
                }
            }
            else {
                // set progress bar to complete
                $scope.viewMode.progress_1 = {
                    done: true,
                    show: false,
                    max: 1,
                    value: 1,
                };
                if (updateProgressTimeout1ID)
                    $timeout.cancel(updateProgressTimeout1ID);
                if (updateProgressTimeout2ID)
                    $interval.cancel(updateProgressTimeout2ID);
            }
        })
            .catch(function (error) {
            console.log('updateProgress error');
            //console.log(error);
            if ($scope.viewMode.updateProgressEnabled) {
                $timeout($scope.updateProgress, 800);
            }
        });
    };
    $scope.copyRealm = function (row) {
        if (row.pnAssetAccount) {
            row.pnAccount = row.pnAssetAccount;
        }
        else {
            row.pnAssetAccount = row.pnAccount;
        }
        if (row.pnAssetRealm) {
            row.pnUserRealm = row.pnAssetRealm;
        }
        else {
            row.pnAssetRealm = row.pnUserRealm;
        }
    };
    // Handle View Audit Roam UI
    $scope.hitAction = function (mode, ui, event, clearUi) {
        if (clearUi === void 0) { clearUi = false; }
        if (event !== undefined && event !== null) {
            event.preventDefault();
        }
        if (ui === undefined || ui === null) {
            return;
        }
        console.log('hitAction called with mode:', mode, 'ui:', ui);
        switch (mode) {
            case 'openPNID':
                // redirect or open new tab with
                // Base URI + '/view/pnid/' + ui.viewPnid
                break;
            case 'view':
                // Parse search text and tag for special syntax (realm:value, account:value, etc.)
                var parsedSearch = searchService.parseSearchText(ui.viewText);
                var parsedTag = searchService.parseSearchText(ui.viewTag);
                // Hide-completed defaults on for free-text/tag search; by-id opens show all
                // so a completed root is not an empty result (checkbox still overrides).
                var hasFreeSearch = !!(parsedSearch.text ||
                    parsedTag.text ||
                    ui.viewTag ||
                    ui.viewTopic ||
                    ui.viewCode ||
                    ui.viewRealm ||
                    ui.viewDate1 ||
                    ui.viewDate2 ||
                    ui.viewDateRange ||
                    ui.viewDateRangeDays);
                var doneArg = void 0;
                if (ui.viewDone !== undefined && ui.viewDone !== null && ui.viewDone !== '') {
                    doneArg = ui.viewDone;
                }
                else if (ui.viewPnid && !hasFreeSearch) {
                    doneArg = undefined;
                }
                else {
                    doneArg = 0;
                }
                var viewSearchArgs = {
                    pnid: ui.viewPnid,
                    s: parsedSearch.text,
                    realm: ui.viewRealm || parsedSearch.params.realm || parsedTag.params.realm,
                    account: parsedSearch.params.account || parsedTag.params.account,
                    topicLike: ui.viewTopic,
                    code: ui.viewCode || parsedSearch.params.code,
                    hint: parsedSearch.params.hint,
                    point: parsedSearch.params.point,
                    tag: parsedTag.text || ui.viewTag,
                    d1: ui.viewDate1,
                    d2: ui.viewDate2,
                    dr: ui.viewDateRange,
                    ds: ui.viewDateRangeDays,
                    my: ui.viewMy,
                };
                if (doneArg !== undefined) {
                    viewSearchArgs.done = doneArg;
                }
                $scope.personSearch(viewSearchArgs);
                // Note: history recording now handled inside personSearch via recordSearchFromArgs
                if (clearUi && event.which === 13) {
                    ui.viewText = null;
                    ui.viewTag = null;
                }
                break;
            case 'audit':
                $scope.postURI(config.basePath + 'api1.php?json=post', {
                    auditRow: {
                        taskGroup: 'Audit',
                        topicGroup: 'UI',
                        body: 'Audit',
                        tagAux: null,
                        value: null,
                    },
                    auditTags: ui.auditMultipleTags ? ui.auditMultipleTags : ui.auditTag,
                }, 'hit', event, { auditMode: true });
                break;
            case 'roam':
                break;
        }
    };
    // hit URI hitURI
    $scope.hitURI = function (uri, message) {
        var messageValue = '';
        if (message !== undefined && message !== null) {
            messageValue = message;
            message = '...';
        }
        $scope.viewMode.hitMessage = '...';
        try {
            $scope.viewMode.actionLoading = true;
        }
        catch (_a) { }
        return $http
            .get(uri)
            .then(function (response) {
            console.debug('hitURI response = ', response);
            message = messageValue;
            $scope.viewMode.hitMessage = 'OK';
            $scope.fetchRecent();
        })
            .finally(function () {
            try {
                $scope.viewMode.actionLoading = false;
            }
            catch (_a) { }
        });
    };
    $scope.startAndManage = function (auditRow, uri, target, ui) {
        /*
        {
            auditRowRedBike: ___,
            ParentFK: result.ID,
            taskGroup: 'Activity',
            topicGroup: 'Start',
            topicDetail: null
        }
        */
        if (auditRow) {
            $scope.postTaskAction(null, {
                // startAndManage: open Focus T (same as Work pack / recent Start)
                flowKind: auditRow.flowKind || 'T',
                timeStyle: auditRow.timeStyle || 'duration',
                opensFocus: auditRow.opensFocus !== false,
                closesPreviousT: auditRow.closesPreviousT !== false,
                auditRow: auditRow,
            }, ui);
        }
        if (uri) {
            if (!target) {
                target = 'sobi_manage_b';
            }
            $window.open(uri, target);
        }
    };
    $scope.reloadSearch = function () {
        if ($scope.reportSearch) {
            $scope.personSearch($scope.reportSearch);
        }
    };
    /**
     * True if any search/recent row is mid-edit or has unsaved draft UI state.
     * Full personSearch rebinds reportResult and drops open editors (drafts look "cleared").
     */
    function hasOpenRowEditUi() {
        var lists = [$scope.reportResult, $scope.scheduleRows, $scope.recentRows].filter(Boolean);
        for (var _i = 0, lists_1 = lists; _i < lists_1.length; _i++) {
            var list = lists_1[_i];
            if (!Array.isArray(list))
                continue;
            for (var _a = 0, list_1 = list; _a < list_1.length; _a++) {
                var r = list_1[_a];
                if (r && (r.edit || r.reply)) {
                    // Any open edit form, or reply form with draft indicators
                    if (r.edit)
                        return true;
                    if (r.reply && (r.reply._draftUnsavedIndicator || r.reply._draftIndicator || r.reply.pnBody)) {
                        return true;
                    }
                }
            }
        }
        return false;
    }
    /**
     * After Start/Done/etc: do not full-reload search while an editor is open.
     * Soft path: recent only (postTaskAction already bursts recent on success).
     */
    $scope.reloadSearchUnlessEditing = function () {
        if (hasOpenRowEditUi()) {
            try {
                if ($scope.fetchRecentOnly) {
                    $scope.fetchRecentOnly();
                }
            }
            catch (_a) {
                /* ignore */
            }
            return;
        }
        $scope.reloadSearch();
    };
    /** Callback factory: always soft if this row is editing; else full reloadSearch. */
    $scope.afterTaskKeepEdit = function (row) {
        return function () {
            if (row && (row.edit || row.reply)) {
                try {
                    if ($scope.fetchRecentOnly) {
                        $scope.fetchRecentOnly();
                    }
                }
                catch (_a) {
                    /* ignore */
                }
                return;
            }
            $scope.reloadSearch();
        };
    };
    /**
     * Client-side filter for search result rows (instant, no re-search).
     * Server also applies hideTS / done when personSearch runs.
     * Root pnid for this search is never hidden (empty /view/pnid/N is wrong).
     */
    $scope.searchResultRowVisible = function (row) {
        var _a, _b;
        if (!row)
            return false;
        if (row._clientHidden)
            return false;
        // Just-done flash: keep visible briefly even when hide-completed is on
        if (row._justDoneAt && Date.now() - Number(row._justDoneAt) < 1600) {
            return true;
        }
        var rs = $scope.reportSearch || {};
        // Always show the requested root note (and viewMode /view/pnid target)
        try {
            var rootCandidates = [
                rs.pnid,
                (_a = $scope.viewMode) === null || _a === void 0 ? void 0 : _a.initialSearchOnlyPNID,
                (_b = $scope.viewMode) === null || _b === void 0 ? void 0 : _b.zenPnid,
            ];
            var rowId = Number(row.ID);
            for (var _i = 0, rootCandidates_1 = rootCandidates; _i < rootCandidates_1.length; _i++) {
                var c = rootCandidates_1[_i];
                if (c == null || c === '')
                    continue;
                var n = Number(c);
                if (!isNaN(n) && n > 0 && n === rowId) {
                    return true;
                }
            }
        }
        catch (_c) {
            /* ignore */
        }
        var hideDone = rs.done === 0 || rs.done === '0';
        if (hideDone && row.pnCompletedUTC) {
            // Optional keep recent done: client grace ~2h when recentDone=1
            var keepRecent = rs.recentDone === 1 || rs.recentDone === '1' || rs.recentDone === true;
            if (!keepRecent)
                return false;
            var ms = (0, localRowPatch_1.parseUtcMs)(row.pnCompletedUTC);
            if (ms == null || Date.now() - ms > 2 * 3600 * 1000)
                return false;
        }
        var hideTS = rs.hideTS === 1 || rs.hideTS === '1' || rs.hideTS === true;
        if (hideTS && (0, focusTimeHelpers_1.isTimeTrackingRow)(row))
            return false;
        return true;
    };
    /** True when completed time + done-by are already set (Done menu must no-op). */
    $scope.isRowAlreadyDone = function (row) {
        return (0, focusTimeHelpers_1.isRowAlreadyDone)(row);
    };
    /**
     * Popup "Done" — no-ops when the row is already completed with person/by.
     * Avoids re-stamping done time / overwriting done-by.
     */
    $scope.markRowDone = function (row, callback) {
        if (!row || !row.ID) {
            return $q.reject(new Error('missing row'));
        }
        if ((0, focusTimeHelpers_1.isRowAlreadyDone)(row)) {
            // Already done — leave stamps alone; do not hit the server
            return $q.resolve(null);
        }
        return $scope.updateResultRow({ ID: null, edit: null, reply: { ID: row.ID, doneCheck: true } }, null, null, callback || null);
    };
    /**
     * After Done on a search row: stamp completed locally, flash feedback, no full re-search.
     * (Full personSearch was jarring and re-pulled "recently done" for 2 days.)
     * Skips re-stamp when completed time + person are already set.
     */
    $scope.afterDoneOnSearch = function (row) {
        return function () {
            try {
                if (row) {
                    if ((0, focusTimeHelpers_1.isRowAlreadyDone)(row)) {
                        return;
                    }
                    var nowIso = new Date().toISOString();
                    if (!row.pnCompletedUTC) {
                        row.pnCompletedUTC = nowIso;
                    }
                    if ($scope.person && $scope.person.dbPK != null) {
                        row.pnCompletedPersonPK = $scope.person.dbPK;
                    }
                    row._justDoneAt = Date.now();
                    row.uiMessage = 'Done';
                    row._draftFeedbackTone = undefined;
                    // Soft drop from list after flash when hide-completed is on
                    $timeout(function () {
                        try {
                            delete row._justDoneAt;
                        }
                        catch (_a) {
                            /* ignore */
                        }
                    }, 1700);
                }
            }
            catch (_a) {
                /* ignore */
            }
            // Focus card / open timers only — not a full search rebind
            try {
                if ($scope.fetchRecentOnly) {
                    $scope.fetchRecentOnly();
                }
            }
            catch (_b) {
                /* ignore */
            }
        };
    };
    $scope.reloadFocus = function () {
        if ($scope.tagStatus.entity.EntityTag) {
            $scope.setPersonFocus({ setRedBike: $scope.tagStatus.entity.EntityTag });
        }
    };
    /**
     * Human duration interval? Only flowKind S or T (Focus model).
     * taskGroup alone is not time tracking (Activity/Note is a timestamp).
     */
    $scope.isTimeTracking = function (row) {
        return (0, focusTimeHelpers_1.isTimeTrackingRow)(row);
    };
    /** Template alias (same as isTimeTracking). */
    $scope.isTimeTrackingRow = function (row) {
        return (0, focusTimeHelpers_1.isTimeTrackingRow)(row);
    };
    $scope.rowFlowKind = function (row) {
        return (0, focusTimeHelpers_1.rowFlowKind)(row);
    };
    $scope.postTaskAction = function (form, action, ui, callback) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        action.message = '...';
        if (ui) {
            ui.message = '...';
        }
        // pass auditRow: action.auditRow
        // pass Task Action Header
        // Use new /api/api.php endpoint for all auditRow submissions (modernizing from legacy api1.php)
        var endpoint = config.api;
        // Top / pack actions that open human duration must hit Python Focus API.
        // Otherwise PHP auditRow inserts open T without person_focus_state → orphans.
        var arIn = action.auditRow || {};
        var tg = String(arIn.taskGroup || action.taskGroup || '');
        var tpg = String(arIn.topicGroup || action.topicGroup || '');
        var rawFlow = (_b = (_a = action.flowKind) !== null && _a !== void 0 ? _a : arIn.flowKind) !== null && _b !== void 0 ? _b : arIn.flow_kind;
        var rawTimeStyle = (_c = action.timeStyle) !== null && _c !== void 0 ? _c : arIn.timeStyle;
        var rawOpens = (_d = action.opensFocus) !== null && _d !== void 0 ? _d : arIn.opensFocus;
        // Legacy / incomplete packs: Activity work starts without flowKind stamps
        var looksLikeOpenActivityTimer = tg === 'Activity' &&
            rawFlow == null &&
            String(rawTimeStyle || '').toLowerCase() !== 'stamp' &&
            String(rawTimeStyle || '').toLowerCase() !== 'none' &&
            // Typical open-timer topics from defaultActions1 + packs
            (tpg === 'Start' ||
                tpg === 'Planning' ||
                tpg === 'Admin' ||
                tpg === 'Workflow' ||
                tpg === 'Developing' ||
                tpg === 'Meeting' ||
                tpg === 'Work' ||
                tpg === '' ||
                /start|work|plan|admin|meet/i.test(tpg));
        // Session/Travel open segments without stamps (top action bar)
        var looksLikeOpenSessionTimer = (tg === 'Session' || tg === 'Travel') &&
            rawFlow == null &&
            String(rawTimeStyle || '').toLowerCase() !== 'stamp' &&
            String(rawTimeStyle || '').toLowerCase() !== 'none' &&
            tpg !== 'Shift'; // legacy Session/Shift rows were S envelopes
        if (looksLikeOpenActivityTimer || looksLikeOpenSessionTimer) {
            action.flowKind = 'T';
            action.timeStyle = action.timeStyle || 'duration';
            action.opensFocus = true;
            action.closesPreviousT = true;
        }
        // Explicit opensFocus without flowKind → open T
        if ((rawOpens === true || rawOpens === 1 || rawOpens === '1') &&
            (action.flowKind == null && arIn.flowKind == null && arIn.flow_kind == null)) {
            action.flowKind = 'T';
            action.timeStyle = action.timeStyle || 'duration';
            action.opensFocus = true;
            action.closesPreviousT = action.closesPreviousT !== false;
        }
        // Merge explicit flow + planning config onto auditRow (taskGroup alone is not reliable)
        var auditRow = __assign(__assign({}, arIn), { flowKind: (_f = (_e = action.flowKind) !== null && _e !== void 0 ? _e : arIn.flowKind) !== null && _f !== void 0 ? _f : arIn.flow_kind, timeStyle: (_g = action.timeStyle) !== null && _g !== void 0 ? _g : arIn.timeStyle, sealScope: (_h = action.sealScope) !== null && _h !== void 0 ? _h : arIn.sealScope, closesPreviousT: (_j = action.closesPreviousT) !== null && _j !== void 0 ? _j : arIn.closesPreviousT, opensFocus: (_k = action.opensFocus) !== null && _k !== void 0 ? _k : arIn.opensFocus, planningKind: (_l = action.planningKind) !== null && _l !== void 0 ? _l : arIn.planningKind, schedule: action.createsSchedule === true ||
                arIn.schedule === true ||
                arIn.schedule === 1
                ? true
                : arIn.schedule });
        // Focus S/T/seal → Python Focus API (PHP no longer dual-writes person_focus_state)
        var flowNorm = String(auditRow.flowKind || '')
            .trim()
            .toLowerCase();
        var timeStyleNorm = String(auditRow.timeStyle || '')
            .trim()
            .toLowerCase();
        var sealScopeNorm = String(auditRow.sealScope || '')
            .trim()
            .toLowerCase();
        var opensFocus = auditRow.opensFocus === true ||
            auditRow.opensFocus === 1 ||
            auditRow.opensFocus === '1' ||
            (auditRow.opensFocus == null && (flowNorm === 's' || flowNorm === 't'));
        // Prefer startFocusT for any open duration T (default opensFocus when flow is T)
        var shouldStartFocusT = flowNorm === 't' &&
            opensFocus &&
            timeStyleNorm !== 'stamp' &&
            timeStyleNorm !== 'none';
        var parentFk = arIn.ParentFK != null
            ? arIn.ParentFK
            : arIn.parentFK != null
                ? arIn.parentFK
                : form && form.ID
                    ? form.ID
                    : null;
        var finishTaskActionUi = function (ok) {
            $timeout(function () {
                action.message = ok ? '.' : '!';
                if (ui) {
                    ui.message = ok ? '.' : '!';
                }
            }, 1000);
            if (ok && typeof callback === 'function') {
                try {
                    callback();
                }
                catch (_a) {
                    /* ignore */
                }
            }
            else if (ok) {
                try {
                    if ($scope.fetchRecentOnly) {
                        $scope.fetchRecentOnly();
                    }
                    else {
                        $scope.fetchRecent();
                    }
                }
                catch (_b) {
                    /* ignore */
                }
            }
        };
        if (flowNorm === 's') {
            return pilotNotesSyncService
                .startFocusS({
                taskGroup: String(auditRow.taskGroup || 'Session'),
                // Empty topic by default — never invent legacy "Shift" T&A stamp
                topicGroup: auditRow.topicGroup != null && String(auditRow.topicGroup).trim() !== ''
                    ? String(auditRow.topicGroup)
                    : '',
                topicDetail: auditRow.topicDetail != null ? String(auditRow.topicDetail) : 'Start',
                body: auditRow.body != null ? String(auditRow.body) : null,
                assetTag: auditRow.tag != null ? String(auditRow.tag) : null,
                assetTagAux: auditRow.tagAux != null ? String(auditRow.tagAux) : null,
                assetAccount: auditRow.assetAccount != null ? String(auditRow.assetAccount) : null,
                assetRealm: auditRow.assetRealm != null ? String(auditRow.assetRealm) : null,
                itemCode: (_m = auditRow.itemCode) !== null && _m !== void 0 ? _m : null,
            })
                .then(function (data) {
                applyFocusStatePayload(data);
                finishTaskActionUi(true);
                return data;
            })
                .catch(function (err) {
                finishTaskActionUi(false);
                return $q.reject(err);
            });
        }
        if (shouldStartFocusT) {
            var packAccount = auditRow.assetAccount != null
                ? String(auditRow.assetAccount)
                : form
                    ? form.pnAssetAccount || form.pnAccount
                    : null;
            var packRealm = auditRow.assetRealm != null
                ? String(auditRow.assetRealm)
                : form
                    ? form.pnAssetRealm || form.pnUserRealm
                    : null;
            return pilotNotesSyncService
                .startFocusT({
                parentId: parentFk != null ? Number(parentFk) : null,
                taskGroup: String(auditRow.taskGroup || 'Activity'),
                topicGroup: String(auditRow.topicGroup || 'Start'),
                topicDetail: auditRow.topicDetail != null ? String(auditRow.topicDetail) : null,
                body: auditRow.body != null ? String(auditRow.body) : null,
                assetTag: auditRow.tag != null ? String(auditRow.tag) : null,
                assetTagAux: auditRow.tagAux != null ? String(auditRow.tagAux) : null,
                assetAccount: packAccount,
                assetRealm: packRealm,
                account: packAccount,
                realm: packRealm,
                itemCode: (_p = (_o = auditRow.itemCode) !== null && _o !== void 0 ? _o : $scope.localPersonItemCodeValue) !== null && _p !== void 0 ? _p : null,
            })
                .then(function (data) {
                applyFocusStatePayload(data);
                finishTaskActionUi(true);
                return data;
            })
                .catch(function (err) {
                finishTaskActionUi(false);
                return $q.reject(err);
            });
        }
        if (flowNorm === 'seal' || flowNorm === 'close') {
            var sealPromise = sealScopeNorm === 's' || sealScopeNorm === 's_and_t'
                ? pilotNotesSyncService.signOffFocus({
                    taskGroup: String(auditRow.taskGroup || 'Session'),
                    topicGroup: String(auditRow.topicGroup || 'Shift'),
                    topicDetail: auditRow.topicDetail != null
                        ? String(auditRow.topicDetail)
                        : 'Finish',
                    body: auditRow.body != null ? String(auditRow.body) : null,
                })
                : pilotNotesSyncService.sealFocusT({
                    taskGroup: String(auditRow.taskGroup || 'Session'),
                    topicGroup: String(auditRow.topicGroup || 'Travel'),
                    topicDetail: auditRow.topicDetail != null
                        ? String(auditRow.topicDetail)
                        : null,
                    body: auditRow.body != null ? String(auditRow.body) : null,
                    assetTag: auditRow.tag != null ? String(auditRow.tag) : null,
                    assetTagAux: auditRow.tagAux != null ? String(auditRow.tagAux) : null,
                });
            return sealPromise
                .then(function (data) {
                applyFocusStatePayload(data);
                finishTaskActionUi(true);
                return data;
            })
                .catch(function (err) {
                finishTaskActionUi(false);
                return $q.reject(err);
            });
        }
        $scope
            .postURI(endpoint, {
            action: 'auditRow',
            auditRow: auditRow,
            auditRowRefNum: $scope.localPersonRefNumGroup,
            auditRowRedBike: action.auditRow.auditRowRedBike
                ? action.auditRow.auditRowRedBike
                : $scope.localPersonRedBikeGroup,
            auditRowBlueBike: $scope.localPersonBlueBikeGroup,
            auditRowItemCode: $scope.localPersonItemCodeGroup,
        })
            .then(function () {
            // collapse the feedback message in 1 second
            // leave an echo for 90 seconds
            $timeout(function () {
                action.message = '.';
                if (ui) {
                    ui.message = '.';
                }
            }, 1 * 1000);
            $timeout(function () {
                action.message = null;
            }, 90 * 1000);
            // reset the form
            if (form) {
                if (action.showBodyInput) {
                    action.auditRow.body = action.defaultBody;
                }
                if (action.showTagAuxInput) {
                    action.auditRow.tagAux = action.defaultTagAux;
                }
                if (action.showTagAuxInputNumeric) {
                    action.auditRow.tagAux = action.defaultTagAux;
                }
                if (action.showValueInput) {
                    action.auditRow.value = action.defaultValue;
                }
                form.$setPristine();
                form.$setUntouched();
            }
            if (ui) {
                ui.message = 'saved';
            }
            action.message = 'saved';
        }, function (response) {
            action.message = 'ERROR';
            console.log(response);
        })
            .then(function (response) {
            if (callback) {
                callback();
            }
            else {
                // One reconcile for openMeta / focus pointers after pack actions
                refreshRecentAfterMutation();
            }
        });
    };
    $scope.bindResult = bindResult;
    function bindResult(response) {
        if (response.data.reportResult != null) {
            $scope.reportImages = response.data.images ? response.data.images : null;
        }
        else {
            $scope.reportImages = null;
        }
        if (response.data.reportResult != null) {
            // On the board, fold Recent so search results stay primary; never open Recent in report/search/view
            if (isRecentUiEnabled()) {
                $scope.viewMode.recentRows = 4;
            }
            // bind search results
            $scope.reportResult = response.data.reportResult.map(function (row) { return (__assign(__assign({}, row), { umlHtml: row.pnTopicDetail === 'UML' && showUml(row.pnBody) })); });
            $scope.reportSearch = {};
            if (Array.isArray(response.data.args)) {
                //$scope.debugMessage = response.data;
            }
            else {
                $scope.reportSearch = response.data.args;
            }
            // set the window title
            $window.document.title =
                (response.data.rowID ? response.data.rowID : '') +
                    (response.data.searchCaption ? response.data.searchCaption : '') +
                    ($scope.reportSearch.s ? $scope.reportSearch.s : '') +
                    ($scope.reportSearch.realm ? $scope.reportSearch.realm : '') +
                    ($scope.reportSearch.tag ? $scope.reportSearch.tag : '') +
                    ($scope.reportSearch.code ? $scope.reportSearch.code : '') +
                    ' - audroam.com';
            if ($scope.viewMode.zenMode) {
                enterZenFromReportResult();
            }
            else if ($scope.viewMode.presentMode) {
                enterPresentFromReportResult();
            }
            // Enrich View History captions once we have row fields (task/topic/body).
            try {
                var argsPnid = response.data.args && response.data.args.pnid != null
                    ? Number(response.data.args.pnid)
                    : null;
                var onlyPnid = $scope.viewMode.initialSearchOnlyPNID
                    ? Number($scope.viewMode.initialSearchOnlyPNID)
                    : null;
                var pnid_1 = argsPnid || onlyPnid;
                if (pnid_1 && $scope.reportResult && $scope.reportResult.length) {
                    var match = $scope.reportResult.find(function (r) { return Number(r.ID) === pnid_1; }) ||
                        ($scope.reportResult.length === 1 ? $scope.reportResult[0] : null);
                    if (match) {
                        historyService.enrichViewEntry(pnid_1, match);
                        $scope.history = historyService.getAllHistory();
                    }
                }
            }
            catch (_a) {
                /* ignore history enrich errors */
            }
            // Thread pills (membership progress + unlink dropdown)
            try {
                if (typeof $scope.refreshThreadPills === 'function') {
                    $scope.refreshThreadPills();
                }
            }
            catch (_b) {
                /* ignore */
            }
            // Focus T/S chips on search rows need openMeta/sessionMeta.
            // Board Recent already applied focus meta — skip a second GET /focus/state on View here.
            try {
                var hasFocusMeta = $scope.openMeta != null || $scope.sessionMeta != null;
                if (!hasFocusMeta &&
                    typeof $scope.refreshFocusState === 'function') {
                    $scope.refreshFocusState();
                }
            }
            catch (_c) {
                /* ignore */
            }
            if (response.data.args.pnid == null) {
                $scope.reportSearch.pnid = undefined;
            }
            if (response.data.args.d1 != null) {
                $scope.reportSearch.d1 = new Date(response.data.args.d1);
            }
            if (response.data.args.d2 != null) {
                $scope.reportSearch.d2 = new Date(response.data.args.d2);
            }
            if (response.data.args.dr != null) {
                $scope.reportSearch.dr = new Date(response.data.args.dr);
            }
            $timeout(function () {
                var _a;
                (_a = $window.document.getElementById('report-results')) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: 'smooth' });
            }, 1000);
            //$scope.debugMessage = response.data;
        }
    }
    $scope.setLocalEntity = function (entity, ui) {
        ui.severity = entity.severity;
    };
    $scope.updateEntity = function (entity, ui) {
        ui.message = '...';
        person16Service.updateEntity(entity).then(function (response) {
            if (response.data.Result == 'OK') {
                ui.message = 'OK';
                ui.severity = entity.severity;
                ui.showUI = false;
                // refresh the focus UI
                $scope.reloadFocus();
            }
        }, function (response) {
            ui.message = 'ERROR';
        });
    };
    $scope.updateEntityHistory = function (args, ui) {
        ui.message = '...';
        person16Service.updateEntityHistory(args).then(function (response) {
            if (response.data.Result == 'OK') {
                ui.message = 'OK';
                ui.showUI = false;
                // refresh the focus UI
                $scope.reloadFocus();
            }
        }, function () {
            ui.message = 'ERROR';
        });
    };
    $scope.fetchEntityStatus = function () {
        $scope.viewMode.Message = 'Updating...';
        try {
            $scope.viewMode.actionLoading = true;
        }
        catch (_a) { }
        person16Service.entityStatus().then(function (response) {
            if (response.data.Result == 'OK') {
                $scope.viewMode.Message = 'OK';
                $scope.entities = response.data.Rows;
                $scope.chartStatus = response.data.Charts.chart1;
            }
        }, function (response) {
            $scope.viewMode.Message = 'ERROR';
        });
    };
    $scope.activeSearch = function (args, editId, ui) {
        args = args === undefined ? { ds: -90 } : args;
        args.done = 0;
        $scope.personSearch(args, editId, ui);
    };
    $scope.personSearch = personSearch;
    function personSearch(args, editID, ui) {
        if (editID === void 0) { editID = 0; }
        $scope.viewMode.Message = 'Updating...';
        if (ui) {
            ui.message = '...';
        }
        // Smart history recording
        historyService.recordSearchFromArgs(args);
        $scope.history = historyService.getAllHistory();
        return personService.search(args).then(function (response) {
            if (response.data.Result == 'OK') {
                $scope.viewMode.Message = 'OK';
                if (ui) {
                    ui.message = 'OK';
                }
                bindResult(response);
                // open edit mode for the supplied row ID (e.g. recent "Edit Here")
                // Multi-edit safe: do not close other open notes — events are rowId-scoped.
                if (editID > 0) {
                    var opened_1 = false;
                    angular_1.default.forEach($scope.reportResult, function (obj) {
                        if (Number(obj.ID) === Number(editID)) {
                            $scope.editResultRow(obj);
                            opened_1 = true;
                        }
                    });
                    if (!opened_1 && $scope.reportResult && $scope.reportResult.length === 1) {
                        $scope.editResultRow($scope.reportResult[0]);
                    }
                }
            }
            else {
                $scope.viewMode.Message = response.data.Message;
            }
        }, function (error) {
            console.log('❌ personSearch error handler called with:', error.status, error.statusText);
            $scope.viewMode.Message = 'ERROR';
            if (ui) {
                ui.message = 'ERROR';
            }
        });
    }
    $scope.postURI = function (uri, args, clearForm, keyEvent, clearValue, callback) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            // prevent submitting a form if enter is pressed
            if (keyEvent !== undefined && keyEvent !== null) {
                keyEvent.preventDefault();
            }
            $scope.viewMode.Message = 'Updating...';
            if (clearForm !== undefined && clearForm !== null) {
                $scope[clearForm].uiMessage = '...';
            }
            return [2 /*return*/, $http
                    .post(uri, args)
                    .then(function (response) {
                    if (response.data.Result == 'OK') {
                        if (clearForm !== undefined && clearForm !== null) {
                            // Replace the form with a message
                            // This clears the entire object and leaves an OK message in its place
                            $scope[clearForm] = clearValue ? clearValue : { uiMessage: 'OK' };
                        }
                        $scope.bindResult(response);
                        // After a save, fast-merge into Recent only when the board Recent UI is active
                        try {
                            if (!isRecentUiEnabled()) {
                                // search/view/report: do not spawn recentRows
                            }
                            else {
                                var dataAny = response.data || {};
                                var newId_1 = dataAny.rowID || dataAny.RowID || dataAny.ID;
                                if (newId_1 && typeof newId_1 === 'number') {
                                    personService.getRowById(newId_1).then(function (r) {
                                        if (r && r.data && r.data.Result === 'OK' && r.data.Row) {
                                            var i = -1;
                                            if (Array.isArray($scope.recentRows)) {
                                                for (var j = 0; j < $scope.recentRows.length; j++) {
                                                    var x = $scope.recentRows[j];
                                                    if (x && x.ID === newId_1) {
                                                        i = j;
                                                        break;
                                                    }
                                                }
                                            }
                                            if (i >= 0) {
                                                $scope.recentRows[i] = r.data.Row;
                                            }
                                            else if (Array.isArray($scope.recentRows)) {
                                                $scope.recentRows.unshift(r.data.Row);
                                            }
                                            else {
                                                $scope.recentRows = [r.data.Row];
                                            }
                                        }
                                        // One full recent for openMeta / ordering (not a multi-poll burst)
                                        refreshRecentAfterMutation();
                                    }, function () {
                                        refreshRecentAfterMutation();
                                    });
                                }
                                else {
                                    refreshRecentAfterMutation();
                                }
                            }
                        }
                        catch (e) {
                            refreshRecentAfterMutation();
                        }
                        if (response.data.feedback !== undefined) {
                            $scope.feedbackRows = response.data.feedback;
                        }
                        $scope.viewMode.Message = 'OK';
                    }
                    else {
                        $scope.viewMode.ErrorMessage = response;
                        $scope.viewMode.Message = 'Error';
                    }
                }, function (response) {
                    $scope.viewMode.message = 'HTTP or Script Error';
                    console.log('❌ postURI error handler called with status:', response.status);
                    console.log('reject in $scope.postURI');
                    return $q.reject(response);
                })
                    .then(function () {
                    callback && callback();
                })
                    .finally(function () {
                    try {
                        $scope.viewMode.actionLoading = false;
                    }
                    catch (_a) { }
                })];
        });
    }); };
    // Schedule service methods for dedicated API calls
    function handleTaskAction(promise, successMessage, errorMessage, row, refreshRecent, onSuccess) {
        if (refreshRecent === void 0) { refreshRecent = false; }
        if (row) {
            row.taskActionLoading = true;
        }
        $scope.viewMode.hitMessage = '...';
        return promise
            .then(function (result) {
            $scope.fetchSchedule();
            // Show success feedback
            if (row) {
                row.taskActionMessage = '✓';
                row.taskActionLoading = false;
                // Clear success message after 2 seconds
                $timeout(function () { return row.taskActionMessage = null; }, 2000);
            }
            $scope.viewMode.hitMessage = successMessage;
            // Store persistent action result for testing/debugging
            $scope.viewMode.lastActionResult = {
                success: true,
                message: successMessage,
                timestamp: Date.now(),
                action: successMessage.toLowerCase().replace(/\s+/g, '_')
            };
            $timeout(function () { return $scope.viewMode.hitMessage = ''; }, 3000);
            if (refreshRecent) {
                $scope.fetchRecent();
            }
            if (onSuccess) {
                onSuccess(result);
            }
        })
            .catch(function (error) {
            console.error('Task action error:', error);
            // Show error feedback
            if (row) {
                row.taskActionMessage = '✗ Error';
                row.taskActionLoading = false;
                // Clear error message after 5 seconds
                $timeout(function () { return row.taskActionMessage = null; }, 5000);
            }
            $scope.viewMode.hitMessage = errorMessage;
            // Store persistent action result for testing/debugging
            $scope.viewMode.lastActionResult = {
                success: false,
                message: errorMessage,
                timestamp: Date.now(),
                error: error.message || 'Unknown error'
            };
            $timeout(function () { return $scope.viewMode.hitMessage = ''; }, 5000);
        });
    }
    /** Build taskAction payload from schedule row ID (auth is JWT header — no per-row tokens). */
    function scheduleTaskPayload(row, type) {
        var id = row && (row.ID != null ? row.ID : row.taskId);
        return { taskId: Number(id), type: type };
    }
    /**
     * Schedule ##top pin handle menu.
     * - switchRealm: context only
     * - startSession: open Focus **S** (session envelope — not a “shift” product)
     * - startTravel / startInterruption / startTask: Focus **T** fragments under the pin
     */
    $scope.handleTopAction = function (row, mode) {
        var _a, _b;
        if (!row) {
            return $q.reject(new Error('missing top action row'));
        }
        var focusErrMessage = function (err, fallback) {
            if (!err)
                return fallback;
            if (typeof err === 'string' && err.trim())
                return err;
            if (err.message && String(err.message).trim() && !/^Request failed/i.test(String(err.message))) {
                return String(err.message);
            }
            var data = err.data || err;
            var msg = (data && (data.Message || data.message || data.error || data.Error)) ||
                (err.statusText && String(err.statusText)) ||
                fallback;
            return String(msg);
        };
        var mark = function (msg, ok) {
            try {
                row.taskActionLoading = ok === undefined;
                row.taskActionMessage = msg;
                if (ok !== undefined) {
                    $timeout(function () {
                        if (row) {
                            row.taskActionLoading = false;
                            row.taskActionMessage = null;
                        }
                    }, ok ? 3500 : 5000);
                }
            }
            catch (_a) {
                /* ignore */
            }
        };
        var afterFocus = function (data) {
            applyFocusStatePayload(data);
            try {
                if ($scope.fetchRecentOnly)
                    $scope.fetchRecentOnly();
            }
            catch (_a) { }
            try {
                scheduleFilterRefetch(SCHEDULE_FILTER_DEBOUNCE_MS);
            }
            catch (_b) { }
            return data;
        };
        var ctx = (0, scheduleTopActions_1.scheduleRowFocusContext)(row);
        if (mode === 'switchRealm') {
            if (!ctx.account && !ctx.realm) {
                try {
                    (_b = (_a = $scope).toast) === null || _b === void 0 ? void 0 : _b.call(_a, 'Pin has no account/realm — set pnAssetAccount/pnAssetRealm on the ##top note', 'warning', 5000);
                }
                catch (_c) { }
                return $q.reject(new Error('top pin missing account/realm'));
            }
            mark('…');
            return $scope
                .setCurrentRealm({ account: ctx.account, realm: ctx.realm })
                .then(function (data) {
                var _a, _b;
                mark('✓ realm', true);
                try {
                    (_b = (_a = $scope).toast) === null || _b === void 0 ? void 0 : _b.call(_a, "Switched to ".concat(ctx.account || '—').concat(ctx.realm ? ' / ' + ctx.realm : ''), 'success', 3000);
                }
                catch (_c) { }
                try {
                    scheduleFilterRefetch(SCHEDULE_FILTER_DEBOUNCE_MS);
                }
                catch (_d) { }
                return data;
            })
                .catch(function (err) {
                mark('✗', false);
                return $q.reject(err);
            });
        }
        // Session envelope (Focus S) — no Shift topic; parent = pin id; never ##top tag
        if (mode === 'startSession') {
            var sPayload = (0, scheduleTopActions_1.topActionSessionEnvelopePayload)(row);
            mark('…');
            return pilotNotesSyncService
                .startFocusS({
                parentId: sPayload.parentId,
                taskGroup: sPayload.taskGroup,
                topicGroup: sPayload.topicGroup,
                topicDetail: sPayload.topicDetail,
                account: sPayload.account || undefined,
                realm: sPayload.realm || undefined,
                assetAccount: sPayload.assetAccount || undefined,
                assetRealm: sPayload.assetRealm || undefined,
                assetTag: sPayload.assetTag,
                assetTagAux: sPayload.assetTagAux,
            })
                .then(function (data) {
                var _a, _b;
                afterFocus(data);
                mark('✓ session', true);
                try {
                    (_b = (_a = $scope).toast) === null || _b === void 0 ? void 0 : _b.call(_a, data.reused
                        ? "Session (S) already open #".concat(data.ID)
                        : "Started session (S) #".concat(data.ID), 'success', 3000);
                }
                catch (_c) { }
                return data;
            })
                .catch(function (err) {
                var _a, _b;
                mark('✗', false);
                try {
                    (_b = (_a = $scope).toast) === null || _b === void 0 ? void 0 : _b.call(_a, focusErrMessage(err, 'Start session failed'), 'danger', 5000);
                }
                catch (_c) { }
                return $q.reject(err);
            });
        }
        // T fragments under pin: travel / interruption / task
        var payload = (0, scheduleTopActions_1.topActionStartPayload)(row, mode);
        mark('…');
        return pilotNotesSyncService
            .startFocusT({
            parentId: payload.parentId,
            taskGroup: payload.taskGroup,
            topicGroup: payload.topicGroup,
            topicDetail: payload.topicDetail,
            account: payload.account || undefined,
            realm: payload.realm || undefined,
            assetAccount: payload.assetAccount || undefined,
            assetRealm: payload.assetRealm || undefined,
            assetTag: payload.assetTag,
            assetTagAux: payload.assetTagAux,
        })
            .then(function (data) {
            var _a, _b;
            afterFocus(data);
            var label = mode === 'startInterruption'
                ? 'interruption'
                : mode === 'startTravel'
                    ? 'travel'
                    : 'task';
            mark('✓ ' + label, true);
            try {
                var msg = data.closedTId
                    ? "Started ".concat(label, " T #").concat(data.ID, " (closed prior #").concat(data.closedTId, ")")
                    : "Started ".concat(label, " T #").concat(data.ID);
                if (mode === 'startInterruption') {
                    msg +=
                        ' · later: Add as task parent if work stuck, or set parent to an existing task';
                }
                (_b = (_a = $scope).toast) === null || _b === void 0 ? void 0 : _b.call(_a, msg, 'success', mode === 'startInterruption' ? 7000 : 4000);
            }
            catch (_c) { }
            return data;
        })
            .catch(function (err) {
            var _a, _b;
            mark('✗', false);
            try {
                (_b = (_a = $scope).toast) === null || _b === void 0 ? void 0 : _b.call(_a, focusErrMessage(err, 'Top action failed'), 'danger', 5000);
            }
            catch (_c) { }
            return $q.reject(err);
        });
    };
    /**
     * Schedule board Start (top pins + row timer): Python Focus T under the schedule note.
     * PHP taskAction start inserts Activity/Start without reliable person_focus_state → orphans.
     */
    $scope.startTask = function (dataOrRow, row) {
        var _a, _b;
        // Prefer row when provided; accept legacy {taskId,type} first arg for older templates/tests
        var target = row || dataOrRow;
        var id = target && (target.ID != null ? target.ID : target.taskId != null ? target.taskId : null);
        if (id == null || Number(id) <= 0) {
            try {
                (_b = (_a = $scope).toast) === null || _b === void 0 ? void 0 : _b.call(_a, 'Cannot start: missing schedule row', 'danger', 4000);
            }
            catch (_c) { }
            return $q.reject(new Error('missing schedule row'));
        }
        // Normalize so startFocusTFromRow gets a full row when possible
        var rowForFocus = target && target.ID != null
            ? target
            : {
                ID: Number(id),
                pnAssetTag: target === null || target === void 0 ? void 0 : target.pnAssetTag,
                pnAssetTagAux: target === null || target === void 0 ? void 0 : target.pnAssetTagAux,
                pnAssetAccount: (target === null || target === void 0 ? void 0 : target.pnAssetAccount) || (target === null || target === void 0 ? void 0 : target.pnAccount),
                pnAssetRealm: (target === null || target === void 0 ? void 0 : target.pnAssetRealm) || (target === null || target === void 0 ? void 0 : target.pnUserRealm),
                pnAccount: target === null || target === void 0 ? void 0 : target.pnAccount,
                pnUserRealm: target === null || target === void 0 ? void 0 : target.pnUserRealm,
                pnItemCode: target === null || target === void 0 ? void 0 : target.pnItemCode,
                pnBody: target === null || target === void 0 ? void 0 : target.pnBody,
            };
        if (rowForFocus) {
            rowForFocus.taskActionLoading = true;
            rowForFocus.taskActionMessage = '…';
        }
        return $scope
            .startFocusTFromRow(rowForFocus, function () {
            try {
                if ($scope.fetchRecentOnly) {
                    $scope.fetchRecentOnly();
                }
            }
            catch (_a) { }
            // Do NOT call fetchSchedule() immediately here.
            // applyFocusStatePayload may change CurrentAccount/Realm → $watchGroup
            // already debounces an Active schedule refetch. One more immediate
            // fetch was stacking 2–3 identical active=1 loads after start-t.
            try {
                scheduleFilterRefetch(SCHEDULE_FILTER_DEBOUNCE_MS);
            }
            catch (_b) { }
        })
            .then(function (data) {
            if (rowForFocus) {
                rowForFocus.taskActionLoading = false;
                rowForFocus.taskActionMessage = '✓ Focus T';
                $timeout(function () {
                    if (rowForFocus)
                        rowForFocus.taskActionMessage = null;
                }, 3000);
            }
            $scope.viewMode.hitMessage = (data === null || data === void 0 ? void 0 : data.closedTId)
                ? "Started T #".concat(data.ID, " (closed prior #").concat(data.closedTId, ")")
                : "Started Focus T #".concat(data.ID);
            $timeout(function () { return ($scope.viewMode.hitMessage = ''); }, 4000);
            // Account/realm from server focus payload (applyFocusStatePayload).
            return data;
        })
            .catch(function (err) {
            if (rowForFocus) {
                rowForFocus.taskActionLoading = false;
                rowForFocus.taskActionMessage = '✗ Error';
                $timeout(function () {
                    if (rowForFocus)
                        rowForFocus.taskActionMessage = null;
                }, 5000);
            }
            $scope.viewMode.hitMessage = 'Task start error';
            $timeout(function () { return ($scope.viewMode.hitMessage = ''); }, 5000);
            return $q.reject(err);
        });
    };
    $scope.topTask = function (dataOrRow, row) {
        var target = row || dataOrRow;
        var payload = dataOrRow && dataOrRow.taskId != null && dataOrRow.type
            ? dataOrRow
            : scheduleTaskPayload(target, 'top');
        handleTaskAction(scheduleService.topTask(payload), 'Task moved to top', 'Task move error', target, true);
    };
    $scope.laterTask = function (dataOrRow, row) {
        var target = row || dataOrRow;
        var payload = dataOrRow && dataOrRow.taskId != null && dataOrRow.type
            ? dataOrRow
            : scheduleTaskPayload(target, 'later');
        handleTaskAction(scheduleService.laterTask(payload), 'Task moved later', 'Task move error', target, true);
    };
    $scope.doneTask = function (dataOrRow, row) {
        var target = row || dataOrRow;
        var payload = dataOrRow && dataOrRow.taskId != null && dataOrRow.type
            ? dataOrRow
            : scheduleTaskPayload(target, 'done');
        handleTaskAction(scheduleService.doneTask(payload), 'OK', 'Task complete error', target, true);
    };
    /**
     * Load schedule from local cache only (no server). Used on page load / person bind.
     */
    function hydrateScheduleFromCache(personId) {
        var _a;
        var id = personId !== null && personId !== void 0 ? personId : (_a = $scope.person) === null || _a === void 0 ? void 0 : _a.dbPK;
        if (!id) {
            return;
        }
        offlineDataService.loadScheduleSnapshot(id).then(function (snapshot) {
            var _a;
            if ((_a = snapshot === null || snapshot === void 0 ? void 0 : snapshot.rows) === null || _a === void 0 ? void 0 : _a.length) {
                $scope.scheduleRows = snapshot.rows;
                $scope.viewMode.offlineScheduleActive = true;
                $scope.viewMode.hitMessage = 'Cached schedule';
                $scope.$applyAsync();
            }
        });
    }
    /** Min chars before schedule `q` hits the server (avoids 1-char full-board refilters). */
    var SCHEDULE_Q_MIN_CHARS = 2;
    /** Debounce when only the search box changed. */
    var SCHEDULE_SEARCH_DEBOUNCE_MS = 700;
    /** Debounce for account / realm / Active toggles. */
    var SCHEDULE_FILTER_DEBOUNCE_MS = 400;
    /** Effective server `q` — only when trimmed length >= SCHEDULE_Q_MIN_CHARS. */
    function effectiveScheduleQ(raw) {
        var q = String(raw != null ? raw : $scope.searchText || '').trim();
        return q.length >= SCHEDULE_Q_MIN_CHARS ? q : undefined;
    }
    /** Build schedule API opts from current UI filters + limit. */
    function scheduleFetchOpts(limit) {
        var _a, _b;
        var shown = Number($scope.viewMode.scheduleRows) || 3;
        var lim = 100;
        if (typeof limit === 'number' && limit > 0) {
            lim = limit;
        }
        else {
            lim = shown >= 100 ? 500 : 100;
        }
        lim = Math.max(1, Math.min(500, lim));
        var opts = { limit: lim };
        var q = effectiveScheduleQ();
        if (q) {
            opts.q = q;
        }
        var acct = String($scope.filterScheduleAccount || '').trim();
        var realm = String($scope.filterScheduleRealm || '').trim();
        if (acct) {
            opts.account = acct;
        }
        if (realm) {
            opts.realm = realm;
        }
        // Active board: pass explicit CurrentAccount/Realm from client focus context.
        // Do not use active=1 alone — PHP resolves that from pilot_people, which can lag
        // Python focus writes (or race mid-transition). Explicit params match the focus
        // we just applied so schedule filters the newly started realm.
        if ($scope.viewMode.filterScheduleActive && !acct && !realm) {
            var focusAcct = String(((_a = $scope.person) === null || _a === void 0 ? void 0 : _a.CurrentAccount) || '').trim();
            var focusRealm = String(((_b = $scope.person) === null || _b === void 0 ? void 0 : _b.CurrentRealm) || '').trim();
            if (focusAcct) {
                opts.account = focusAcct;
            }
            if (focusRealm) {
                opts.realm = focusRealm;
            }
            // Fallback only when person chrome has no context yet
            if (!focusAcct && !focusRealm) {
                opts.active = true;
            }
        }
        return opts;
    }
    /**
     * Explicit schedule fetch (refresh / expand / filter / after mutations). Never auto-polled.
     * Pass a number for limit; filters come from searchText / account / realm / Active.
     *
     * Coalesces concurrent calls (focus account apply + filter watch + startTask used to
     * stack 2–3 identical active=1 requests after start-t).
     */
    var scheduleFetchInFlight = null;
    var scheduleFetchRerun = false;
    $scope.fetchSchedule = function (limitOrForce) {
        var limit = typeof limitOrForce === 'number' && limitOrForce > 0 ? limitOrForce : undefined;
        var opts = scheduleFetchOpts(limit);
        if (scheduleFetchInFlight) {
            // Another caller wants a fetch while one is running — rerun once with latest opts
            scheduleFetchRerun = true;
            return scheduleFetchInFlight;
        }
        $scope.viewMode.hitMessage = '...';
        scheduleFetchInFlight = personService
            .getSchedule(opts)
            .then(function (data) {
            var _a;
            $scope.scheduleRows = data.Data;
            $scope.viewMode.scheduleLimit =
                data.limit != null ? data.limit : opts.limit;
            $scope.viewMode.scheduleTruncated = !!data.truncated;
            $scope.viewMode.scheduleCount =
                data.count != null ? data.count : (data.Data || []).length;
            $scope.viewMode.scheduleServerFiltered = !!(opts.q ||
                opts.account ||
                opts.realm ||
                opts.active);
            // Compact status only — skip pin count and acct/realm filter noise (space for pin pills)
            var bits = [];
            if (opts.active)
                bits.push('active');
            if (opts.q)
                bits.push('q');
            $scope.viewMode.hitMessage = data.truncated
                ? 'OK (top ' +
                    ($scope.viewMode.scheduleCount || opts.limit) +
                    (bits.length ? ' · ' + bits.join('+') : '') +
                    ')'
                : bits.length
                    ? 'OK · ' + bits.join('+')
                    : 'OK';
            // Always merge ##top pins into schedule cache (Active filter must not drop pins).
            // Full unfiltered board also replaces non-top rows; filtered fetches keep prior board.
            if (((_a = $scope.person) === null || _a === void 0 ? void 0 : _a.dbPK) && Array.isArray(data === null || data === void 0 ? void 0 : data.Data)) {
                var personId_1 = $scope.person.dbPK;
                var filtered_1 = !!(opts.q || opts.account || opts.realm || opts.active);
                offlineDataService
                    .loadScheduleSnapshot(personId_1)
                    .then(function (prev) {
                    var merged = (0, scheduleTopActions_1.mergeScheduleCacheRows)({
                        previousRows: (prev === null || prev === void 0 ? void 0 : prev.rows) || [],
                        nextRows: data.Data,
                        // Unfiltered fetch replaces board; Active/q keeps prior board + merges tops
                        replaceBoard: !filtered_1,
                    });
                    return offlineDataService.cacheScheduleSnapshot({
                        personId: personId_1,
                        cachedAt: new Date().toISOString(),
                        rows: merged,
                        limit: opts.limit,
                    });
                })
                    .catch(function () {
                    /* cache best-effort */
                });
            }
            $scope.viewMode.offlineScheduleActive = false;
            $scope.$applyAsync();
            return data;
        })
            .catch(function (error) {
            var _a;
            console.error('❌ fetchSchedule error:', error);
            if (offlineDataService.shouldUseLocalFallback(error)) {
                offlineDataService.loadScheduleSnapshot((_a = $scope.person) === null || _a === void 0 ? void 0 : _a.dbPK).then(function (snapshot) {
                    var _a;
                    if ((_a = snapshot === null || snapshot === void 0 ? void 0 : snapshot.rows) === null || _a === void 0 ? void 0 : _a.length) {
                        $scope.scheduleRows = snapshot.rows;
                        $scope.viewMode.offlineScheduleActive = true;
                        $scope.viewMode.hitMessage = 'Cached schedule';
                        return;
                    }
                    $scope.viewMode.hitMessage = 'Schedule unavailable offline';
                });
            }
            else {
                $scope.viewMode.hitMessage = 'Schedule load error';
            }
            $timeout(function () { return ($scope.viewMode.hitMessage = ''); }, 5000);
        })
            .finally(function () {
            scheduleFetchInFlight = null;
            if (scheduleFetchRerun) {
                scheduleFetchRerun = false;
                // Latest filters (e.g. new CurrentAccount after focus) win
                $timeout(function () { return $scope.fetchSchedule(limitOrForce); }, 0);
            }
        });
        return scheduleFetchInFlight;
    };
    // Debounced server re-query when schedule filters change (Active / search / account / realm)
    var scheduleFilterTimer;
    function scheduleFilterRefetch(debounceMs) {
        if (debounceMs === void 0) { debounceMs = SCHEDULE_FILTER_DEBOUNCE_MS; }
        if (!$scope.viewMode.timeTrackingActive && !$scope.viewMode.fetchEnabled) {
            return;
        }
        if (scheduleFilterTimer) {
            $timeout.cancel(scheduleFilterTimer);
        }
        scheduleFilterTimer = $timeout(function () {
            scheduleFilterTimer = undefined;
            // Only hit server when board is in use (person logged in + fetch enabled)
            if ($scope.person && $scope.person.loginName && $scope.viewMode.fetchEnabled) {
                $scope.fetchSchedule();
            }
        }, debounceMs);
    }
    $scope.$watchGroup([
        function () { return $scope.searchText; },
        function () { return $scope.filterScheduleAccount; },
        function () { return $scope.filterScheduleRealm; },
        function () { return $scope.viewMode.filterScheduleActive; },
        function () { return $scope.person && $scope.person.CurrentAccount; },
        function () { return $scope.person && $scope.person.CurrentRealm; },
    ], function (newVals, oldVals) {
        // Angular init: listener runs once with identical values — skip
        if (!oldVals || !newVals) {
            return;
        }
        if (newVals.length === oldVals.length && newVals.every(function (v, i) { return v === oldVals[i]; })) {
            return;
        }
        var searchChanged = newVals[0] !== oldVals[0];
        var otherChanged = newVals.slice(1).some(function (v, i) { return v !== oldVals[i + 1]; });
        // 0–1 char search does not change effective server `q` — skip refetch unless
        // other filters changed (or user cleared a previous 2+ char query).
        if (searchChanged && !otherChanged) {
            var prevQ = effectiveScheduleQ(oldVals[0]);
            var nextQ = effectiveScheduleQ(newVals[0]);
            if (prevQ === nextQ) {
                return;
            }
            // Longer debounce while typing the text filter
            scheduleFilterRefetch(SCHEDULE_SEARCH_DEBOUNCE_MS);
            return;
        }
        scheduleFilterRefetch(searchChanged ? SCHEDULE_SEARCH_DEBOUNCE_MS : SCHEDULE_FILTER_DEBOUNCE_MS);
    });
    /** Expand schedule list limit in UI and fetch more rows from server. */
    $scope.expandScheduleRows = function (n) {
        var target = Math.max(3, Math.min(500, Number(n) || 100));
        $scope.viewMode.scheduleRows = target;
        try {
            $scope.hitURI('api1.php?setScheduleRows=' + target, null);
        }
        catch (_a) { }
        $scope.fetchSchedule(target >= 100 ? 500 : Math.max(100, target));
    };
    $scope.collapseScheduleRows = function () {
        $scope.viewMode.scheduleRows = 3;
        try {
            $scope.hitURI('api1.php?setScheduleRows=3', null);
        }
        catch (_a) { }
        // Keep already-loaded rows; no need to re-fetch slim set
    };
    // fetch lists — always attempt; keep previous Lists on transport/timeout failure
    $scope.fetchLists = function () {
        listService.getAll().then(function (response) {
            if (response.data.Result === 'OK') {
                $scope.Lists = __assign(__assign({}, $scope.Lists), { TaskGroups: response.data.TaskGroups, TopicGroups: response.data.TopicGroups, TopicDetailOptions: response.data.TopicDetailOptions, ItemCodes: response.data.ItemCodes });
            }
        }, function () {
            /* keep cached lists on degraded network */
        });
    };
    $scope.getCurrentPerson = function () {
        return $scope.person;
    };
    $scope.getCurrentAccount = function () {
        var person = $scope.getCurrentPerson();
        return person ? person.CurrentAccount : undefined;
    };
    $scope.getCurrentRealm = function () {
        var person = $scope.getCurrentPerson();
        return person ? person.CurrentRealm : undefined;
    };
    // fetch person
    $scope.fetchPerson = function () {
        return personService
            .fetchPerson()
            .then(function (response) {
            $scope.setPerson(response.data.person.personObject);
            $scope.viewMode.personReady = true;
            return response;
        })
            .catch(function (err) {
            $scope.person = null;
            $scope.viewMode.personReady = true;
            return $q.reject(err);
        });
    };
    // Token refresh: reload person then emit (session lifecycle listens on userChanged)
    appEventsService.onTokenRefreshed(function () {
        if ($scope.isLoggingIn) {
            return;
        }
        $timeout(function () {
            var prevPk = personPkOf($scope.person);
            var p = $scope.fetchPerson();
            var done = function () {
                emitUserChanged('token_refreshed', prevPk);
            };
            if (p && typeof p.then === 'function') {
                p.then(done).catch(done);
            }
            else {
                done();
            }
        }, 0);
    });
    $rootScope.$on('waf:blocked', function (_event, data) {
        $scope.toast("Security filter blocked this save\n\n" +
            "".concat(data.details, "\n\n") +
            "Your draft is safe in local storage. Use Restore in the edit form, or rephrase and try again.", 'error', 15000);
    });
    // add notes
    $scope.addNote = function (keyEvent, prefix, note, clear) {
        // prevent submitting a form if enter is pressed
        if (keyEvent !== undefined && keyEvent !== null)
            keyEvent.preventDefault();
        $http
            .get(config.basePath + 'api1.php', {
            params: {
                json: 'addNotesOnly',
                addNotes: note.body,
                addNotesPrefix: prefix,
                addNotesObject: note,
            },
        })
            .then(function (response) {
            if (response.data.Result == 'OK') {
                if (clear !== undefined)
                    $scope[clear] = null;
                $scope.fetchRecent();
            }
        });
    };
    // add schedule
    $scope.addSchedule = function (addSchedule, keyEvent) {
        // prevent submitting a form if enter is pressed
        if (keyEvent !== undefined && keyEvent !== null)
            keyEvent.preventDefault();
        $scope.viewMode.hitMessage = '...';
        scheduleService
            .addSchedule({
            body: addSchedule.body,
            tag: addSchedule.tag,
            bike: addSchedule.bike,
        })
            .then(function (response) {
            // push the response into the array, rather than refreshing the entire list
            if (response.Result == 'OK') {
                $scope.viewMode.hitMessage = 'OK';
                $scope.addSchedule.body = '';
                $scope.addSchedule.tag = '';
                $scope.addSchedule.bike = '';
                // Store persistent action result for testing/debugging
                $scope.viewMode.lastActionResult = {
                    success: true,
                    message: 'OK',
                    timestamp: Date.now(),
                    action: 'add_schedule'
                };
                $scope.fetchSchedule();
                // Clear success message after 3 seconds
                $timeout(function () {
                    $scope.viewMode.hitMessage = '';
                }, 3000);
            }
            else {
                $scope.viewMode.hitMessage = '?';
                // Store persistent action result for testing/debugging
                $scope.viewMode.lastActionResult = {
                    success: false,
                    message: '?',
                    timestamp: Date.now(),
                    action: 'add_schedule',
                    error: response.Result || 'Unknown error'
                };
            }
        })
            .catch(function (error) {
            console.error('Add schedule failed:', error);
            $scope.viewMode.hitMessage = 'ERROR';
        });
    };
    // Show Focus editable
    $scope.showFocusEdit = function () {
        $scope.uiPerson = angular_1.default.copy($scope.person);
        $scope.viewMode.showFocusPanel1 = true;
    };
    // Limit chart to last x days
    $scope.setPersonFocusChartDays = function (days) {
        if ($scope.tagStatus.chart1) {
            var minValue = '2017-09-01';
            if (moment) {
                minValue = moment().subtract(days, 'days');
            }
            //console.log(moment);
            $scope.tagStatus.chart1.options.scales.xAxes[0].time.min = minValue;
            $scope.tagStatus.chart1.options.scales.xAxes[0].time.max = new Date();
            // $scope.tagStatus.chart1.options.scales.xAxes[0].time.suggestedMin = minValue;
            $scope.tagStatus.chart1.options.scales.xAxes[0].ticks.min = minValue;
            $scope.tagStatus.chart1.options.scales.xAxes[0].ticks.max = new Date();
            $scope.tagStatus.chart1.options.scales.xAxes[0].bounds = 'ticks';
            // moment( moment().subtract(30, 'days') ).format("YYYY-MM-DD")
        }
    };
    // Set Person Focus
    $scope.setPersonFocus = function (focus, ui) {
        if (ui == undefined || ui == null) {
            ui = {};
        }
        ui.message = '...';
        person16Service.setPersonFocus(focus).then(function (response) {
            var _a, _b;
            if (response.data.Result == 'OK') {
                ui.message = 'OK';
                focus.setRedBike = undefined;
                $scope.tagStatus = response.data.bikeStatus.data;
                //$scope.chart1 = response.data.bikeStatus.data.chart1;
                $scope.viewMode.showCurrentPanel = true;
                var focusAccount = (focus === null || focus === void 0 ? void 0 : focus.account) || ((_a = $scope.person) === null || _a === void 0 ? void 0 : _a.CurrentAccount);
                var focusRealm = (focus === null || focus === void 0 ? void 0 : focus.realm) || ((_b = $scope.person) === null || _b === void 0 ? void 0 : _b.CurrentRealm);
                if (focusAccount && focusRealm) {
                    historyService.addFocusEntry(focusRealm, focusAccount);
                }
                $scope.fetchPerson();
            }
            else {
                // api error
                ui.message = '?';
            }
        }, function () {
            // http or script error
            ui.message = 'ERROR';
        });
    };
    // Edit Row
    // From Recent
    $scope.editRow = function (row) {
        if ($scope.ui === undefined)
            $scope.ui = {};
        $scope.ui.RecentEdit = angular_1.default.copy(row);
        $scope.ui.RecentEdit.pnValue = parseFloat(row.pnValue);
    };
    $scope.editResultRow = function (row) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        console.log('TimeDurationPicker: editResultRow called', {
            rowId: row.ID,
            pnCustomTimeUTC: row.pnCustomTimeUTC,
            pnCompletedUTC: row.pnCompletedUTC,
            pnValue: row.pnValue,
            pnValueUnit: row.pnValueUnit
        });
        // Multi-edit: leave other open row.edit forms alone. Draft/typing/outline events
        // are scoped by rowId so one note cannot stomp another.
        //
        // Re-open same note from server while edit is in progress:
        // 1) flush live outline → form
        // 2) seal local draft/working from the in-progress form
        // 3) load server record as the new edit baseline
        // 4) open() surfaces draft/working indicators when local ≠ server
        try {
            $rootScope.$broadcast('audOutlineFlush', { rowId: row.ID });
        }
        catch (_j) {
            /* ignore */
        }
        try {
            // Prefer live form on this object; sealInProgress also covers a prior row object
            // after search rebind (session still keyed by ID).
            if (row.edit) {
                resultRowDraftService.flush(row, 'edit', (_a = $scope.person) === null || _a === void 0 ? void 0 : _a.dbPK);
            }
            resultRowDraftService.sealInProgressEdit(row.ID, (_b = $scope.person) === null || _b === void 0 ? void 0 : _b.dbPK, 'edit');
        }
        catch (_k) {
            /* ignore */
        }
        clearRowUiMessage(row);
        row.edit = angular_1.default.copy(row);
        // Textarea / map chrome — local + server pnDisplayStyle (KB/brainstorm dogfood)
        try {
            var pid = (_f = (_d = (_c = $scope.person) === null || _c === void 0 ? void 0 : _c.dbPK) !== null && _d !== void 0 ? _d : (_e = $scope.person) === null || _e === void 0 ? void 0 : _e.personId) !== null && _f !== void 0 ? _f : (_g = $scope.person) === null || _g === void 0 ? void 0 : _g.ID;
            (0, outlineMapPrefs_1.mergeServerDisplayStyleIntoLocal)(pid, row.ID, row);
            (0, outlineMapPrefs_1.applyRowDisplayStyleToEdit)(pid, row.ID, row.edit);
        }
        catch (_l) {
            /* ignore */
        }
        if (!row.edit.bodyRows) {
            row.edit.bodyRows = 12;
        }
        row.edit.pnParentFK = parseInt(row.pnParentFK);
        row.edit.pnParentAddFK = parseInt(row.pnParentAddFK);
        row.edit.pnValue = parseFloat(row.pnValue);
        // Set UTC Date objects for datetime-local inputs (Angular handles local display)
        if (row.pnCustomTimeUTC) {
            // Convert UTC to local Date object
            var utcDate = new Date(row.pnCustomTimeUTC);
            console.log('TimeDurationPicker: converting start time', {
                utcString: row.pnCustomTimeUTC,
                utcDate: utcDate,
                isValid: !isNaN(utcDate.getTime()),
                timestamp: utcDate.getTime(),
                isEpoch: utcDate.getTime() === 0
            });
            if (!isNaN(utcDate.getTime()) && utcDate.getTime() !== 0) {
                row.edit.pnCustomTimeUTC = utcDate;
                console.log('TimeDurationPicker: start time set to UTC Date', {
                    utcDate: row.edit.pnCustomTimeUTC
                });
            }
            else {
                row.edit.pnCustomTimeUTC = null;
                console.log('TimeDurationPicker: start time set to null due to validation failure');
            }
        }
        else {
            row.edit.pnCustomTimeUTC = null;
            console.log('TimeDurationPicker: start time was null, set to null');
        }
        if (row.pnCompletedUTC) {
            // Convert UTC to local Date object
            var utcDate = new Date(row.pnCompletedUTC);
            console.log('TimeDurationPicker: converting end time', {
                utcString: row.pnCompletedUTC,
                utcDate: utcDate,
                isValid: !isNaN(utcDate.getTime()),
                timestamp: utcDate.getTime(),
                isEpoch: utcDate.getTime() === 0
            });
            if (!isNaN(utcDate.getTime()) && utcDate.getTime() !== 0) {
                row.edit.pnCompletedUTC = utcDate;
                console.log('TimeDurationPicker: end time set to UTC Date', {
                    utcDate: row.edit.pnCompletedUTC
                });
            }
            else {
                row.edit.pnCompletedUTC = null;
                console.log('TimeDurationPicker: end time set to null due to validation failure');
            }
        }
        else {
            row.edit.pnCompletedUTC = null;
            console.log('TimeDurationPicker: end time was null, set to null');
        }
        // Schedule due date also uses datetime-local — ISO strings → ngModel:datefmt
        if (row.edit.pnScheduleDate) {
            var sched = new Date(row.edit.pnScheduleDate);
            row.edit.pnScheduleDate =
                !isNaN(sched.getTime()) && sched.getTime() !== 0 ? sched : null;
        }
        else {
            row.edit.pnScheduleDate = null;
        }
        console.log('TimeDurationPicker: editResultRow complete', {
            editStartTime: row.edit.pnCustomTimeUTC,
            editEndTime: row.edit.pnCompletedUTC,
            editValue: row.edit.pnValue,
            editUnit: row.edit.pnValueUnit
        });
        // Reset manual edit flags since values are loaded from data
        $scope.editingRow = row;
        // Initialize local encryption state (not service-managed)
        row.edit.encryptionState = encryptionService.initializeRowState(row.pnBody);
        row.edit.encryptionKey = '';
        var draftHint = resultRowDraftService.open($scope, row, 'edit', (_h = $scope.person) === null || _h === void 0 ? void 0 : _h.dbPK);
        if (draftHint) {
            setDraftUiMessage(row, draftHint);
        }
        // Force outline textarea to this row's body (never leave previous note's text painted).
        broadcastOutlineBodyFromRow(row, 'edit');
    };
    function setDraftUiMessage(row, message) {
        row.uiMessage = message;
        row._draftFeedbackTone = (0, resultRowDraftService_1.classifyDraftFeedbackTone)(message);
    }
    function clearRowUiMessage(row) {
        row.uiMessage = '';
        row._draftFeedbackTone = undefined;
    }
    $scope.replyToRow = function (row, options) {
        var _a;
        clearRowUiMessage(row);
        // copy all details except the body for the reply update
        row.reply = angular_1.default.copy(row);
        row.reply.pnBody = '';
        row.reply.ReplyAsPeer = options && options.replyAsPeer ? true : false;
        if (row.reply.ReplyAsPeer === false) {
            row.pnTaskGroupDefault = 'Activity';
            row.reply.pnTaskGroup = row.pnTaskGroupDefault;
            row.pnTopicGroupDefault = 'Reply';
            row.reply.pnTopicGroup = row.pnTopicGroupDefault;
            row.pnTopicDetailDefault = null;
            row.reply.pnTopicDetail = row.pnTopicDetailDefault;
        }
        row.reply.pnValue = null; //parseFloat(row.pnValue);
        var draftHint = resultRowDraftService.open($scope, row, 'reply', (_a = $scope.person) === null || _a === void 0 ? void 0 : _a.dbPK);
        if (draftHint) {
            setDraftUiMessage(row, draftHint);
        }
    };
    $scope.cancelResultEdit = function (row) {
        var _a;
        resultRowDraftService.flush(row, 'edit', (_a = $scope.person) === null || _a === void 0 ? void 0 : _a.dbPK);
        resultRowDraftService.close(row, 'edit');
        row.undoEdit = row.edit;
        row.edit = null;
        // Clear editing row
        $scope.editingRow = null;
    };
    $scope.cancelResultReply = function (row) {
        var _a;
        resultRowDraftService.flush(row, 'reply', (_a = $scope.person) === null || _a === void 0 ? void 0 : _a.dbPK);
        resultRowDraftService.close(row, 'reply');
        row.undoReply = row.reply;
        row.reply = null;
    };
    $scope.previewLocalDraft = function (row, mode) {
        var _a;
        setDraftUiMessage(row, resultRowDraftService.preview(row, mode, (_a = $scope.person) === null || _a === void 0 ? void 0 : _a.dbPK));
    };
    function broadcastOutlineBodyFromRow(row, mode) {
        var target = mode === 'reply' ? row === null || row === void 0 ? void 0 : row.reply : row === null || row === void 0 ? void 0 : row.edit;
        var body = target && target.pnBody != null ? String(target.pnBody) : '';
        var rowId = row === null || row === void 0 ? void 0 : row.ID;
        // Sync broadcast first, then again after digest so ngModel cannot lag.
        $rootScope.$broadcast('audOutlineBodyExternal', { body: body, rowId: rowId });
        $timeout(function () {
            $rootScope.$broadcast('audOutlineBodyExternal', { body: body, rowId: rowId });
        }, 0);
    }
    $scope.restoreLocalDraft = function (row, mode) {
        var _a;
        setDraftUiMessage(row, resultRowDraftService.restore(row, mode, (_a = $scope.person) === null || _a === void 0 ? void 0 : _a.dbPK));
        broadcastOutlineBodyFromRow(row, mode);
    };
    $scope.confirmRestoreLocalDraft = function (row, mode) {
        var _a;
        setDraftUiMessage(row, resultRowDraftService.confirmRestore(row, mode, (_a = $scope.person) === null || _a === void 0 ? void 0 : _a.dbPK));
        broadcastOutlineBodyFromRow(row, mode);
    };
    $scope.undoLocalDraftRestore = function (row, mode) {
        var _a;
        setDraftUiMessage(row, resultRowDraftService.undo(row, mode, (_a = $scope.person) === null || _a === void 0 ? void 0 : _a.dbPK));
        broadcastOutlineBodyFromRow(row, mode);
    };
    $scope.clearLocalDraft = function (row, mode) {
        var _a;
        setDraftUiMessage(row, resultRowDraftService.requestClear(row, mode, (_a = $scope.person) === null || _a === void 0 ? void 0 : _a.dbPK));
    };
    $scope.confirmClearLocalDraft = function (row, mode) {
        var _a;
        setDraftUiMessage(row, resultRowDraftService.confirmClear(row, mode, (_a = $scope.person) === null || _a === void 0 ? void 0 : _a.dbPK));
    };
    $scope.showArchivedLocalDrafts = function (row, mode) {
        var _a, _b, _c;
        resultRowDraftService.showArchived(row, mode, (_a = $scope.person) === null || _a === void 0 ? void 0 : _a.dbPK);
        var count = mode === 'edit' ? (_b = row.edit) === null || _b === void 0 ? void 0 : _b._archivedDraftCount : (_c = row.reply) === null || _c === void 0 ? void 0 : _c._archivedDraftCount;
        if (count) {
            clearRowUiMessage(row);
        }
        else {
            setDraftUiMessage(row, 'No archived drafts for this row.');
        }
    };
    $scope.restoreArchivedLocalDraft = function (row, mode, archiveId) {
        var _a;
        setDraftUiMessage(row, resultRowDraftService.restoreArchived(row, mode, (_a = $scope.person) === null || _a === void 0 ? void 0 : _a.dbPK, archiveId));
        broadcastOutlineBodyFromRow(row, mode);
    };
    $scope.discardArchivedLocalDraft = function (row, mode, archiveId) {
        var _a, _b;
        setDraftUiMessage(row, resultRowDraftService.discardArchived(row, (_a = $scope.person) === null || _a === void 0 ? void 0 : _a.dbPK, archiveId));
        resultRowDraftService.showArchived(row, mode, (_b = $scope.person) === null || _b === void 0 ? void 0 : _b.dbPK);
    };
    $scope.getItemCodeInfo = function (id) {
        if (id === undefined) {
            return null;
        }
        var match = null;
        for (var i = 0; i < $scope.Lists.ItemCodes.length; i++) {
            var row = $scope.Lists.ItemCodes[i];
            // console.log('for: checking', row.ID);
            if (row.ID === id) {
                match = row;
                break;
            }
        }
        return match;
    };
    $scope.getItemCodePath = function (id) { var _a, _b; return (_b = (_a = $scope.getItemCodeInfo(id)) === null || _a === void 0 ? void 0 : _a.Path) !== null && _b !== void 0 ? _b : null; };
    $scope.updateResultRow = function (row, keyEvent, clearEdit, callback) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var sourceRow;
            return __generator(this, function (_c) {
                if (clearEdit === undefined) {
                    clearEdit = true;
                }
                if (!$scope.person)
                    return [2 /*return*/];
                sourceRow = row;
                // pass row.edit to the site
                row.uiMessage = 'updating...';
                row.uiError = undefined;
                // prevent submitting a form if enter is pressed
                if (keyEvent !== undefined && keyEvent !== null)
                    keyEvent.preventDefault();
                // check if the reply should be saved
                if (row.reply) {
                    if (row.reply.ReplyAsSchedule ||
                        row.reply.pnTaskGroup != row.pnTaskGroupDefault ||
                        row.reply.pnTopicGroup != row.pnTopicGroupDefault ||
                        row.reply.pnTopicDetail != row.pnTopicDetailDefault) {
                        row.reply.saveReply = true;
                    }
                }
                // Flush this row's outline only (multi-edit: do not touch other open notes).
                $rootScope.$broadcast('audOutlineFlush', { rowId: sourceRow.ID });
                if (sourceRow.edit) {
                    resultRowDraftService.flush(sourceRow, 'edit', (_a = $scope.person) === null || _a === void 0 ? void 0 : _a.dbPK);
                }
                if (sourceRow.reply) {
                    resultRowDraftService.flush(sourceRow, 'reply', (_b = $scope.person) === null || _b === void 0 ? void 0 : _b.dbPK);
                }
                personService
                    .updateResultRow(row)
                    .then(function (response) {
                    var _a, _b, _c, _d, _e;
                    return __awaiter(this, void 0, void 0, function () {
                        var newRow;
                        return __generator(this, function (_f) {
                            // Only clear local drafts after a confirmed server OK.
                            // WAF/network failures must keep active draft history.
                            if (response.data.Result == 'OK') {
                                resultRowDraftService.clearAll(sourceRow, (_a = $scope.person) === null || _a === void 0 ? void 0 : _a.dbPK, 'saved');
                                if (sourceRow.edit) {
                                    resultRowDraftService.acknowledgeServerSave(sourceRow, 'edit', (_b = $scope.person) === null || _b === void 0 ? void 0 : _b.dbPK);
                                }
                                // Check if the updated row was sent back
                                if (response.data.UpdatedRow !== undefined && response.data.UpdatedRow !== null) {
                                    row = response.data.UpdatedRow;
                                }
                                else if (row.edit !== undefined && row.edit !== null) {
                                    newRow = angular_1.default.copy(row.edit);
                                    row.pnAccount = newRow.pnAccount;
                                    row.pnUserRealm = newRow.pnUserRealm;
                                    row.pnShareLevel = newRow.pnShareLevel;
                                    // Convert datetime-local strings back to ISO strings
                                    row.pnCustomTimeUTC = newRow.pnCustomTimeUTC && !isNaN(new Date(newRow.pnCustomTimeUTC).getTime()) ? new Date(newRow.pnCustomTimeUTC).toISOString() : null;
                                    row.pnCompletedUTC = newRow.pnCompletedUTC && !isNaN(new Date(newRow.pnCompletedUTC).getTime()) ? new Date(newRow.pnCompletedUTC).toISOString() : null;
                                    row.pnCompletedPersonPK = newRow.pnCompletedPersonPK;
                                    row.pnBody = newRow.pnBody;
                                    row.pnTaskGroup = newRow.pnTaskGroup;
                                    row.pnTopicGroup = newRow.pnTopicGroup;
                                    row.pnTopicDetail = newRow.pnTopicDetail;
                                    row.pnItemCode = newRow.pnItemCode;
                                    row.ItemCodePath = $scope.getItemCodePath(newRow.pnItemCode);
                                    row.pnInvoiceNote = newRow.pnInvoiceNote;
                                    row.pnValue = newRow.pnValue;
                                    row.pnValueUnit = newRow.pnValueUnit;
                                    row.pnAssetTag = newRow.pnAssetTag;
                                    row.pnAssetTagAux = newRow.pnAssetTagAux;
                                    row.pnAssetAccount = newRow.pnAssetAccount;
                                    row.pnAssetRealm = newRow.pnAssetRealm;
                                    row.pnUserRoamHint = newRow.pnUserRoamHint;
                                    row.pnUserRoamPoint = newRow.pnUserRoamPoint;
                                    row.pnUserRoamGeoLat = newRow.pnUserRoamGeoLat;
                                    row.pnUserRoamGeoLon = newRow.pnUserRoamGeoLon;
                                    row.pnParentFK = newRow.pnParentFK;
                                    row.pnParentAddFK = newRow.pnParentAddFK;
                                    row.pnSchedule = newRow.pnSchedule;
                                    if (clearEdit == true) {
                                        resultRowDraftService.close(sourceRow, 'edit');
                                        row.edit = null;
                                        // Clear editing row
                                        $scope.editingRow = null;
                                    }
                                }
                                if (row.reply !== undefined && row.reply !== null) {
                                    resultRowDraftService.close(sourceRow, 'reply');
                                    if (row.reply.doneCheck && $scope.person) {
                                        // Client-side done stamp so list can hide/filter without re-search
                                        row.pnCompletedPersonPK = $scope.person.dbPK;
                                        if (!row.pnCompletedUTC) {
                                            row.pnCompletedUTC = new Date().toISOString();
                                        }
                                        row._justDoneAt = Date.now();
                                    }
                                    row.reply = null;
                                }
                                row.uiMessage = response.data.Result;
                                row._draftFeedbackTone = undefined;
                            }
                            else if (offlineDataService.shouldUseLocalFallback(response)) {
                                // HTTP 200 + DB_CONNECTION_FAILED etc. — same as transport offline
                                if (sourceRow.edit) {
                                    resultRowDraftService.flush(sourceRow, 'edit', (_c = $scope.person) === null || _c === void 0 ? void 0 : _c.dbPK);
                                }
                                if (sourceRow.reply) {
                                    resultRowDraftService.flush(sourceRow, 'reply', (_d = $scope.person) === null || _d === void 0 ? void 0 : _d.dbPK);
                                }
                                offlineDataService.enqueueSync({
                                    personId: (_e = $scope.person) === null || _e === void 0 ? void 0 : _e.dbPK,
                                    kind: 'updateRow',
                                    payload: {
                                        edit: sourceRow.edit,
                                        reply: sourceRow.reply,
                                        rowArray: sourceRow.rowArray,
                                    },
                                    baseRowUpdatedAt: pilotNotesSyncService.extractBaseRowUpdatedAt(row),
                                });
                                $scope.viewMode.serverUnreachable = true;
                                row.uiMessage = undefined;
                                row.uiError = 'Offline — save queued and will sync when back online.';
                                row._draftFeedbackTone = 'warning';
                            }
                            else {
                                row.uiMessage = undefined;
                                row._draftFeedbackTone = undefined;
                                row.uiError = response.data.Message;
                            }
                            return [2 /*return*/];
                        });
                    });
                }, function (response) {
                    var _a, _b, _c, _d, _e, _f;
                    // http error — never clear local drafts here
                    row.uiMessage = undefined;
                    row.uiError =
                        typeof response.data === 'string'
                            ? undefined
                            : (_a = response.data) === null || _a === void 0 ? void 0 : _a.Message;
                    // Re-persist form so a blocked save cannot leave storage empty
                    if (sourceRow.edit) {
                        resultRowDraftService.flush(sourceRow, 'edit', (_b = $scope.person) === null || _b === void 0 ? void 0 : _b.dbPK);
                    }
                    if (sourceRow.reply) {
                        resultRowDraftService.flush(sourceRow, 'reply', (_c = $scope.person) === null || _c === void 0 ? void 0 : _c.dbPK);
                    }
                    if ((0, authInterceptor_1.isWafHttpResponse)(response)) {
                        // Refresh draft toolbar indicators without forcing full diff open
                        if (sourceRow.edit) {
                            resultRowDraftService.flush(sourceRow, 'edit', (_d = $scope.person) === null || _d === void 0 ? void 0 : _d.dbPK);
                        }
                        if (sourceRow.reply) {
                            resultRowDraftService.flush(sourceRow, 'reply', (_e = $scope.person) === null || _e === void 0 ? void 0 : _e.dbPK);
                        }
                        row.uiError =
                            'Security filter blocked this save. Local draft kept — use restore or changes when ready.';
                        row._draftFeedbackTone = 'warning';
                    }
                    else if (offlineDataService.shouldUseLocalFallback(response)) {
                        offlineDataService.enqueueSync({
                            personId: (_f = $scope.person) === null || _f === void 0 ? void 0 : _f.dbPK,
                            kind: 'updateRow',
                            payload: {
                                edit: sourceRow.edit,
                                reply: sourceRow.reply,
                                rowArray: sourceRow.rowArray,
                            },
                            baseRowUpdatedAt: pilotNotesSyncService.extractBaseRowUpdatedAt(row),
                        });
                        row.uiError = 'Offline — save queued and will sync when back online.';
                    }
                })
                    .catch(function (err) {
                    var _a, _b;
                    // FieldAllowlistError / other sync failure before HTTP
                    console.error('updateResultRow failed', err);
                    if (sourceRow.edit) {
                        resultRowDraftService.flush(sourceRow, 'edit', (_a = $scope.person) === null || _a === void 0 ? void 0 : _a.dbPK);
                    }
                    if (sourceRow.reply) {
                        resultRowDraftService.flush(sourceRow, 'reply', (_b = $scope.person) === null || _b === void 0 ? void 0 : _b.dbPK);
                    }
                    row.uiMessage = undefined;
                    var allowlistMsg = err && err.name === 'FieldAllowlistError' && err.message
                        ? String(err.message)
                        : err instanceof Error && err.message
                            ? err.message
                            : null;
                    row.uiError =
                        allowlistMsg || 'Save failed before request completed. Local draft kept.';
                    if (err && err.name === 'FieldAllowlistError') {
                        // personService already broadcasts ui:toast; keep row.uiError as detail
                        row._draftFeedbackTone = 'warning';
                    }
                })
                    .then(function () {
                    if (callback) {
                        callback();
                    }
                });
                return [2 /*return*/];
            });
        });
    };
    $scope.hideImage = function (row) {
        row.deleteMessage = '...';
        personService.hideImage(row.ID, null).then(function (response) {
            if (response.data.Result == 'OK') {
                row.deleteMessage = 'Saved.';
            }
        }, function () {
            row.deleteMessage = 'ERROR';
        });
    };
    $scope.hideNote = function (row, callback) {
        row.deleteMessage = '...';
        personService
            .hideNote(row.ID)
            .then(function (response) {
            if (response.data.Result == 'OK') {
                row.deleteMessage = 'Saved.';
            }
        }, function () {
            row.deleteMessage = 'ERROR';
        })
            .then(function () {
            if (callback) {
                callback();
            }
        });
    };
    function hasJwtToken() {
        var ls = window.localStorage;
        return !!(ls && ls.getItem('jwt_token'));
    }
    $scope.loadInitialSearch = function () {
        var searchParams = searchService.loadInitialSearch($scope.viewMode);
        if (searchParams) {
            if ($scope.viewMode.zenMode) {
                $scope.viewMode.zenLoading = true;
                $scope.viewMode.zenError = null;
            }
            return $scope.personSearch(searchParams);
        }
        return $q.resolve();
    };
    /**
     * Target note id from URL/view mode (/view/pnid/N, /zen/pnid/N, or search args).
     * pnid search also returns children (pnParentFK = N) — never pick those by accident.
     */
    function resolveRequestedPnid() {
        var vm = $scope.viewMode;
        var candidates = [
            vm && vm.zenPnid,
            vm && vm.initialSearchOnlyPNID,
            $scope.reportSearch && $scope.reportSearch.pnid,
        ];
        for (var _i = 0, candidates_1 = candidates; _i < candidates_1.length; _i++) {
            var c = candidates_1[_i];
            if (c == null || c === '')
                continue;
            var n = Number(c);
            if (!isNaN(n) && n > 0)
                return n;
        }
        return null;
    }
    /** Exact row for requested pnid only — no fallback to children/siblings in the result set. */
    function findReportRowForRequestedPnid() {
        var rows = $scope.reportResult || [];
        if (!rows.length)
            return null;
        var pnid = resolveRequestedPnid();
        if (pnid != null) {
            return rows.find(function (r) { return Number(r.ID) === pnid; }) || null;
        }
        // No explicit pnid (unusual for present/zen) — only safe when a single row.
        return rows.length === 1 ? rows[0] : null;
    }
    /**
     * Keep only the requested note in reportResult so present/zen never open a child
     * that came back from `ID = pnid OR pnParentFK = pnid` search.
     */
    function pinReportResultToRow(row) {
        if (!row || row.ID == null)
            return;
        var id = Number(row.ID);
        $scope.reportResult = ($scope.reportResult || []).filter(function (r) { return Number(r.ID) === id; });
    }
    function enterZenFromReportResult() {
        var vm = $scope.viewMode;
        vm.zenLoading = false;
        var pnid = resolveRequestedPnid();
        var row = findReportRowForRequestedPnid();
        if (!row) {
            vm.zenError = 'No note found for pnid ' + (pnid || vm.zenPnid || '?');
            vm.zenRow = null;
            $window.document.title = 'Zen · not found - audroam';
            return;
        }
        pinReportResultToRow(row);
        vm.zenError = null;
        vm.zenRow = row;
        if (!row.edit) {
            $scope.editResultRow(row);
        }
        // Tall map for presentation; outline opens map + present when possible
        if (row.edit && (!row.edit.bodyRows || row.edit.bodyRows < 30)) {
            row.edit.bodyRows = 30;
        }
        $window.document.title = 'Zen · ' + (row.ID || pnid || vm.zenPnid) + ' - audroam';
        $timeout(function () {
            $rootScope.$broadcast('audOutlineZenEnter');
        }, 50);
    }
    /** /view/pnid/N?present=1 — open edit + map presentation on the requested note only. */
    function enterPresentFromReportResult() {
        var row = findReportRowForRequestedPnid();
        if (!row) {
            return;
        }
        // Drop children/siblings from the list so only the passed ID is presented.
        pinReportResultToRow(row);
        if (!row.edit) {
            $scope.editResultRow(row);
        }
        if (row.edit && (!row.edit.bodyRows || row.edit.bodyRows < 20)) {
            row.edit.bodyRows = 30;
        }
        $timeout(function () {
            $rootScope.$broadcast('audOutlineZenEnter');
        }, 80);
    }
    if ($scope.viewMode.initialSearchOnly) {
        $timeout(function () {
            $scope.loadInitialSearch().catch(function (error) {
                if ($scope.viewMode.zenMode) {
                    $scope.viewMode.zenLoading = false;
                    $scope.viewMode.zenError = 'Failed to load note.';
                }
            });
        }, 300);
        // prevent any other initial loads / Focus / schedule board chrome
        $scope.viewMode.hideBlocks = true;
        $scope.viewMode.showCurrentPanel = false;
        $scope.viewMode.showTimewritingStyle = 1;
        $scope.viewMode.recentFetchEnabled = false;
        $scope.viewMode.fetchEnabled = false;
        // Drop any cached Recent paint so the panel cannot appear after Start
        try {
            $scope.recentRows = null;
        }
        catch (_h) {
            /* ignore */
        }
        // Classify page mode for view vs search when not already set (e.g. ?searchText=)
        if (!$scope.viewMode.pageMode || $scope.viewMode.pageMode === 'board') {
            var onlyPnid = $scope.viewMode.initialSearchOnlyPNID;
            $scope.viewMode.pageMode = onlyPnid ? 'view' : 'search';
        }
        $scope.viewMode.timeTrackingActive = false;
    }
    else if ($scope.viewMode.initialSearch) {
        $timeout(function () {
            $scope.loadInitialSearch().catch(function (error) {
            });
        }, 300);
    }
    $scope.doLogin = function (args) {
        $scope.loginMessage = '...';
        $timeout(function () {
            $scope.loginMessage = null;
        }, 3000);
        personService.login(args).then(function (response) {
            // Store the access token in localStorage if provided
            if (response.data && response.data.accessToken) {
                var ls = window.localStorage;
                if (ls) {
                    ls.setItem('jwt_token', response.data.accessToken);
                }
            }
            // Set a flag to prevent duplicate fetchPerson from token-refresh path
            $scope.isLoggingIn = true;
            var prevPk = personPkOf($scope.person);
            var afterPerson = function () {
                emitUserChanged('login', prevPk);
                // Cold start without JWT skipped Focus/Recent; load them now
                afterUserSessionReady('login');
                if ($scope.viewMode.initialSearchOnly || $scope.viewMode.initialSearch) {
                    try {
                        $scope.loadInitialSearch();
                    }
                    catch (_a) {
                        /* ignore */
                    }
                }
                try {
                    historyService.startSync();
                }
                catch (_b) {
                    /* ignore */
                }
                $timeout(function () {
                    $scope.isLoggingIn = false;
                }, 500);
            };
            var p = $scope.fetchPerson();
            if (p && typeof p.then === 'function') {
                p.then(afterPerson).catch(afterPerson);
            }
            else {
                afterPerson();
            }
        });
    };
    // --- My account panel (tabbed: profile / notifications / drafts / activity / sessions) ---
    $scope.accountSessions = [];
    $scope.accountSessionsMeta = null;
    $scope.accountSessionsError = null;
    $scope.accountSessionsLoading = false;
    $scope.accountSessionsLimit = 8;
    /** Client-only: notes with local draft / working / typing / archive data */
    $scope.localDraftInventory = [];
    $scope.localDraftPreview = null;
    /** Inner tab: profile | notifications | drafts | activity | sessions | threads */
    $scope.myAccountTab = 'profile';
    $scope.setMyAccountTab = function (tab) {
        var next = (tab || 'profile').toLowerCase();
        var allowed = ['profile', 'notifications', 'drafts', 'activity', 'sessions', 'threads'];
        $scope.myAccountTab = allowed.indexOf(next) >= 0 ? next : 'profile';
        // Lazy-load tab data so opening the panel stays light
        if ($scope.myAccountTab === 'notifications') {
            try {
                $scope.refreshPushStatus();
                $scope.loadPushPrefs();
                $scope.loadPushInbox();
            }
            catch (_a) {
                /* ignore */
            }
        }
        else if ($scope.myAccountTab === 'drafts') {
            $scope.refreshLocalDraftInventory();
        }
        else if ($scope.myAccountTab === 'sessions') {
            $scope.accountSessionsLimit = 8;
            $scope.loadAccountSessions();
        }
        else if ($scope.myAccountTab === 'threads') {
            try {
                if (typeof $scope.refreshThreadsFromServer === 'function') {
                    $scope.refreshThreadsFromServer({ quiet: true });
                }
            }
            catch (_b) {
                /* ignore */
            }
        }
    };
    $scope.openMyAccount = function (tab) {
        $scope.viewMode.showMyAccount = !$scope.viewMode.showMyAccount;
        if ($scope.viewMode.showMyAccount) {
            $scope.setMyAccountTab(tab || $scope.myAccountTab || 'profile');
            // Badge counts even when not on those tabs
            try {
                $scope.refreshLocalDraftInventory();
            }
            catch (_a) {
                /* ignore */
            }
            // Scroll panel into view when opened from footer
            $timeout(function () {
                var el = document.querySelector('.my-account-panel');
                if (el && typeof el.scrollIntoView === 'function') {
                    el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                }
            }, 50);
        }
    };
    // Deep link from push: /?push=inbox | account | schedule → open My Account + notifications tab
    $timeout(function () {
        try {
            var params = new URLSearchParams($window.location.search || '');
            var push = (params.get('push') || '').toLowerCase();
            if (push === 'inbox' || push === 'account' || push === 'schedule' || push === 'notifications') {
                if (!$scope.viewMode.showMyAccount) {
                    $scope.viewMode.showMyAccount = true;
                }
                $scope.setMyAccountTab('notifications');
                $timeout(function () {
                    var el = document.querySelector('.push-inbox-panel') ||
                        document.querySelector('.my-account-panel');
                    if (el && typeof el.scrollIntoView === 'function') {
                        el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                    }
                }, 100);
            }
        }
        catch (_a) {
            /* ignore */
        }
    }, 300);
    $scope.refreshLocalDraftInventory = function () {
        var _a;
        try {
            $scope.localDraftInventory = resultRowDraftService.listLocalInventory((_a = $scope.person) === null || _a === void 0 ? void 0 : _a.dbPK);
        }
        catch (_b) {
            $scope.localDraftInventory = [];
        }
    };
    /** Open note in UI and prompt to restore local working copy / draft. */
    $scope.openLocalDraftItem = function (item, openNewTab) {
        if (!item || item.rowId == null)
            return;
        var id = Number(item.rowId);
        if (!id)
            return;
        $scope.localDraftPreview = null;
        $scope.viewMode.showMyAccount = false;
        if (openNewTab) {
            try {
                $window.open('/view/pnid/' + id, '_blank');
            }
            catch (_a) {
                /* ignore */
            }
            return;
        }
        $scope.personSearch({ pnid: id });
        // After search binds, open edit so Restore can apply working stream.
        $timeout(function () {
            try {
                var rows = $scope.reportResult || [];
                var row_1 = rows.find(function (r) { return Number(r.ID) === id; }) ||
                    (rows.length === 1 ? rows[0] : null);
                if (row_1 && typeof $scope.editResultRow === 'function') {
                    $scope.editResultRow(row_1);
                    $timeout(function () {
                        var _a;
                        try {
                            var mode = item.mode === 'reply' ? 'reply' : 'edit';
                            setDraftUiMessage(row_1, resultRowDraftService.restore(row_1, mode, (_a = $scope.person) === null || _a === void 0 ? void 0 : _a.dbPK));
                            broadcastOutlineBodyFromRow(row_1, mode);
                        }
                        catch (_b) {
                            /* ignore restore errors */
                        }
                    }, 200);
                }
                else if (typeof $scope.toast === 'function') {
                    $scope.toast('Opened search for #' + id + ' — open Edit then Restore if needed.', 'info', 4000);
                }
            }
            catch (_a) {
                /* ignore */
            }
        }, 600);
    };
    $scope.previewLocalDraftItem = function (item) {
        $scope.localDraftPreview =
            $scope.localDraftPreview &&
                $scope.localDraftPreview.rowId === item.rowId &&
                $scope.localDraftPreview.mode === item.mode
                ? null
                : item;
    };
    $scope.loadAccountSessions = function () {
        $scope.accountSessionsLoading = true;
        $scope.accountSessionsError = null;
        var token = null;
        try {
            token = $window.localStorage.getItem('jwt_token');
        }
        catch (_a) {
            token = null;
        }
        if (!token) {
            $scope.accountSessionsLoading = false;
            $scope.accountSessionsError = 'No access token in localStorage — log in again if this persists.';
            $scope.accountSessions = [];
            $scope.accountSessionsMeta = null;
            return;
        }
        $http
            .get('/api/v2/sessions', {
            headers: { Authorization: 'Bearer ' + token },
        })
            .then(function (response) {
            var sessions = (response.data && response.data.sessions) || [];
            $scope.accountSessions = sessions;
            var sessionCount = sessions.filter(function (s) { return (s.kind || 'session') === 'session' && s.active; }).length;
            var integrationCount = sessions.filter(function (s) { return s.kind === 'integration' && s.active; }).length;
            $scope.accountSessionsMeta = {
                sessionCount: sessionCount,
                integrationCount: integrationCount,
                total: sessions.length,
            };
        })
            .catch(function (error) {
            var status = error && error.status;
            if (status === 401) {
                $scope.accountSessionsError = 'Session list requires a valid access token (try refreshing the page).';
            }
            else if (status === 503) {
                $scope.accountSessionsError = 'Sessions API database unavailable.';
            }
            else {
                $scope.accountSessionsError =
                    (error && error.data && error.data.error) ||
                        'Could not load sessions. Is the Python API running?';
            }
            $scope.accountSessions = [];
            $scope.accountSessionsMeta = null;
        })
            .finally(function () {
            $scope.accountSessionsLoading = false;
        });
    };
    $scope.revokeAccountSession = function (session) {
        if (!session || !session.tokenId) {
            return;
        }
        if (!confirm('Revoke this credential? That device or integration will need a new login/key.')) {
            return;
        }
        var token = null;
        try {
            token = $window.localStorage.getItem('jwt_token');
        }
        catch (_a) {
            token = null;
        }
        if (!token) {
            $scope.accountSessionsError = 'Not authenticated.';
            return;
        }
        session._revoking = true;
        $http
            .delete('/api/v2/sessions/' + encodeURIComponent(session.tokenId), {
            headers: { Authorization: 'Bearer ' + token },
        })
            .then(function () { return $scope.loadAccountSessions(); })
            .catch(function (error) {
            session._revoking = false;
            $scope.accountSessionsError =
                (error && error.data && error.data.error) || 'Failed to revoke session.';
        });
    };
    /** Switch realm from My Account, then collapse the panel so results stay visible. */
    $scope.setCurrentRealmFromAccount = function (realm) {
        if (!realm) {
            return;
        }
        var p = $scope.setCurrentRealm(realm);
        if (p && typeof p.then === 'function') {
            p.then(function () {
                $scope.viewMode.showMyAccount = false;
            });
        }
        else {
            $scope.viewMode.showMyAccount = false;
        }
    };
    $scope.runAccountSearch = function (entry) {
        $scope.selectSearchHistory(entry);
        $scope.viewMode.showMyAccount = false;
    };
    $scope.runAccountScan = function (entry) {
        $scope.selectScanHistory(entry);
        $scope.viewMode.showMyAccount = false;
    };
    /** Build /s/{...} link payload for a history search entry. */
    $scope.accountSearchLink = function (entry) {
        if (!entry || !entry.data) {
            return {};
        }
        if (entry.data.params && typeof entry.data.params === 'object') {
            return entry.data.params;
        }
        var link = {};
        if (entry.data.text) {
            link.s = entry.data.text;
        }
        if (entry.data.realm) {
            link.realm = entry.data.realm;
        }
        return link;
    };
    $scope.accountScanLink = function (entry) {
        if (!entry || !entry.data) {
            return {};
        }
        if (entry.data.params && typeof entry.data.params === 'object') {
            return entry.data.params;
        }
        var link = { tag: entry.data.tag };
        if (entry.data.realm) {
            link.realm = entry.data.realm;
        }
        return link;
    };
    $scope.updatePassword = function (args) {
        if (!args.newPassword || args.newPassword !== args.confirmPassword) {
            $scope.login.passwordUpdateMessage = 'Passwords do not match';
            $scope.login.passwordUpdateSuccess = false;
            return;
        }
        if (!args.currentPassword) {
            $scope.login.passwordUpdateMessage = 'Current password is required';
            $scope.login.passwordUpdateSuccess = false;
            return;
        }
        $scope.login.passwordUpdateMessage = 'Updating password...';
        // First verify current password by attempting login
        var verifyArgs = {
            loginName: $scope.person.loginName,
            loginPassword: args.currentPassword
        };
        personService.login(verifyArgs).then(function (response) {
            // Current password is correct, now update to new password
            var updateArgs = {
                loginName: $scope.person.loginName,
                setPassword: args.newPassword,
                updatePassword: true
            };
            return personService.login(updateArgs);
        }).then(function (response) {
            $scope.login.passwordUpdateMessage = 'Password updated successfully!';
            $scope.login.passwordUpdateSuccess = true;
            // Clear the form
            $scope.login.currentPassword = null;
            $scope.login.newPassword = null;
            $scope.login.confirmPassword = null;
            // Hide the form after a delay
            $timeout(function () {
                $scope.viewMode.showPasswordUpdate = false;
                $scope.login.passwordUpdateMessage = null;
            }, 3000);
        }).catch(function (error) {
            $scope.login.passwordUpdateMessage = 'Password update failed. Please check your current password.';
            $scope.login.passwordUpdateSuccess = false;
        });
    };
    // Local-first board: paint IndexedDB cache immediately, then background refresh.
    // Do not gate on navigator.onLine (partial DNS / black-hole still report "online").
    // Capture / Focus create remains online-only on pilot — see docs/product/next-product-journal-timestream.md
    if ($scope.viewMode.recentFetchEnabled) {
        $timeout(function () {
            hydrateOfflineFirst().then(function () {
                $scope.fetchRecent();
                replayOfflineSyncQueue();
            });
        }, 0);
    }
    else if ($scope.viewMode.fetchPersonEnabled) {
        $timeout(function () {
            hydrateOfflineFirst().then(function () {
                $scope.fetchPerson();
                replayOfflineSyncQueue();
            });
        }, 0);
    }
    else {
        $timeout(function () {
            hydrateOfflineFirst();
        }, 0);
    }
    // Ensure one-shot fetch if recentFetchEnabled is toggled on later
    $scope.$watch(function () { return $scope.viewMode && $scope.viewMode.recentFetchEnabled; }, function (newVal, oldVal) {
        if (newVal && !oldVal) {
            $timeout(function () { return $scope.fetchRecent(); }, 100);
        }
        else if (!newVal && oldVal) {
            if (recentFetchTimerID) {
                $timeout.cancel(recentFetchTimerID);
                recentFetchTimerID = undefined;
            }
        }
    });
    // Schedule: never auto-fetch. Show last cache if any; server only on refresh / after mutations.
    $scope.$watch(function () { return ($scope.person && $scope.person.dbPK != null ? $scope.person.dbPK : undefined); }, function (newId, oldId) {
        if (newId != null && newId !== oldId) {
            hydrateScheduleFromCache(newId);
        }
    });
    if (((_b = $scope.person) === null || _b === void 0 ? void 0 : _b.dbPK) != null) {
        hydrateScheduleFromCache($scope.person.dbPK);
    }
    if ($scope.viewMode.initListFetchEnabled) {
        $timeout($scope.fetchLists, 150);
    }
    // Auto-load Daily Tally when the panel is opened the first time
    try {
        var tallyLoadedOnce_1 = false;
        $scope.$watch(function () { return $scope.nav && $scope.nav.tally && $scope.nav.tally.collapsed; }, function (newVal, oldVal) {
            var _a;
            if (newVal === false && tallyLoadedOnce_1 === false) {
                tallyLoadedOnce_1 = true;
                try {
                    // restore persisted defaults
                    var ls = window.localStorage;
                    if (ls && ls.getItem('audroam.tally.mode')) {
                        $scope.viewMode.tallyMode = ls.getItem('audroam.tally.mode');
                    }
                    // If no recent tally activity, prefer today's date over stored value
                    var stored = ls ? ls.getItem('audroam.tally.date') : null;
                    var todayStr = new Date().toISOString().slice(0, 10);
                    if (stored && /^\d{4}-\d{2}-\d{2}$/.test(stored) && stored === todayStr) {
                        $scope.viewMode.tallyDate = new Date(stored + 'T00:00:00');
                    }
                    else {
                        $scope.viewMode.tallyDate = new Date();
                    }
                    if (ls && ls.getItem('audroam.tally.mineOnly')) {
                        $scope.viewMode.tallyMineOnly = ls.getItem('audroam.tally.mineOnly') === '1';
                    }
                    else {
                        $scope.viewMode.tallyMineOnly = (_a = $scope.viewMode.tallyMineOnly) !== null && _a !== void 0 ? _a : true;
                    }
                    if (ls && ls.getItem('audroam.tally.openWithinHours')) {
                        var ohStr = ls.getItem('audroam.tally.openWithinHours');
                        var oh = ohStr ? parseInt(ohStr, 10) : NaN;
                        if (!isNaN(oh)) {
                            $scope.viewMode.tallyOpenHrs = oh;
                        }
                    }
                    else {
                        $scope.viewMode.tallyOpenHrs = $scope.viewMode.tallyOpenHrs || 24;
                    }
                    // Always load today's tally (local) and details on first open
                    var dateStr = todayStr;
                    $scope.fetchTally(dateStr);
                    // Fetch details and render timeline for today
                    try {
                        $scope.fetchDailyDetails(dateStr);
                    }
                    catch (_b) { }
                    $scope.viewMode.showTimeline = true;
                }
                catch (_c) { }
            }
        });
    }
    catch (_j) { }
    // Cleanup timers on scope destroy
    $scope.$on('$destroy', function () {
        if (recentFetchTimerID)
            $timeout.cancel(recentFetchTimerID);
    });
    // collapse the map
    if ($scope.nav && $scope.nav.map.initCollapsed) {
        $timeout(function () {
            $scope.nav.map.collapsed = true;
        }, 1000);
    }
    else if ($scope.nav) {
        $timeout(function () {
            $scope.nav.map.collapsed = true;
        }, 2000);
    }
    $scope.exportActions = function (group, list) {
        var output = [];
        angular_1.default.forEach(list, function (obj, index) {
            output.push({ group: group, detail: obj });
        });
        return output;
    };
    // Helper function to process URI body text (separates URL from caption)
    // Caches result on row object to prevent infinite digest cycles
    $scope.processUriBody = function (row) {
        // Return cached result if available and body hasn't changed
        if (row._processedUriBody !== undefined && row._lastProcessedBody === row.pnBody) {
            return row._processedUriBody;
        }
        var body = row.pnBody;
        if (!body || typeof body !== 'string') {
            row._processedUriBody = null;
            row._lastProcessedBody = body;
            return null;
        }
        var lines = body.split('\n');
        if (lines.length > 1) {
            row._processedUriBody = {
                url: lines[0].trim(),
                caption: lines.slice(1).join('\n').trim()
            };
        }
        else {
            row._processedUriBody = null; // No newline, treat as plain text
        }
        row._lastProcessedBody = body;
        return row._processedUriBody;
    };
    $scope.onDurationChange = function () {
        // Recalculate end time when duration changes
        var row = $scope.editingRow;
        if (row && row.edit && row.edit.pnCustomTimeUTC && row.edit.pnValue !== null && row.edit.pnValue !== undefined) {
            var startTimeStr = timeCalculationService.normalizeTime(row.edit.pnCustomTimeUTC);
            if (startTimeStr) {
                var endTimeStr = timeCalculationService.calculateEndTime(startTimeStr, row.edit.pnValue);
                if (endTimeStr) {
                    // Parse endTimeStr back to Date object
                    var _a = endTimeStr.split('T'), datePart = _a[0], timePart = _a[1];
                    var _b = timePart.split(':').map(Number), hours = _b[0], minutes = _b[1];
                    var endTimeDate = new Date(row.edit.pnCustomTimeUTC); // Start with same date
                    endTimeDate.setHours(hours, minutes, 0, 0);
                    row.edit.pnCompletedUTC = endTimeDate;
                }
            }
        }
    };
    $scope.onEndTimeChange = function () {
        // Recalculate duration when end time changes
        var row = $scope.editingRow;
        if (row && row.edit && row.edit.pnCustomTimeUTC && row.edit.pnCompletedUTC) {
            var startTimeStr = timeCalculationService.normalizeTime(row.edit.pnCustomTimeUTC);
            var endTimeStr = timeCalculationService.normalizeTime(row.edit.pnCompletedUTC);
            if (startTimeStr && endTimeStr) {
                var duration = timeCalculationService.calculateDuration(startTimeStr, endTimeStr);
                // Only update duration if end time is after start time (positive duration)
                if (duration !== null && duration >= 0) {
                    row.edit.pnValue = duration;
                }
                // If duration is negative (end before start), don't update pnValue
            }
        }
        // Set completed person if blank
        if (row && row.edit && row.edit.pnCompletedUTC && !row.edit.pnCompletedPersonPK && $scope.person && $scope.person.dbPK) {
            row.edit.pnCompletedPersonPK = $scope.person.dbPK;
        }
    };
    $scope.addDuration = function (minutes) {
        var row = $scope.editingRow;
        if (row && row.edit) {
            var current = row.edit.pnValue || 0;
            row.edit.pnValue = timeCalculationService.addMinutesToDuration(current, minutes);
            $scope.onDurationChange();
        }
    };
    $scope.setDuration = function (minutes) {
        var row = $scope.editingRow;
        if (row && row.edit) {
            row.edit.pnValue = timeCalculationService.durationFromMinutes(minutes);
            $scope.onDurationChange();
        }
    };
    $scope.exportAllActions = function () {
        var output = [];
        Array.prototype.push.apply(output, $scope.exportActions('default-1', $scope.defaultActions1));
        Array.prototype.push.apply(output, $scope.exportActions('default-1', $scope.defaultActions2));
        Array.prototype.push.apply(output, $scope.exportActions('default-1', $scope.reuseActions));
        Array.prototype.push.apply(output, $scope.exportActions('default-1', $scope.bikeshareActions));
        return output;
    };
    // Logout function: clear localStorage JWT and call server logout
    $scope.logout = function () {
        // Stop history sync before logout
        historyService.stopSync();
        var prevPk = personPkOf($scope.person);
        try {
            // Clear JWT token from localStorage
            localStorage.removeItem('jwt_token');
            console.log('JWT token cleared from localStorage');
        }
        catch (error) {
            console.error('Failed to clear JWT token:', error);
        }
        $scope.person = null;
        $scope.openMeta = null;
        $scope.sessionMeta = null;
        $scope.idleMeta = null;
        emitUserChanged('logout', prevPk);
        emitFocusContextChanged('logout');
        // Call server logout API
        $http({
            method: 'POST',
            url: config.basePath + 'api/api.php',
            data: { action: 'logout' },
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            var _a;
            console.log('Server logout successful:', response.data);
            // Redirect to the URL provided by server or default
            var redirectUrl = ((_a = response.data) === null || _a === void 0 ? void 0 : _a.redirectUrl) || '/';
            window.location.href = redirectUrl;
        }, function (error) {
            console.error('Server logout failed:', error);
            // Even if server logout fails, redirect to home
            window.location.href = '/';
        });
    };
    // Encryption functions
    $scope.generateEncryptionKey = function (row) {
        return __awaiter(this, void 0, void 0, function () {
            var fullPassphrase, key, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        fullPassphrase = (row.edit.passphraseBase || '') + (row.edit.passphraseSuffix || '');
                        return [4 /*yield*/, encryptionService.generateKey(fullPassphrase || undefined)];
                    case 1:
                        key = _a.sent();
                        row.edit.encryptionKey = key; // Show the key to the user
                        row.uiMessage = fullPassphrase ? 'Key generated from passphrase' : 'New random key generated';
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        console.error('Failed to generate key:', error_1);
                        row.uiError = 'Failed to generate encryption key';
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    $scope.generatePassphraseSuffix = function (row) {
        var symbols = ['.', '-', '+', '_', '*', '@', '#', '$', '%', '&'];
        var chunks = ['sup', 'kip', 'zap', 'bee', 'sea', 'see', 'eye', 'aye', 'oar', 'ore', 'cat', 'cut', 'kit', 'ket', 'bat', 'bet', 'dog', 'dug', 'fog', 'fug', 'jam', 'gem', 'ham', 'hem', 'lap', 'lip', 'map', 'mop', 'nap', 'nip', 'pat', 'pet', 'rat', 'ret', 'sat', 'set', 'tap', 'tip', 'vat', 'vet', 'wax', 'wex', 'yak', 'yuk', 'zip', 'box', 'fox', 'mix', 'pix', 'vex'];
        var symbol = symbols[Math.floor(Math.random() * symbols.length)];
        var chunk = chunks[Math.floor(Math.random() * chunks.length)];
        row.edit.passphraseSuffix = symbol + chunk;
    };
    /**
     * Outline + crypto share one body authority rule:
     * flush live textarea → transform → applyBodyExternal (model + textarea + map).
     */
    function flushOutlineBodies(row) {
        var _a, _b;
        try {
            var rowId = (_a = row === null || row === void 0 ? void 0 : row.ID) !== null && _a !== void 0 ? _a : (_b = row === null || row === void 0 ? void 0 : row.edit) === null || _b === void 0 ? void 0 : _b.ID;
            if (rowId != null && rowId !== '') {
                $rootScope.$broadcast('audOutlineFlush', { rowId: rowId });
            }
            else {
                $rootScope.$broadcast('audOutlineFlush');
            }
        }
        catch (_c) {
            /* ignore */
        }
    }
    function applyEditBodyExternal(row, body) {
        var _a, _b;
        var next = body == null ? '' : String(body);
        if (row && row.edit) {
            row.edit.pnBody = next;
        }
        var rowId = (_a = row === null || row === void 0 ? void 0 : row.ID) !== null && _a !== void 0 ? _a : (_b = row === null || row === void 0 ? void 0 : row.edit) === null || _b === void 0 ? void 0 : _b.ID;
        try {
            $rootScope.$broadcast('audOutlineBodyExternal', {
                body: next,
                rowId: rowId,
            });
        }
        catch (_c) {
            /* ignore */
        }
        try {
            if (rowId != null && rowId !== '') {
                $rootScope.$broadcast('audDraftPersistHint', { rowId: rowId });
            }
            else {
                $rootScope.$broadcast('audDraftPersistHint');
            }
        }
        catch (_d) {
            /* ignore */
        }
    }
    var cryptoBodyHost = (0, editBodyCryptoActions_1.createCryptoBodyHost)(encryptionService, function (row) { return flushOutlineBodies(row); }, applyEditBodyExternal);
    $scope.compressRowContent = function (row) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (0, editBodyCryptoActions_1.compressRowContent)(cryptoBodyHost, row)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    $scope.encryptRowContent = function (row) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (0, editBodyCryptoActions_1.encryptRowContent)(cryptoBodyHost, row)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    $scope.decryptRowContent = function (row) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (0, editBodyCryptoActions_1.decryptRowContent)(cryptoBodyHost, row)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    $scope.tryAutoDecode = function (row) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (0, editBodyCryptoActions_1.tryAutoDecode)(cryptoBodyHost, row)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    // Get display text for row - always show actual pnBody data
    $scope.getRowDisplayText = function (row) {
        return row.pnBody;
    };
    // Recent / compact: caption or s1 preamble (not encoded blob).
    $scope.rowDisplayCaption = function (row) {
        return (0, outlineDisplayCaption_1.rowPreviewCaption)(row);
    };
}
exports.AudRoamCtrl = AudRoamCtrl;
